var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _g3, _path13, _g4, _path14, _path15, _g5, _path16, _g6, _path17, _g7, _path18, _g8, _path19, _g9, _path20, _g10, _path21, _g11, _path22, _g12, _path23, _path24, _path25, _g13, _path26, _g14, _path27, _path28, _path29, _path30, _path31, _g15, _path32, _g16, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g17, _path43, _g18, _path44, _path45, _path46, _path47, _path48, _g19, _path49, _g20, _path50, _g21, _path51, _path52, _path53, _path54, _path55, _path56, _g22, _path57, _g23, _path58, _g24, _path59, _g25, _path60, _g26, _path61, _g27, _path62, _g28, _path63, _g29, _path64, _g30, _path65, _path66, _path67, _path68, _path69, _g31, _path70, _g32, _path71, _g33, _path72, _g34, _path73, _g35, _path74, _g36, _path75, _g37, _path76, _g38, _path77, _g39, _path78, _path79, _g40, _path80, _g41, _path81, _g42, _path82, _g43, _path83, _path84, _path85, _path86, _g44, _path87, _path88, _path89, _path90, _path91, _g45, _path92, _g46, _path93, _g47, _path94, _g48, _path95, _path96, _path97, _g49, _path98, _g50, _path99, _g51, _path100, _g52, _path101, _g53, _path102, _g54, _path103, _g55, _path104, _g56, _path105, _g57, _path106, _g58, _path107, _path108, _path109, _g59, _path110, _path111, _g60, _path112, _g61, _path113, _g62, _path114, _g63, _path115, _path116, _path117, _g64, _path118, _g65, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g66, _path126, _g67, _path127, _g68, _path128, _g69, _path129, _g70, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g71, _path150, _g72, _path151, _g73, _path152, _g74, _path153, _g75, _path154, _g76, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g77, _path165, _g78, _path166, _path167, _g79, _path168, _g80, _path169, _g81, _path170, _g82, _path171, _g83, _path172, _g84, _path173, _g85, _path174, _g86, _path175, _g87, _path176, _g88, _path177, _g89, _path178, _g90, _path179, _g91, _path180, _g92, _path181, _g93, _path182, _g94, _path183, _g95, _path184, _g96, _path185, _g97, _path186, _path187, _g98, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferalCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 308,
    viewBox: "0 0 208 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10961_47271)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10961_47271)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 200,
    height: 300,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10961_47271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.5,
    cy: 91,
    rx: 39.5,
    ry: 10,
    fill: "#D0D5FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.561 54.0239L106.23 57.252H105.662L108.993 54.0239H109.561Z",
    fill: "#3F2782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.359 50.5293C115.554 50.5293 118.658 51.0639 118.713 53.9664V54.025H118.145V53.9664C118.091 51.0639 114.987 50.5293 113.791 50.5293H114.359Z",
    fill: "#3F2782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.367 47.2769L128.264 50.5293L123.059 50.5879C123.278 51.2054 123.426 52.4742 123.16 54.0256H122.588C122.723 53.2502 122.754 52.5453 122.724 51.9565C122.694 51.3682 122.603 50.8967 122.492 50.5879L127.695 50.5293L130.799 47.2769H131.367Z",
    fill: "#3F2782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.716 54.0239L125.647 57.252H125.079L128.148 54.0239H128.716Z",
    fill: "#3F2782"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.023 63.3188L103.872 66.4209L109.747 81.3468H109.179L103.305 66.4209L104.456 63.3188C104.456 63.3188 104.456 63.3188 105.023 63.3188Z",
    fill: "#3F2782"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.034 57.2529C117.531 65.5281 109.46 65.7863 109.035 65.8L114.485 81.3485H113.913L108.472 65.8C108.897 65.7863 116.964 65.5281 121.444 57.2916L122.034 57.2529Z",
    fill: "#3F2782"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.89 36.27C127.645 36.27 130.184 36.8788 132.356 38.0054C134.711 39.2498 136.609 41.1462 137.889 43.5477C139.184 45.9443 139.841 48.8567 139.853 52.0368C139.855 55.2162 139.176 58.6683 137.913 62.1203C136.619 65.5723 134.731 69.0243 132.367 72.2088C129.997 75.3838 127.178 78.2957 124.109 80.6929C121.042 83.0944 117.736 84.9907 114.455 86.2402C111.449 87.3661 108.461 87.9705 105.708 87.9705C105.465 87.9705 105.224 87.9656 104.985 87.9562C111.048 87.7616 117.918 84.8591 123.797 80.0847C129.686 75.3296 134.501 68.7517 136.941 62.1197C139.428 55.4882 139.491 48.9098 137.131 44.1547C134.797 39.3752 130.08 36.4778 124.161 36.2831C124.405 36.275 124.648 36.27 124.89 36.27Z",
    fill: "#3F2782"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.13 44.1538C139.49 48.9089 139.427 55.4867 136.94 62.1188C134.501 68.7502 129.686 75.3286 123.796 80.0837C117.917 84.8582 111.048 87.7607 104.984 87.9553C99.0615 87.7607 94.3439 84.8632 92.0103 80.0837C89.6505 75.3286 89.7135 68.7508 92.2049 62.1188C94.6401 55.4873 99.4551 48.9089 105.344 44.1538C111.223 39.3793 118.093 36.4768 124.161 36.2822C130.08 36.4762 134.798 39.3743 137.13 44.1538ZM123.16 54.0233C123.425 52.4726 123.277 51.2032 123.059 50.5862L128.263 50.5276L131.367 47.2752H130.799H111.979H111.407L108.158 50.5276C108.379 50.5276 112.591 50.5276 113.792 50.5276C114.987 50.5276 118.091 51.0622 118.146 53.9647L109.562 54.0233H108.994L105.663 57.2514H117.4C116.908 58.3686 116.181 59.4783 115.249 60.4383C113.628 62.1063 111.389 63.3189 108.692 63.3189C105.591 63.3189 105.591 63.3189 105.591 63.3189C105.024 63.3189 105.024 63.3189 105.024 63.3189C104.456 63.3189 104.456 63.3189 104.456 63.3189L103.306 66.416L109.179 81.3469H113.914H114.486L109.036 65.7985C109.461 65.7847 117.532 65.5265 122.012 57.29L125.08 57.2514H125.648L128.717 54.0233H128.149H123.16Z",
    fill: "#3F2782"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.032 31.2417C141.115 31.2417 148.216 45.0641 141.886 62.1197C135.557 79.1752 118.196 92.9976 103.114 92.9976C88.0274 92.9976 80.93 79.1752 87.2595 62.1197C93.5891 45.0641 110.946 31.2417 126.032 31.2417ZM124.109 80.6922C127.179 78.295 129.997 75.3832 132.367 72.2081C134.731 69.0237 136.618 65.5717 137.913 62.1197C139.176 58.6676 139.856 55.2156 139.853 52.0362C139.841 48.8567 139.185 45.9443 137.89 43.5471C136.609 41.1455 134.711 39.2492 132.356 38.0048C130.184 36.8782 127.645 36.2694 124.89 36.2694C124.649 36.2694 124.406 36.2744 124.161 36.2838C123.922 36.2744 123.681 36.2694 123.438 36.2694C120.681 36.2694 117.697 36.8745 114.685 38.0048C111.406 39.2492 108.101 41.1455 105.037 43.5471C101.963 45.9443 99.1451 48.8561 96.7754 52.0312C94.4112 55.2156 92.528 58.6676 91.2336 62.1197C89.9655 65.5717 89.2868 69.0237 89.2937 72.2031C89.3005 75.3826 89.9618 78.295 91.2524 80.6922C92.5374 83.0938 94.4312 84.9901 96.786 86.2345C98.9617 87.3611 101.497 87.9699 104.255 87.9699C104.497 87.9699 104.74 87.9649 104.985 87.9556C105.224 87.9649 105.465 87.9699 105.708 87.9699C108.461 87.9699 111.449 87.3655 114.455 86.2395C117.736 84.9901 121.041 83.0944 124.109 80.6922Z",
    fill: "#3F2782"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.979 47.2769H111.407L108.157 50.5293C108.168 50.5293 108.372 50.5293 108.725 50.5293L111.979 47.2769Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 25,
    width: 49,
    height: 64
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8139 82.4225C77.8174 77.0367 76.1257 67.1653 80.3151 55.878C86.6446 38.8224 104.001 25 119.088 25L126.032 31.2378C110.945 31.2378 93.5892 45.0603 87.2597 62.1158C83.0709 73.4032 84.7627 83.2746 90.7585 88.6603C88.6757 86.789 85.8973 84.2938 83.8139 82.4225Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8142 82.4224L90.7588 88.6603C90.5972 88.5149 90.4388 88.3671 90.2835 88.2149L83.3389 81.9771C83.4942 82.1286 83.6526 82.2771 83.8142 82.4224Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3388 81.9778L90.2834 88.2156C89.9696 87.9094 89.6683 87.5894 89.3801 87.2569L82.4355 81.019C82.7237 81.3515 83.025 81.6715 83.3388 81.9778Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4355 81.0185L89.3801 87.2564C89.0944 86.927 88.8218 86.5852 88.5623 86.2315L81.6177 79.9937C81.8778 80.348 82.1504 80.6898 82.4355 81.0185Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6181 79.9942L88.5627 86.2321C88.3032 85.8777 88.0562 85.5122 87.8235 85.1348L80.8789 78.897C81.1116 79.2744 81.3586 79.6399 81.6181 79.9942Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8793 78.8965L87.8239 85.1343C87.5893 84.7545 87.3685 84.3633 87.1614 83.961L80.2168 77.7231C80.4239 78.1249 80.6447 78.5166 80.8793 78.8965Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2168 77.7219L87.1614 83.9597C86.9481 83.5449 86.7491 83.1176 86.5657 82.6797L79.6211 76.4419C79.8045 76.8804 80.0035 77.3071 80.2168 77.7219Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6212 76.4432L86.5658 82.681C86.3756 82.2269 86.2015 81.7609 86.0437 81.2837L79.0991 75.0459C79.2569 75.5231 79.431 75.9897 79.6212 76.4432Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0989 75.0451L86.0435 81.2829C85.8775 80.7814 85.7303 80.2668 85.6018 79.7403L78.6572 73.5024C78.7857 74.0289 78.9329 74.5429 79.0989 75.0451Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6569 73.5031L85.6014 79.7409C85.463 79.1745 85.3457 78.5938 85.2503 78.0005L78.3057 71.7627C78.4011 72.3559 78.5184 72.9367 78.6569 73.5031Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3064 71.7622L85.251 78C85.1443 77.3344 85.0651 76.652 85.0139 75.9546L78.0693 69.7168C78.1199 70.4142 78.1991 71.0966 78.3064 71.7622Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.069 69.7161L85.0136 75.954C84.9519 75.1075 84.9313 74.2386 84.9544 73.3497L78.0098 67.1118C77.9867 68.0007 78.0067 68.8697 78.069 69.7161Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0093 67.1134L84.9539 73.3513C84.9869 72.0663 85.1092 70.7389 85.3244 69.3765L78.3798 63.1387C78.1646 64.5004 78.0423 65.8278 78.0093 67.1134Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3799 63.1381L85.3245 69.3759C85.6925 67.0473 86.3319 64.6158 87.2601 62.115C87.3998 61.7389 87.5445 61.3646 87.6942 60.9922L80.7496 54.7544C80.5993 55.1268 80.4546 55.5017 80.3149 55.8772C79.3873 58.3786 78.7479 60.8095 78.3799 63.1381Z",
    fill: "#F9D53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7495 54.7536L87.6941 60.9915C88.2842 59.5256 88.9554 58.0859 89.6983 56.6793L82.7537 50.4414C82.0108 51.848 81.3402 53.2877 80.7495 54.7536Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7539 50.4436L89.6985 56.6814C90.1826 55.7645 90.6978 54.8612 91.2405 53.9742L84.2959 47.7363C83.7532 48.6233 83.2386 49.5266 82.7539 50.4436Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2964 47.7362L91.241 53.974C91.6963 53.2298 92.1717 52.4969 92.6657 51.7764L85.7211 45.5386C85.2271 46.2597 84.7517 46.992 84.2964 47.7362Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7212 45.5388L92.6658 51.7766C93.1093 51.1298 93.5672 50.4929 94.0387 49.8672L87.0941 43.6294C86.6219 44.2551 86.1641 44.8919 85.7212 45.5388Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0942 43.6274L94.0388 49.8652C94.4749 49.2863 94.9227 48.7168 95.3818 48.1573L88.4372 41.9194C87.9781 42.4796 87.5303 43.0491 87.0942 43.6274Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.437 41.9214L95.3816 48.1592C95.8189 47.6265 96.2655 47.1026 96.7215 46.5879L89.7769 40.3501C89.3209 40.8647 88.8743 41.3887 88.437 41.9214Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 40.349L96.7214 46.5868C97.1662 46.0847 97.6203 45.5919 98.0825 45.1085L91.138 38.8706C90.6757 39.354 90.2222 39.8475 89.7769 40.349Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1382 38.8709L98.0828 45.1087C98.5369 44.6334 98.9991 44.1675 99.4682 43.7115L92.5236 37.4736C92.0545 37.9296 91.5923 38.3956 91.1382 38.8709Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5234 37.4741L99.468 43.7119C99.9346 43.2584 100.408 42.8149 100.888 42.3814L93.9432 36.1436C93.4635 36.5771 92.99 37.0212 92.5234 37.4741Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9434 36.1422L100.888 42.38C101.371 41.9434 101.862 41.5167 102.358 41.1006L95.4136 34.8628C94.9171 35.2789 94.4274 35.7055 93.9434 36.1422Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4136 34.8627L102.358 41.1005C102.861 40.6789 103.371 40.2684 103.885 39.8692L96.9406 33.6313C96.4254 34.0306 95.9163 34.441 95.4136 34.8627Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9404 33.6316L103.885 39.8695C104.41 39.4621 104.942 39.0666 105.478 38.6836L98.5336 32.4458C97.9971 32.8288 97.4657 33.2243 96.9404 33.6316Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5337 32.446L105.478 38.6838C106.044 38.2796 106.616 37.8897 107.192 37.5142L100.248 31.2764C99.6715 31.6513 99.0995 32.0418 98.5337 32.446Z",
    fill: "#ECC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.248 31.2766L107.193 37.5145C107.805 37.1159 108.421 36.7341 109.043 36.3692L102.099 30.1313C101.477 30.4963 100.86 30.8786 100.248 31.2766Z",
    fill: "#EBC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.099 30.1303L109.043 36.3681C109.721 35.9708 110.403 35.594 111.09 35.2378L104.145 29C103.458 29.3562 102.776 29.733 102.099 30.1303Z",
    fill: "#EAC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.145 29.0008L111.09 35.2387C111.873 34.8332 112.662 34.4552 113.454 34.1065L106.509 27.8687C105.717 28.2173 104.928 28.5954 104.145 29.0008Z",
    fill: "#E9C739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509 27.8684L113.454 34.1062C114.437 33.6733 115.425 33.286 116.416 32.9454L109.471 26.7075C108.48 27.0481 107.492 27.4361 106.509 27.8684Z",
    fill: "#E8C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.471 26.7079L116.416 32.9458C119.64 31.8392 122.886 31.2378 126.033 31.2378L119.088 25C115.941 24.9994 112.695 25.6007 109.471 26.7079Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 30,
    width: 8,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.593 36.8335C118.582 36.836 118.571 36.8385 118.559 36.841C118.316 36.6227 117.991 36.3308 117.748 36.1124C117.489 35.881 117.146 35.5716 116.887 35.3402C116.62 35.0994 116.262 34.7788 115.995 34.5387C115.722 34.2935 115.358 33.9673 115.086 33.7221C114.813 33.477 114.45 33.1507 114.177 32.9056C113.909 32.6648 113.553 32.3442 113.284 32.104C113.026 31.872 112.682 31.5632 112.424 31.3318C112.181 31.1134 111.857 30.8215 111.613 30.6032C111.625 30.6007 111.636 30.5982 111.647 30.5957C113.963 32.6748 116.279 34.7545 118.593 36.8335Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0471L124.161 36.2849C123.921 36.2756 123.68 36.2706 123.437 36.2706C120.926 36.2706 118.225 36.7727 115.486 37.7171L108.541 31.4793C111.279 30.5349 113.98 30.0327 116.492 30.0327C116.736 30.0327 116.976 30.0371 117.216 30.0471Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 30,
    width: 10,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.677 33.3139C113.668 32.4075 112.658 31.5005 111.648 30.5942C112.252 30.4595 112.852 30.3484 113.444 30.2617C115.759 32.3408 118.074 34.4205 120.389 36.4996C119.796 36.5863 119.197 36.6973 118.594 36.832C117.288 35.6587 115.982 34.4866 114.677 33.3139Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0451L124.161 36.283C123.921 36.2736 123.68 36.2686 123.437 36.2686C120.926 36.2686 118.225 36.7708 115.486 37.7152L108.541 31.4773C111.279 30.5329 113.98 30.0308 116.492 30.0308C116.736 30.0308 116.976 30.0351 117.216 30.0451Z",
    fill: "#6D44E5"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.438 36.27C123.681 36.27 123.922 36.275 124.161 36.2844C118.094 36.479 111.224 39.3815 105.345 44.1559C99.4556 48.911 94.6406 55.4888 92.2053 62.1209C89.7139 68.7524 89.6509 75.3308 92.0107 80.0859C94.3443 84.8653 99.062 87.7628 104.985 87.9574C104.74 87.9668 104.496 87.9718 104.255 87.9718C101.497 87.9718 98.9615 87.363 96.7858 86.2364C94.431 84.992 92.5372 83.0957 91.2522 80.6941C89.9616 78.2969 89.3004 75.3851 89.2935 72.205C89.2866 69.0249 89.9653 65.5736 91.2335 62.1215C92.5272 58.6695 94.4104 55.2175 96.7752 52.0331C99.1449 48.858 101.963 45.9462 105.037 43.549C108.101 41.1474 111.406 39.2511 114.685 38.0067C117.696 36.8751 120.681 36.27 123.438 36.27Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 30,
    width: 37,
    height: 55
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2518 80.6894C92.0103 82.1072 92.9815 83.3492 94.1343 84.3847L87.189 78.1468C86.0363 77.1113 85.0651 75.8694 84.3065 74.4515C86.6214 76.5306 88.9363 78.6097 91.2505 80.6887C88.9356 78.6097 86.6208 76.5306 84.3059 74.4509C83.0153 72.0543 82.3541 69.1419 82.3472 65.9624C84.6621 68.0415 86.9763 70.12 89.2912 72.199C86.9763 70.12 84.6621 68.0409 82.3472 65.9618C82.3404 62.7824 83.019 59.3304 84.2872 55.879C86.6021 57.958 88.9169 60.0365 91.2318 62.1162C90.8201 61.7463 90.4078 61.3764 89.9961 61.0058C89.8988 60.9179 89.7684 60.8012 89.6705 60.7133C89.5713 60.6241 89.439 60.5056 89.3398 60.4164C89.2394 60.3259 89.1059 60.2062 89.0055 60.1163C88.9045 60.0253 88.7691 59.9042 88.668 59.8132C88.4977 59.6603 88.2713 59.4564 88.101 59.3042C87.9301 59.1507 87.7024 58.9461 87.5315 58.7927C87.1547 58.454 86.778 58.1159 86.4012 57.7778C86.2353 57.6287 86.0145 57.4303 85.8485 57.2812C85.687 57.1359 85.4711 56.9419 85.3089 56.7966C85.1524 56.6562 84.944 56.4684 84.7868 56.3281C84.6365 56.1933 84.4369 56.0137 84.2866 55.8783C85.5803 52.4263 87.4635 48.9749 89.8276 45.7905C92.1425 47.8696 94.4574 49.948 96.7722 52.0271C96.5714 51.8468 96.3699 51.6659 96.169 51.4856C96.0748 51.4014 95.9501 51.2885 95.8559 51.2043C95.7598 51.1182 95.632 51.0035 95.5365 50.9174C95.4386 50.8301 95.3088 50.7128 95.2109 50.6254C95.1117 50.5362 94.9795 50.4177 94.8809 50.3285C94.7805 50.2387 94.647 50.1183 94.5466 50.0285C94.4455 49.9374 94.3102 49.8164 94.2091 49.7253C94.0388 49.5725 93.8124 49.3685 93.6421 49.2163C93.4712 49.0629 93.2435 48.8583 93.0726 48.7048C92.9023 48.552 92.6752 48.348 92.5049 48.1946C92.3365 48.043 92.1113 47.8409 91.9429 47.6893C91.777 47.5402 91.5562 47.3419 91.3902 47.1928C91.2287 47.0474 91.0128 46.8541 90.8507 46.7087C90.6941 46.5684 90.4851 46.3806 90.3292 46.2402C90.1788 46.1055 89.9786 45.9259 89.8289 45.7911C92.1987 42.6167 95.0163 39.7042 98.0903 37.3076C98.0909 37.3076 98.0909 37.307 98.0915 37.307C98.0922 37.3077 98.0909 37.3077 98.0909 37.3083C100.406 39.3873 102.721 41.4652 105.036 43.5443C104.765 43.3016 104.495 43.0589 104.225 42.8157C102.18 40.9793 100.136 39.1428 98.0915 37.307C101.154 34.9055 104.46 33.0098 107.738 31.7653C107.738 31.7653 107.738 31.7653 107.739 31.7647C107.739 31.7647 107.739 31.7653 107.738 31.7653C110.053 33.8444 112.368 35.9228 114.683 38.0019C114.617 37.9427 114.551 37.884 114.486 37.8248C114.456 37.7979 114.416 37.7618 114.386 37.7349C114.355 37.7075 114.316 37.6713 114.285 37.6445C114.254 37.617 114.214 37.5802 114.183 37.5528C114.153 37.5254 114.112 37.4879 114.08 37.4605C114.049 37.4324 114.008 37.3956 113.977 37.3675C113.946 37.3395 113.904 37.302 113.873 37.274C113.647 37.0719 113.347 36.8024 113.122 36.6003C112.889 36.3907 112.578 36.1119 112.346 35.9029C112.108 35.6896 111.791 35.4045 111.553 35.1911C111.315 34.9766 110.996 34.6903 110.756 34.4751C110.519 34.2617 110.203 33.9779 109.965 33.7646C109.733 33.5562 109.424 33.278 109.192 33.0697C108.968 32.8688 108.67 32.6006 108.446 32.3997C108.234 32.2095 107.952 31.9556 107.74 31.7647C109.041 31.2763 110.338 30.8858 111.613 30.6001C113.928 32.6792 116.243 34.7589 118.558 36.8379C117.282 37.1236 115.985 37.5141 114.683 38.0032C111.404 39.2476 108.099 41.1439 105.036 43.5455C101.962 45.9427 99.1432 48.8545 96.7735 52.0296C94.4093 55.214 92.5261 58.666 91.2318 62.1181C89.9636 65.5701 89.285 69.0221 89.2918 72.2015C89.2999 75.3803 89.9611 78.2928 91.2518 80.6894Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0432L124.161 36.281C123.921 36.2717 123.68 36.2667 123.437 36.2667C120.926 36.2667 118.225 36.7688 115.486 37.7132L108.541 31.4754C111.279 30.531 113.98 30.0288 116.492 30.0288C116.736 30.0288 116.976 30.0332 117.216 30.0432Z",
    fill: "#6D44E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.541 31.4766L115.486 37.7144C115.219 37.8067 114.952 37.9028 114.684 38.0032C114.159 38.2028 113.633 38.4187 113.108 38.6507L106.164 32.4129C106.689 32.1808 107.215 31.9644 107.74 31.7654C108.007 31.665 108.275 31.5689 108.541 31.4766Z",
    fill: "#E8C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.163 32.4121L113.108 38.65C112.454 38.9388 111.801 39.2525 111.151 39.5906L104.206 33.3528C104.857 33.0147 105.51 32.7009 106.163 32.4121Z",
    fill: "#E9C739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.206 33.3525L111.15 39.5904C110.582 39.8854 110.015 40.1992 109.452 40.5298L102.507 34.292C103.071 33.9614 103.637 33.6476 104.206 33.3525Z",
    fill: "#EAC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.507 34.292L109.452 40.5298C108.938 40.8311 108.428 41.1474 107.922 41.4774L100.978 35.2395C101.484 34.9095 101.994 34.5933 102.507 34.292Z",
    fill: "#EBC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.978 35.2393L107.922 41.4771C107.45 41.7846 106.982 42.1046 106.517 42.4359L99.5723 36.198C100.037 35.8668 100.505 35.5468 100.978 35.2393Z",
    fill: "#ECC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.573 36.1987L106.518 42.4366C106.077 42.751 105.641 43.076 105.208 43.4109L98.2637 37.1731C98.6953 36.8387 99.132 36.5137 99.573 36.1987Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2634 37.1738L105.208 43.4117C105.151 43.456 105.094 43.5009 105.036 43.5452C104.653 43.844 104.274 44.1509 103.899 44.4653L96.9541 38.2274C97.329 37.913 97.7083 37.6061 98.0919 37.3073C98.1493 37.263 98.206 37.2181 98.2634 37.1738Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9543 38.2266L103.899 44.4644C103.497 44.8013 103.1 45.1474 102.709 45.5011L95.7642 39.2633C96.1559 38.9096 96.5526 38.564 96.9543 38.2266Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.764 39.2627L102.709 45.5005C102.312 45.8586 101.921 46.2254 101.536 46.5996L94.5913 40.3618C94.9762 39.9875 95.3673 39.6207 95.764 39.2627Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5915 40.3628L101.536 46.6006C101.143 46.9824 100.757 47.3716 100.378 47.769L93.4331 41.5312C93.8124 41.1344 94.1985 40.7445 94.5915 40.3628Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4328 41.5308L100.377 47.7686C99.985 48.1791 99.6002 48.597 99.2234 49.0218L92.2788 42.7839C92.6556 42.3591 93.0404 41.9412 93.4328 41.5308Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2785 42.7837L99.2231 49.0215C98.8295 49.465 98.4446 49.9167 98.0691 50.3745L91.1245 44.1367C91.5007 43.6788 91.8855 43.2272 92.2785 42.7837Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1244 44.1372L98.069 50.3751C97.671 50.8597 97.2843 51.3525 96.9075 51.8516L89.9629 45.6137C90.3397 45.1147 90.727 44.6219 91.1244 44.1372Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9628 45.6147L96.9074 51.8526C96.8631 51.9119 96.8188 51.9705 96.7745 52.0297C96.4526 52.4633 96.1395 52.9018 95.8357 53.3447L88.8911 47.1068C89.1949 46.664 89.508 46.2254 89.8299 45.7919C89.8742 45.7326 89.9185 45.674 89.9628 45.6147Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8914 47.1055L95.836 53.3433C95.4193 53.9503 95.0201 54.5659 94.6389 55.1872L87.6943 48.9494C88.0755 48.3275 88.4747 47.7124 88.8914 47.1055Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6942 48.9497L94.6388 55.1876C94.1691 55.9529 93.7268 56.7283 93.3132 57.5099L86.3687 51.2721C86.7816 50.4905 87.2245 49.7151 87.6942 48.9497Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3679 51.2725L93.3125 57.5103C92.6812 58.7024 92.1167 59.9087 91.6233 61.1189L84.6787 54.881C85.1721 53.6709 85.7366 52.4645 86.3679 51.2725Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6793 54.8809L91.6239 61.1187C91.4885 61.4512 91.3581 61.7843 91.2334 62.1174C90.4717 64.1902 89.9228 66.2637 89.6072 68.2779L82.6626 62.04C82.9782 60.0258 83.5272 57.953 84.2888 55.8795C84.4129 55.5464 84.5433 55.2133 84.6793 54.8809Z",
    fill: "#F9D53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.662 62.0396L89.6066 68.2774C89.4282 69.4164 89.324 70.5367 89.2991 71.6271L82.3545 65.3893C82.3794 64.2989 82.4836 63.1786 82.662 62.0396Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3545 65.3887L89.2991 71.6265C89.2947 71.8186 89.2929 72.0095 89.2929 72.1998C89.2941 72.7387 89.3141 73.2702 89.3527 73.7923L82.4081 67.5545C82.3695 67.0324 82.3495 66.5009 82.3483 65.9619C82.3476 65.7723 82.3495 65.5808 82.3545 65.3887Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4082 67.5562L89.3528 73.794C89.3965 74.3853 89.4644 74.9655 89.5555 75.5325L82.6109 69.2946C82.5192 68.7276 82.4519 68.1481 82.4082 67.5562Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6108 69.2949L89.5554 75.5328C89.6359 76.033 89.7351 76.5233 89.853 77.0018L82.9084 70.7639C82.7905 70.2855 82.6913 69.7952 82.6108 69.2949Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9087 70.7632L89.8533 77.001C89.9606 77.4383 90.0835 77.8662 90.2219 78.2841L83.2774 72.0463C83.1389 71.629 83.016 71.2011 82.9087 70.7632Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2773 72.0464L90.2219 78.2842C90.3511 78.6741 90.4933 79.0546 90.6486 79.4258L83.704 73.1879C83.5487 72.8168 83.4065 72.4363 83.2773 72.0464Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7041 73.1875L90.6487 79.4253C90.7965 79.7772 90.9562 80.1202 91.1278 80.454L84.1832 74.2161C84.0116 73.8824 83.8519 73.5393 83.7041 73.1875Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1831 74.2163L91.1277 80.4542C91.1682 80.5334 91.21 80.612 91.2518 80.69C91.3909 80.9501 91.5375 81.2039 91.6904 81.4522L84.7458 75.2144C84.5923 74.9661 84.4463 74.7122 84.3072 74.4521C84.2654 74.3741 84.2237 74.2955 84.1831 74.2163Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7456 75.2144L91.6902 81.4522C91.883 81.7647 92.0869 82.0673 92.3015 82.3598L85.3569 76.122C85.143 75.8294 84.939 75.5269 84.7456 75.2144Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3574 76.1216L92.302 82.3594C92.5178 82.6539 92.7449 82.9383 92.9819 83.2115L86.0373 76.9737C85.8003 76.7005 85.5733 76.416 85.3574 76.1216Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0376 76.9741L92.9822 83.212C93.223 83.4896 93.4744 83.7572 93.7364 84.0129L86.7918 77.7751C86.5298 77.5187 86.2784 77.2517 86.0376 76.9741Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7915 77.7739L93.7361 84.0118C93.8665 84.139 93.9993 84.2632 94.1341 84.3848L87.1895 78.1469C87.0547 78.0253 86.9219 77.9012 86.7915 77.7739Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 30,
    width: 9,
    height: 7
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.39 36.4997C120.119 36.257 119.849 36.0138 119.578 35.7711C119.291 35.5135 119.005 35.2558 118.718 34.9988C118.518 34.8192 118.251 34.579 118.05 34.3994C117.847 34.2166 117.575 33.9727 117.372 33.79C117.166 33.6059 116.893 33.3602 116.689 33.1762C116.485 32.9928 116.212 32.7482 116.007 32.5648C115.806 32.3839 115.537 32.1425 115.336 31.9617C115.139 31.7851 114.877 31.5493 114.68 31.3728C114.49 31.2025 114.237 30.9748 114.048 30.8045C113.867 30.6423 113.625 30.4253 113.444 30.2631C113.865 30.2013 114.282 30.152 114.695 30.1152C117.01 32.1943 119.325 34.274 121.64 36.3531C121.227 36.3886 120.809 36.4385 120.39 36.4997Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0461L124.161 36.2839C123.922 36.2746 123.681 36.2696 123.437 36.2696C120.926 36.2696 118.225 36.7717 115.486 37.7161L108.542 31.4783C111.28 30.5339 113.981 30.0317 116.493 30.0317C116.736 30.0317 116.977 30.0361 117.216 30.0461Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 30,
    width: 42,
    height: 55
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.149C86.0371 77.1135 85.0659 75.8716 84.3074 74.4531C83.0168 72.0559 82.3555 69.1441 82.3487 65.964C82.3418 62.784 83.0205 59.3326 84.2887 55.8805C85.5824 52.4285 87.4656 48.9765 89.8304 45.7921C92.2001 42.617 95.0184 39.7052 98.0924 37.308C101.156 34.9064 104.461 33.0101 107.74 31.7657C110.752 30.6354 113.736 30.0303 116.493 30.0303L123.438 36.2681C120.681 36.2681 117.697 36.8732 114.685 38.0035C111.406 39.2479 108.101 41.1443 105.038 43.5458C101.964 45.9424 99.1453 48.8548 96.7756 52.0299C94.4114 55.2143 92.5282 58.6664 91.2339 62.1184C89.9657 65.5704 89.2864 69.0224 89.2939 72.2019C89.3008 75.3813 89.962 78.2938 91.2526 80.691C92.0111 82.1094 92.9823 83.3514 94.1351 84.3869C92.0517 82.5155 89.2733 80.0204 87.1899 78.149Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.19 78.1499L94.1346 84.3877C93.9992 84.2661 93.8663 84.142 93.7366 84.0147L86.792 77.7769C86.9224 77.9041 87.0552 78.0282 87.19 78.1499Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7918 77.776L93.7364 84.0139C93.4744 83.7581 93.223 83.4912 92.9822 83.2129L86.0376 76.9751C86.2784 77.2533 86.5298 77.5203 86.7918 77.776Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0378 76.9751L92.9824 83.213C92.7454 82.9391 92.5183 82.6553 92.3025 82.3609L85.3579 76.123C85.5737 76.4168 85.8008 76.7013 86.0378 76.9751Z",
    fill: "#C89108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3579 76.1234L92.3025 82.3613C92.0879 82.0687 91.8839 81.7662 91.6912 81.4537L84.7466 75.2158C84.9393 75.5283 85.1433 75.8309 85.3579 76.1234Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7462 75.2164L91.6908 81.4543C91.5374 81.206 91.3914 80.9521 91.2523 80.692C91.2124 80.6184 91.1737 80.5441 91.135 80.4693L84.1904 74.2314C84.2291 74.3063 84.2678 74.3805 84.3077 74.4541C84.4468 74.7136 84.5934 74.9681 84.7462 75.2164Z",
    fill: "#CA9208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.19 74.2313L91.1346 80.4691C90.9606 80.1311 90.7984 79.7836 90.6487 79.4268L83.7041 73.189C83.8538 73.5458 84.016 73.8932 84.19 74.2313Z",
    fill: "#CB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.704 73.1894L90.6486 79.4272C90.4933 79.0567 90.3504 78.6756 90.2219 78.2857L83.2773 72.0479C83.4065 72.4377 83.5487 72.8182 83.704 73.1894Z",
    fill: "#CC9409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2778 72.0478L90.2224 78.2856C90.0846 77.8683 89.9611 77.4404 89.8538 77.0025L82.9092 70.7646C83.0165 71.2025 83.1394 71.6304 83.2778 72.0478Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9089 70.7654L89.8535 77.0033C89.7356 76.5248 89.6364 76.0345 89.5559 75.5342L82.6113 69.2964C82.6918 69.7973 82.791 70.287 82.9089 70.7654Z",
    fill: "#CD9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6114 69.2961L89.556 75.5339C89.4643 74.9669 89.3969 74.3868 89.3533 73.7955L82.4087 67.5576C82.4524 68.1496 82.5197 68.7297 82.6114 69.2961Z",
    fill: "#CE9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4085 67.5574L89.3531 73.7952C89.3144 73.2731 89.2945 72.7417 89.2932 72.2027C89.2926 72.0125 89.2951 71.8216 89.2995 71.6294L82.3549 65.3916C82.3505 65.5837 82.3486 65.7752 82.3486 65.9649C82.3499 66.5038 82.3698 67.0346 82.4085 67.5574Z",
    fill: "#CF9609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.355 65.3907L89.2996 71.6286C89.3251 70.5382 89.4287 69.4179 89.6071 68.2789L82.6625 62.041C82.4841 63.18 82.3806 64.3004 82.355 65.3907Z",
    fill: "#D09709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6626 62.0409L89.6072 68.2787C89.9228 66.2645 90.4718 64.1917 91.2334 62.1182C91.3582 61.7851 91.4885 61.4526 91.6239 61.1202L84.6793 54.8823C84.5439 55.2148 84.4136 55.5479 84.2888 55.8804C83.5272 57.9538 82.9782 60.0267 82.6626 62.0409Z",
    fill: "#D19709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6797 54.883L91.6243 61.1208C92.1177 59.9107 92.6822 58.7043 93.3135 57.5123L86.3689 51.2744C85.737 52.4665 85.1725 53.6728 84.6797 54.883Z",
    fill: "#D09709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3682 51.275L93.3128 57.5128C93.7263 56.7312 94.1686 55.9559 94.6389 55.1905L87.6943 48.9526C87.2246 49.718 86.7824 50.4934 86.3682 51.275Z",
    fill: "#CF9609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6948 48.9508L94.6394 55.1887C95.0205 54.5674 95.4198 53.9517 95.8365 53.3448L88.8919 47.1069C88.4752 47.7139 88.076 48.3289 87.6948 48.9508Z",
    fill: "#CE9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8916 47.1082L95.8362 53.3461C96.14 52.9032 96.4531 52.4647 96.775 52.0311C96.8311 51.9563 96.8873 51.8814 96.9434 51.8072L89.9988 45.5693C89.9427 45.6442 89.8865 45.7184 89.8304 45.7933C89.5085 46.2262 89.1954 46.6653 88.8916 47.1082Z",
    fill: "#CD9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.999 45.5689L96.9436 51.8067C97.3085 51.3239 97.6841 50.8467 98.0695 50.377L91.1249 44.1392C90.7401 44.6089 90.3646 45.0855 89.999 45.5689Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.125 44.1391L98.0696 50.377C98.4451 49.9191 98.83 49.4675 99.2236 49.024L92.279 42.7861C91.886 43.2296 91.5011 43.6812 91.125 44.1391Z",
    fill: "#CC9409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2788 42.7854L99.2234 49.0233C99.6002 48.5985 99.985 48.1799 100.377 47.7701L93.4328 41.5322C93.0411 41.9427 92.6562 42.3606 92.2788 42.7854Z",
    fill: "#CB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4336 41.5331L100.378 47.7709C100.757 47.3742 101.144 46.9843 101.537 46.6026L94.592 40.3647C94.199 40.7465 93.8129 41.1364 93.4336 41.5331Z",
    fill: "#CA9208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5918 40.3633L101.536 46.6011C101.921 46.2268 102.312 45.8601 102.709 45.502L95.7645 39.2642C95.3678 39.6228 94.9767 39.989 94.5918 40.3633Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7646 39.2646L102.709 45.5025C103.101 45.1488 103.498 44.8032 103.9 44.4664L96.9555 38.2285C96.5531 38.5654 96.1558 38.9109 95.7646 39.2646Z",
    fill: "#C89108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9546 38.2298L103.899 44.4676C104.274 44.1532 104.653 43.8463 105.037 43.5475C105.071 43.5207 105.104 43.4945 105.139 43.4683L98.194 37.2305C98.1604 37.2567 98.1267 37.2835 98.0924 37.3097C97.7094 37.6079 97.3295 37.9148 96.9546 38.2298Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1938 37.2294L105.138 43.4673C105.593 43.113 106.054 42.7699 106.518 42.438L99.573 36.2002C99.1083 36.532 98.6486 36.8751 98.1938 37.2294Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5732 36.1985L106.518 42.4363C106.982 42.1051 107.45 41.7851 107.923 41.4776L100.978 35.2397C100.506 35.5473 100.037 35.8673 99.5732 36.1985Z",
    fill: "#C68F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.978 35.2415L107.923 41.4793C108.429 41.1493 108.939 40.8337 109.452 40.5318L102.508 34.2939C101.995 34.5959 101.485 34.9115 100.978 35.2415Z",
    fill: "#C58F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.507 34.2934L109.452 40.5313C110.015 40.2007 110.582 39.8869 111.15 39.5918L104.205 33.354C103.637 33.6491 103.071 33.9628 102.507 34.2934Z",
    fill: "#C48E08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.206 33.3547L111.151 39.5926C111.801 39.2551 112.454 38.9407 113.108 38.6519L106.163 32.4141C105.51 32.7029 104.856 33.0173 104.206 33.3547Z",
    fill: "#C38D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.164 32.4143L113.108 38.6522C113.633 38.4201 114.159 38.2037 114.684 38.0047C114.952 37.9043 115.219 37.8082 115.487 37.7159L108.542 31.478C108.275 31.5703 108.007 31.6664 107.74 31.7668C107.215 31.9658 106.689 32.1823 106.164 32.4143Z",
    fill: "#C28D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.542 31.4768L115.487 37.7147C118.225 36.7703 120.926 36.2681 123.438 36.2681L116.493 30.0303C113.981 30.0303 111.28 30.5324 108.542 31.4768Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 34,
    width: 27,
    height: 50
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.345 44.1519C99.4562 48.907 94.6412 55.4848 92.2059 62.1169C89.7145 68.7484 89.6515 75.3268 92.0113 80.0819C92.5552 81.1953 93.2283 82.2071 94.0155 83.106C93.7722 82.8877 93.4479 82.5958 93.204 82.3774C92.9457 82.146 92.602 81.8366 92.3438 81.6052C92.0762 81.365 91.7187 81.0438 91.4511 80.8036C91.1785 80.5585 90.8149 80.2322 90.5423 79.9871C89.9422 79.4475 89.3415 78.9085 88.7408 78.369C88.1837 77.8687 87.6267 77.3684 87.0697 76.8682C86.2818 75.9693 85.6088 74.9581 85.0654 73.844C82.7057 69.0889 82.7687 62.5111 85.2601 55.8791C87.6953 49.2476 92.5103 42.6692 98.3995 37.9141C99.7687 36.8019 101.192 35.7913 102.647 34.8931C104.962 36.9721 107.277 39.0518 109.591 41.1309C108.138 42.0292 106.715 43.0397 105.345 44.1519Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7849 77.6218L94.7295 83.8596C94.465 83.6014 94.2112 83.3319 93.9685 83.0518L87.0239 76.814C87.2666 77.094 87.5205 77.3635 87.7849 77.6218Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0243 76.8141L93.9689 83.052C93.7312 82.7781 93.5042 82.4937 93.2883 82.1993L86.3438 75.9614C86.5596 76.2559 86.7866 76.5403 87.0243 76.8141Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3436 75.9625L93.2882 82.2003C93.0755 81.9103 92.8734 81.6102 92.6819 81.3008L85.7373 75.063C85.9282 75.3724 86.1303 75.6724 86.3436 75.9625Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7376 75.0623L92.6822 81.3001C92.4807 80.9739 92.291 80.6364 92.1145 80.2896L85.1699 74.0518C85.3465 74.3986 85.5355 74.736 85.7376 75.0623Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1697 74.0506L92.1142 80.2885C92.0793 80.2199 92.045 80.1512 92.0113 80.0814C91.8753 79.8075 91.7475 79.5274 91.6277 79.2418L84.6831 73.0039C84.8029 73.2896 84.9308 73.5697 85.0667 73.8435C85.1004 73.9134 85.1347 73.9826 85.1697 74.0506Z",
    fill: "#ECC72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6827 73.0048L91.6273 79.2427C91.4732 78.8753 91.3322 78.4979 91.2044 78.1124L84.2598 71.8745C84.3876 72.26 84.5286 72.6374 84.6827 73.0048Z",
    fill: "#EDC82B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2602 71.8742L91.2047 78.112C91.0681 77.6997 90.9471 77.2774 90.8411 76.8458L83.8965 70.6079C84.0025 71.0396 84.1235 71.4619 84.2602 71.8742Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8967 70.6079L90.8413 76.8458C90.7253 76.3736 90.628 75.8908 90.5481 75.398L83.6035 69.1602C83.6834 69.6529 83.7807 70.1357 83.8967 70.6079Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6037 69.1597L90.5483 75.3976C90.4578 74.8362 90.3911 74.2623 90.3474 73.6778L83.4028 67.4399C83.4465 68.0244 83.5132 68.5983 83.6037 69.1597Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4025 67.4392L90.3471 73.677C90.294 72.9634 90.2766 72.2342 90.294 71.4913L83.3495 65.2534C83.3326 65.9963 83.3501 66.7262 83.4025 67.4392Z",
    fill: "#F1CB2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3501 65.253L90.2947 71.4908C90.3209 70.3917 90.4238 69.2633 90.6041 68.1168L83.6595 61.8789C83.4792 63.026 83.3763 64.1538 83.3501 65.253Z",
    fill: "#F2CC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6597 61.8789L90.6043 68.1168C90.9124 66.155 91.4464 64.1383 92.2061 62.116C92.3421 61.7461 92.4856 61.3762 92.6359 61.0069L85.6913 54.769C85.541 55.1383 85.3975 55.5082 85.2615 55.8781C84.5018 57.9004 83.9678 59.9171 83.6597 61.8789Z",
    fill: "#F3CD2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6909 54.7707L92.6355 61.0086C93.0959 59.8776 93.6242 58.7511 94.2131 57.6382L87.2685 51.4004C86.6796 52.5132 86.1519 53.6398 85.6909 54.7707Z",
    fill: "#F2CC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2681 51.3999L94.2127 57.6378C94.6163 56.8742 95.0485 56.1176 95.5076 55.3697L88.563 49.1318C88.1039 49.8791 87.6717 50.6364 87.2681 51.3999Z",
    fill: "#F1CB2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.563 49.1307L95.5076 55.3685C95.8887 54.7466 96.2886 54.1315 96.7052 53.524L89.7607 47.2861C89.344 47.8937 88.9441 48.5094 88.563 49.1307Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7607 47.2871L96.7053 53.5249C97.0771 52.9828 97.4632 52.4464 97.8612 51.918L90.9166 45.6802C90.518 46.2085 90.1325 46.7444 89.7607 47.2871Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9165 45.6798L97.8611 51.9176C98.2304 51.4273 98.6109 50.9439 99.002 50.4673L92.0574 44.2295C91.6663 44.7054 91.2858 45.1895 90.9165 45.6798Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0576 44.2298L99.0022 50.4676C99.3709 50.0185 99.7483 49.5756 100.134 49.1402L93.1898 42.9023C92.8037 43.3377 92.4257 43.7806 92.0576 44.2298Z",
    fill: "#EDC82B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.189 42.9017L100.134 49.1395C100.504 48.7216 100.883 48.3099 101.269 47.9063L94.3249 41.6685C93.9388 42.072 93.5601 42.4837 93.189 42.9017Z",
    fill: "#ECC72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3252 41.6685L101.27 47.9063C101.643 47.5152 102.024 47.1316 102.411 46.7554L95.4667 40.5176C95.0794 40.8937 94.6988 41.2773 94.3252 41.6685Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4668 40.5182L102.411 46.756C102.793 46.3855 103.179 46.0225 103.572 45.6675L96.6277 39.4297C96.2347 39.7852 95.8479 40.1483 95.4668 40.5182Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6274 39.4296L103.572 45.6675C103.961 45.3163 104.355 44.9732 104.754 44.6382L97.8095 38.4004C97.4103 38.7354 97.0161 39.0784 96.6274 39.4296Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8096 38.4007L104.754 44.6386C104.95 44.4745 105.147 44.3123 105.345 44.1526C105.579 43.963 105.814 43.7759 106.051 43.5918L99.1064 37.354C98.8694 37.538 98.6342 37.7252 98.4003 37.9148C98.2026 38.0745 98.0054 38.2367 97.8096 38.4007Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1064 37.3532L106.051 43.591C106.488 43.2517 106.93 42.9223 107.377 42.6036L100.432 36.3657C99.986 36.6845 99.5437 37.0138 99.1064 37.3532Z",
    fill: "#E7C32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.432 36.367L107.376 42.6048C107.842 42.273 108.311 41.9524 108.785 41.6436L101.84 35.4058C101.367 35.7145 100.897 36.0352 100.432 36.367Z",
    fill: "#E6C22A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.841 35.4051L108.785 41.6429C109.298 41.3092 109.813 40.9898 110.334 40.6841L103.389 34.4463C102.869 34.7519 102.352 35.0713 101.841 35.4051Z",
    fill: "#E5C129"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 30,
    width: 9,
    height: 7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.161 36.2825C123.922 36.2731 123.681 36.2681 123.438 36.2681C122.28 35.2283 121.123 34.189 119.965 33.1492C119.693 32.9047 119.329 32.5778 119.056 32.3327C118.789 32.0925 118.431 31.7713 118.164 31.5311C117.906 31.2997 117.562 30.9903 117.304 30.7589C117.06 30.5405 116.736 30.2486 116.493 30.0303C116.736 30.0303 116.977 30.0353 117.216 30.0446C119.3 31.916 122.078 34.4111 124.161 36.2825Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0446L124.161 36.2825C123.921 36.2731 123.68 36.2681 123.437 36.2681C120.926 36.2681 118.225 36.7703 115.486 37.7147L108.541 31.4768C111.279 30.5324 113.98 30.0303 116.492 30.0303C116.736 30.0303 116.976 30.0346 117.216 30.0446Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 30,
    width: 9,
    height: 7
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.493 30.0303C116.736 30.0303 116.977 30.0353 117.216 30.0446L124.161 36.2825C123.921 36.2731 123.681 36.2681 123.437 36.2681L116.493 30.0303Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.493 30.0303L123.438 36.2681C123.681 36.2681 123.922 36.2731 124.161 36.2825L117.217 30.0446C116.977 30.0346 116.736 30.0303 116.493 30.0303Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 30,
    width: 23,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.592 41.1328C109.348 40.9145 109.024 40.6226 108.781 40.4042C108.523 40.1722 108.179 39.8634 107.921 39.632C107.653 39.3919 107.296 39.0706 107.028 38.8305C106.755 38.5859 106.392 38.2591 106.119 38.0139C105.846 37.7688 105.483 37.4425 105.21 37.1974C104.943 36.9572 104.585 36.636 104.318 36.3958C104.059 36.1644 103.716 35.855 103.457 35.6236C103.214 35.4052 102.89 35.1133 102.646 34.895C107.435 31.9364 112.562 30.1941 117.216 30.0444L118.027 30.773C118.461 31.1629 118.895 31.5534 119.33 31.9432C119.896 32.4522 120.462 32.9613 121.029 33.4703C122.073 34.4078 123.117 35.3447 124.161 36.2823C119.507 36.432 114.381 38.1742 109.592 41.1328Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.84 35.4075L108.785 41.6453C109.297 41.3116 109.813 40.9922 110.333 40.6866L103.389 34.4487C102.868 34.7544 102.352 35.0738 101.84 35.4075Z",
    fill: "#E5C129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.388 34.449L110.332 40.6868C110.907 40.3494 111.485 40.0294 112.066 39.7281L105.122 33.4902C104.54 33.7915 103.962 34.1115 103.388 34.449Z",
    fill: "#E4C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.122 33.4903L112.067 39.7282C112.74 39.3789 113.417 39.0539 114.095 38.7544L107.151 32.5166C106.473 32.816 105.795 33.141 105.122 33.4903Z",
    fill: "#E3C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.151 32.5166L114.095 38.7544C114.949 38.3771 115.807 38.0402 116.662 37.7452L109.717 31.5073C108.862 31.8018 108.005 32.1392 107.151 32.5166Z",
    fill: "#E2BF29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.717 31.5074L116.662 37.7453C119.213 36.8657 121.75 36.3611 124.16 36.2837L117.216 30.0459C114.805 30.1232 112.269 30.6279 109.717 31.5074Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 30,
    width: 42,
    height: 55
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1356 84.2413L88.191 78.0035C86.9091 76.852 85.8524 75.4553 85.0664 73.846C82.7066 69.0909 82.7696 62.513 85.261 55.881C87.6963 49.2495 92.5113 42.6711 98.4004 37.916C104.28 33.1415 111.149 30.2391 117.217 30.0444L124.161 36.2823C118.094 36.4769 111.224 39.3794 105.345 44.1538C99.4559 48.9089 94.6409 55.4867 92.2056 62.1188C89.7142 68.7503 89.6512 75.3287 92.011 80.0838C92.797 81.6938 93.8537 83.0898 95.1356 84.2413Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0459L124.161 36.2837C121.751 36.3611 119.214 36.8657 116.662 37.7453L109.718 31.5074C112.269 30.6279 114.806 30.1232 117.216 30.0459Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.718 31.5073L116.663 37.7452C115.807 38.0402 114.95 38.3771 114.096 38.7544L107.152 32.5166C108.006 32.1392 108.863 31.8018 109.718 31.5073Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.152 32.5166L114.096 38.7544C113.418 39.0539 112.741 39.3789 112.068 39.7282L105.123 33.4903C105.795 33.141 106.473 32.816 107.152 32.5166Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.122 33.4902L112.067 39.7281C111.486 40.03 110.907 40.3494 110.333 40.6868L103.388 34.449C103.963 34.1115 104.541 33.7921 105.122 33.4902Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.389 34.4487L110.333 40.6866C109.814 40.9922 109.297 41.3116 108.785 41.6453L101.84 35.4075C102.352 35.0738 102.869 34.7544 103.389 34.4487Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.841 35.4082L108.785 41.646C108.312 41.9548 107.841 42.2754 107.377 42.6073L100.432 36.3694C100.897 36.0376 101.367 35.717 101.841 35.4082Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.431 36.3682L107.376 42.606C106.929 42.9248 106.488 43.2535 106.051 43.5935L99.106 37.3556C99.5432 37.0163 99.9855 36.6869 100.431 36.3682Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1064 37.3564L106.051 43.5943C105.814 43.7783 105.579 43.9655 105.345 44.1551C105.147 44.3148 104.95 44.477 104.754 44.641L97.8096 38.4032C98.0054 38.2391 98.2019 38.0769 98.4003 37.9172C98.6342 37.727 98.87 37.5398 99.1064 37.3564Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81 38.4033L104.755 44.6412C104.355 44.9761 103.961 45.3192 103.573 45.6704L96.6279 39.4326C97.0159 39.0814 97.4102 38.7383 97.81 38.4033Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6277 39.4307L103.572 45.6685C103.179 46.0234 102.792 46.3865 102.411 46.757L95.4668 40.5192C95.8473 40.1486 96.2341 39.7856 96.6277 39.4307Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4662 40.5205L102.411 46.7584C102.023 47.1345 101.643 47.5187 101.269 47.9092L94.3247 41.6714C94.6984 41.2809 95.0795 40.8973 95.4662 40.5205Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3249 41.6709L101.269 47.9087C100.883 48.313 100.505 48.724 100.134 49.142L93.189 42.9041C93.5601 42.4862 93.9388 42.0745 94.3249 41.6709Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1888 42.9048L100.133 49.1426C99.7473 49.578 99.3699 50.0209 99.0012 50.4701L92.0566 44.2322C92.4253 43.7831 92.8033 43.3402 93.1888 42.9048Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0574 44.2329L99.002 50.4708C98.6115 50.9473 98.231 51.4307 97.8611 51.921L90.9165 45.6832C91.2858 45.1929 91.6663 44.7095 92.0574 44.2329Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9166 45.6826L97.8612 51.9205C97.4626 52.4488 97.0771 52.9846 96.7053 53.5273L89.7607 47.2895C90.1325 46.7468 90.518 46.211 90.9166 45.6826Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7607 47.2891L96.7052 53.5269C96.2886 54.1345 95.8887 54.7495 95.5076 55.3714L88.563 49.1336C88.9441 48.5117 89.344 47.896 89.7607 47.2891Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.563 49.1338L95.5076 55.3716C95.0485 56.1196 94.6169 56.8762 94.2127 57.6397L87.2681 51.4019C87.6717 50.6383 88.1039 49.8817 88.563 49.1338Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.268 51.4023L94.2126 57.6402C93.6237 58.7536 93.096 59.8796 92.635 61.0105L85.6904 54.7727C86.1514 53.6417 86.6791 52.5152 87.268 51.4023Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6904 54.772L92.635 61.0098C92.4846 61.3791 92.3412 61.749 92.2052 62.1189C91.4454 64.1406 90.9121 66.1579 90.6033 68.1197L83.6587 61.8819C83.9668 59.9201 84.5008 57.9034 85.2606 55.8811C85.3966 55.5111 85.54 55.1413 85.6904 54.772Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6595 61.8818L90.6041 68.1197C90.4238 69.2668 90.3209 70.3946 90.2947 71.4937L83.3501 65.2559C83.3763 64.1568 83.4792 63.029 83.6595 61.8818Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3498 65.2573L90.2944 71.4952C90.2769 72.2381 90.2944 72.9673 90.3474 73.6809L83.4028 67.4431C83.3498 66.7301 83.3323 66.0003 83.3498 65.2573Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4023 67.4429L90.3469 73.6807C90.39 74.2658 90.4573 74.8397 90.5478 75.4005L83.6032 69.1626C83.5127 68.6019 83.446 68.028 83.4023 67.4429Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.603 69.1616L90.5476 75.3995C90.6268 75.8923 90.7248 76.3751 90.8408 76.8473L83.8962 70.6094C83.7802 70.1372 83.6829 69.6544 83.603 69.1616Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8965 70.6094L90.8411 76.8472C90.9471 77.2789 91.0681 77.7012 91.2047 78.1135L84.2602 71.8757C84.1235 71.4633 84.0025 71.041 83.8965 70.6094Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2603 71.8755L91.2048 78.1133C91.3321 78.4988 91.4731 78.8762 91.6278 79.2436L84.6832 73.0058C84.5285 72.6384 84.3875 72.261 84.2603 71.8755Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6826 73.0068L91.6272 79.2447C91.747 79.5304 91.8749 79.8105 92.0108 80.0843C92.0445 80.1535 92.0788 80.2228 92.1138 80.2914L85.1692 74.0536C85.1342 73.9849 85.0999 73.9163 85.0662 73.8465C84.9309 73.5726 84.803 73.2925 84.6826 73.0068Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1694 74.0537L92.114 80.2916C92.2906 80.639 92.4802 80.9758 92.6817 81.3021L85.7371 75.0642C85.535 74.738 85.346 74.4005 85.1694 74.0537Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7373 75.064L92.6819 81.3018C92.8734 81.6112 93.0755 81.9112 93.2882 82.2013L86.3436 75.9635C86.1303 75.6734 85.9282 75.3734 85.7373 75.064Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3438 75.9644L93.2883 82.2022C93.5042 82.4966 93.7312 82.7811 93.9689 83.0549L87.0243 76.8171C86.7866 76.5432 86.5596 76.2588 86.3438 75.9644Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0239 76.8174L93.9685 83.0552C94.2112 83.3353 94.465 83.6048 94.7295 83.863L87.7849 77.6252C87.5205 77.3669 87.2666 77.0975 87.0239 76.8174Z",
    fill: "#3D2780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7852 77.6245L94.7297 83.8624C94.8626 83.9921 94.998 84.1187 95.1358 84.2422L88.1912 78.0044C88.0528 77.8809 87.918 77.7543 87.7852 77.6245Z",
    fill: "#3F2782"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.462 41.0386L111.408 47.2764L108.158 50.5295L101.212 44.2916L104.462 41.0386Z",
    fill: "#EEC82B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.212 44.2916L104.462 41.0386L111.408 47.2764L108.158 50.5295L101.212 44.2916Z",
    fill: "#F3E9BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 44,
    width: 8,
    height: 7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.157 50.5284L101.213 44.2905C101.235 44.2905 101.298 44.2905 101.394 44.2905C103.709 46.3696 106.024 48.4493 108.339 50.5284C108.242 50.5284 108.179 50.5284 108.157 50.5284Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.212 44.2905L108.157 50.5284C108.378 50.5284 112.59 50.5284 113.791 50.5284C114.558 50.5284 116.11 50.7486 117.139 51.6724L110.194 45.4345C109.166 44.5107 107.613 44.2905 106.846 44.2905C105.646 44.2905 101.434 44.2905 101.212 44.2905Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 44,
    width: 8,
    height: 7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.78 44.2905L108.725 50.5284C108.372 50.5284 108.168 50.5284 108.157 50.5284L101.212 44.2905C101.223 44.2905 101.428 44.2905 101.78 44.2905Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.78 44.2905L108.725 50.5284C108.372 50.5284 108.168 50.5284 108.157 50.5284L101.212 44.2905C101.223 44.2905 101.428 44.2905 101.78 44.2905Z",
    fill: "#3F2782"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.034 41.0386L111.979 47.2764H111.408L104.462 41.0386H105.034Z",
    fill: "#3F2782"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.462 41.0386H105.034L111.979 47.2764H111.408L104.462 41.0386Z",
    fill: "#E6DCB3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.78 44.2916L105.034 41.0386L111.979 47.2764L108.725 50.5295L101.78 44.2916Z",
    fill: "#F3D760"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.034 41.0386L111.979 47.2764L108.725 50.5295L101.78 44.2916L105.034 41.0386Z",
    fill: "#F3E9BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 30,
    width: 8,
    height: 7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.89 36.2681C124.649 36.2681 124.406 36.2731 124.161 36.2825L117.217 30.0446C117.461 30.0353 117.705 30.0303 117.945 30.0303C117.945 30.0303 117.945 30.0303 117.946 30.0303C120.26 32.11 122.575 34.189 124.89 36.2681Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6152L135.012 39.853C134.211 39.1338 133.322 38.5138 132.356 38.0035C130.184 36.8769 127.645 36.2681 124.89 36.2681C124.649 36.2681 124.406 36.2731 124.161 36.2825L117.217 30.0446C117.461 30.0353 117.705 30.0303 117.945 30.0303C120.701 30.0303 123.239 30.6391 125.411 31.7657C126.376 32.2759 127.266 32.8959 128.067 33.6152Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 30,
    width: 8,
    height: 7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.045C117.461 30.0356 117.704 30.0312 117.945 30.0312L124.889 36.2691C124.648 36.2691 124.405 36.2741 124.161 36.2828C122.078 34.4115 119.3 31.9163 117.216 30.045Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.045L124.161 36.2829C124.405 36.2735 124.648 36.2691 124.889 36.2691L117.945 30.0313C117.704 30.0307 117.461 30.0357 117.216 30.045Z",
    fill: "#3F2782"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7173 51.0162L102.044 47.7881L108.989 54.0259L105.662 57.254L98.7173 51.0162Z",
    fill: "#3F2782"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.044 47.7881L108.989 54.0259L105.662 57.254L98.7173 51.0162L102.044 47.7881Z",
    fill: "#3F2782"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M102.048 47.7881L108.993 54.0259L105.662 57.254L98.7173 51.0162L102.048 47.7881Z",
    fill: "#EDC82B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7173 51.0162L102.048 47.7881L108.993 54.0259L105.662 57.254L98.7173 51.0162Z",
    fill: "#F3E8BE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.616 47.7881L109.561 54.0259H108.993L102.048 47.7881H102.616Z",
    fill: "#3F2782"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.048 47.7881H102.616L109.561 54.0259H108.993L102.048 47.7881Z",
    fill: "#E6DCB3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2847 51.0162L102.616 47.7881L109.561 54.0259L106.229 57.254L99.2847 51.0162Z",
    fill: "#F3D660"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.616 47.7881L109.561 54.0259L106.229 57.254L99.2847 51.0162L102.616 47.7881Z",
    fill: "#F3E8BE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M130.798 47.2769L127.695 50.5293L122.492 50.5879C122.603 50.8967 122.694 51.3682 122.724 51.9565C122.754 52.5447 122.722 53.2496 122.588 54.0256H128.149L125.08 57.2537H122.035H121.467C116.964 65.5288 108.897 65.787 108.473 65.8008L113.914 81.3492H109.746L103.872 66.4233L105.022 63.3212C105.022 63.3212 105.022 63.3212 105.59 63.3212C105.59 63.3212 105.59 63.3212 108.691 63.3212H109.259C113.512 63.3212 116.62 60.3114 117.97 57.2537H106.229L109.56 54.0256H118.144H118.711C118.658 51.0645 115.553 50.5299 114.358 50.5299H113.79C112.036 50.5299 109.429 50.5299 109.292 50.5299C108.939 50.5299 108.735 50.5299 108.724 50.5299L111.978 47.2775H130.798V47.2769Z",
    fill: "#F0D45F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 44,
    width: 13,
    height: 7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M108.338 50.5284C108.095 50.31 107.771 50.0181 107.527 49.7998C107.269 49.5684 106.925 49.259 106.667 49.0275C106.399 48.7868 106.042 48.4661 105.774 48.226C105.501 47.9808 105.138 47.6546 104.865 47.4095C104.593 47.1643 104.229 46.8381 103.956 46.5929C103.689 46.3528 103.331 46.0315 103.064 45.7914C102.805 45.5599 102.462 45.2505 102.203 45.0191C101.96 44.8008 101.636 44.5089 101.393 44.2905C102.251 44.2905 105.765 44.2905 106.845 44.2905C109.16 46.3696 111.475 48.4493 113.79 50.5284C112.712 50.5284 109.197 50.5284 108.338 50.5284Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.212 44.2905L108.157 50.5284C108.378 50.5284 112.591 50.5284 113.791 50.5284C114.558 50.5284 116.11 50.7486 117.139 51.6724L110.195 45.4345C109.166 44.5107 107.614 44.2905 106.846 44.2905C105.646 44.2905 101.434 44.2905 101.212 44.2905Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 44,
    width: 13,
    height: 7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M106.847 44.2905L113.791 50.5284C112.037 50.5284 109.43 50.5284 109.293 50.5284C108.94 50.5284 108.735 50.5284 108.725 50.5284L101.78 44.2905C101.791 44.2905 101.995 44.2905 102.348 44.2905C102.485 44.2905 105.092 44.2905 106.847 44.2905Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.847 44.2905L113.791 50.5284C112.037 50.5284 109.43 50.5284 109.293 50.5284C108.94 50.5284 108.735 50.5284 108.725 50.5284L101.78 44.2905C101.791 44.2905 101.995 44.2905 102.348 44.2905C102.485 44.2905 105.092 44.2905 106.847 44.2905Z",
    fill: "white"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 44.292H107.414L114.358 50.5298H113.791L106.846 44.292Z",
    fill: "#E6DCB3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.292L114.358 50.5298H113.791L106.846 44.292H107.414Z",
    fill: "#3F2782"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M123.854 41.0386L130.798 47.2764H111.979L105.034 41.0386H123.854Z",
    fill: "#3F2782"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M105.034 41.0386H123.854L130.798 47.2764H111.979L105.034 41.0386Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 44,
    width: 10,
    height: 8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M114.359 50.5284L107.414 44.2905C107.997 44.2905 109.032 44.4178 109.947 44.8831C112.262 46.9622 114.577 49.0419 116.892 51.121C115.977 50.655 114.941 50.5284 114.359 50.5284Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.2905L114.359 50.5284C115.125 50.5284 116.678 50.7486 117.707 51.6724L110.763 45.4345C109.733 44.5107 108.181 44.2905 107.414 44.2905Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 44,
    width: 11,
    height: 8
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 50.5284C111.476 48.4493 109.162 46.3696 106.847 44.2905C107.444 44.2905 108.519 44.424 109.451 44.9206C111.766 46.9996 114.08 49.0787 116.395 51.1578C114.08 49.0787 111.766 46.9996 109.451 44.9206C109.561 44.9792 109.668 45.0422 109.773 45.1114C112.088 47.1905 114.403 49.2702 116.717 51.3493C115.724 50.6949 114.459 50.5284 113.791 50.5284Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.212 44.2905L108.157 50.5284C108.378 50.5284 112.591 50.5284 113.791 50.5284C114.558 50.5284 116.11 50.7486 117.139 51.6724L110.195 45.4345C109.166 44.5107 107.614 44.2905 106.846 44.2905C105.646 44.2905 101.434 44.2905 101.212 44.2905Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 44,
    width: 12,
    height: 8
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.194 45.4345L117.139 51.6724C116.11 50.7486 114.558 50.5284 113.79 50.5284L106.846 44.2905C107.613 44.2905 109.166 44.5107 110.194 45.4345Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.194 45.4345L117.139 51.6724C116.11 50.7486 114.558 50.5284 113.79 50.5284L106.846 44.2905C107.613 44.2905 109.166 44.5107 110.194 45.4345Z",
    fill: "white"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 47.7275L118.145 53.9654L109.561 54.024L102.616 47.7862L111.2 47.7275Z",
    fill: "#3F2782"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.616 47.7881H111.2L118.145 54.0259H109.561L102.616 47.7881Z",
    fill: "#3F2782"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7173 51.0151H110.454L117.398 57.253H105.662L98.7173 51.0151Z",
    fill: "#3F2782"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2849 51.0151L106.23 57.253H105.662L98.7173 51.0151H99.2849Z",
    fill: "#E6DCB3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M102.616 47.7881L99.2849 51.0162H98.7173L102.048 47.7881H102.616Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 30,
    width: 9,
    height: 7
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.76 36.5015C127.384 36.4398 127.001 36.3899 126.613 36.3531C126.37 36.1348 126.046 35.8428 125.802 35.6245C125.544 35.3925 125.2 35.0837 124.942 34.8523C124.341 34.3127 123.741 33.7737 123.14 33.2342C122.868 32.989 122.504 32.6628 122.231 32.4176C121.964 32.1775 121.606 31.8562 121.339 31.6161C121.08 31.3846 120.737 31.0752 120.478 30.8438C120.235 30.6255 119.911 30.3336 119.667 30.1152C120.055 30.1527 120.438 30.2019 120.815 30.2637C123.131 32.3428 125.446 34.4225 127.76 36.5015Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6166L135.012 39.8545C134.211 39.1353 133.322 38.5152 132.356 38.005C130.184 36.8784 127.645 36.2696 124.89 36.2696C124.649 36.2696 124.406 36.2746 124.161 36.2839L117.217 30.0461C117.461 30.0367 117.705 30.0317 117.945 30.0317C120.701 30.0317 123.239 30.6406 125.411 31.7671C126.376 32.2774 127.266 32.8974 128.067 33.6166Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 57,
    width: 9,
    height: 7
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0779 57.0835L105.022 63.3213C104.455 63.3213 104.455 63.3213 104.455 63.3213L97.5103 57.0835C97.5103 57.0835 97.5103 57.0835 98.0779 57.0835Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0779 57.0835L105.022 63.3213C104.455 63.3213 104.455 63.3213 104.455 63.3213L97.5103 57.0835C97.5103 57.0835 97.5103 57.0835 98.0779 57.0835Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 57,
    width: 9,
    height: 7
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5103 57.0835C97.5103 57.0835 97.5103 57.0835 98.0779 57.0835L105.022 63.3213C104.455 63.3213 104.455 63.3213 104.455 63.3213C102.372 61.45 99.5937 58.9548 97.5103 57.0835Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5103 57.0835L104.455 63.3213C104.455 63.3213 104.455 63.3213 105.022 63.3213L98.0779 57.0835C97.5103 57.0835 97.5103 57.0835 97.5103 57.0835Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 30,
    width: 10,
    height: 7
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M129.328 36.8364C128.818 36.6998 128.295 36.5875 127.761 36.4996C127.518 36.2812 127.194 35.9893 126.95 35.771C126.691 35.5396 126.348 35.2302 126.09 34.9987C125.822 34.758 125.465 34.4373 125.197 34.1972C124.924 33.952 124.561 33.6258 124.288 33.3806C124.015 33.1355 123.652 32.8093 123.379 32.5641C123.112 32.3233 122.755 32.0027 122.487 31.7625C122.228 31.5305 121.885 31.2217 121.626 30.9903C121.383 30.772 121.059 30.48 120.815 30.2617C121.349 30.3497 121.872 30.462 122.382 30.5986C124.697 32.6776 127.012 34.7573 129.328 36.8364Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6161L135.012 39.854C134.211 39.1348 133.322 38.5147 132.356 38.0045C130.184 36.8779 127.645 36.2691 124.89 36.2691C124.649 36.2691 124.406 36.2741 124.161 36.2834L117.217 30.0456C117.461 30.0362 117.705 30.0312 117.945 30.0312C120.701 30.0312 123.239 30.6401 125.411 31.7666C126.376 32.2769 127.266 32.8969 128.067 33.6161Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 30,
    width: 8,
    height: 7
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M127.887 35.5434C126.052 33.8953 124.217 32.2473 122.382 30.5986C122.389 30.6005 122.395 30.6024 122.402 30.6036C124.717 32.6827 127.032 34.7624 129.347 36.8415C129.341 36.8396 129.334 36.8377 129.327 36.8358C128.847 36.4054 128.368 35.9744 127.887 35.5434Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6166L135.012 39.8545C134.211 39.1353 133.322 38.5152 132.356 38.005C130.184 36.8784 127.645 36.2696 124.89 36.2696C124.649 36.2696 124.406 36.2746 124.161 36.2839L117.217 30.0461C117.461 30.0367 117.705 30.0317 117.945 30.0317C120.701 30.0317 123.239 30.6406 125.411 31.7671C126.376 32.2774 127.266 32.8974 128.067 33.6166Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 57,
    width: 8,
    height: 7
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6453 57.0835L105.59 63.3213C105.022 63.3213 105.022 63.3213 105.022 63.3213L98.0776 57.0835C98.0776 57.0835 98.0776 57.0835 98.6453 57.0835Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6453 57.0835L105.59 63.3213C105.022 63.3213 105.022 63.3213 105.022 63.3213L98.0776 57.0835C98.0776 57.0835 98.0776 57.0835 98.6453 57.0835Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 57,
    width: 8,
    height: 7
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0776 57.0835C98.0776 57.0835 98.0776 57.0835 98.6453 57.0835L105.59 63.3213C105.022 63.3213 105.022 63.3213 105.022 63.3213C102.939 61.45 100.161 58.9548 98.0776 57.0835Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0776 57.0835L105.022 63.3213C105.022 63.3213 105.022 63.3213 105.59 63.3213L98.6453 57.0835C98.0776 57.0835 98.0776 57.0835 98.0776 57.0835Z",
    fill: "#E7CB5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 44,
    width: 8,
    height: 8
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M116.894 51.1224C116.894 51.1218 116.893 51.1218 116.892 51.1211C116.649 50.9028 116.324 50.6109 116.08 50.3926C115.822 50.1611 115.478 49.8517 115.22 49.6203C114.953 49.3795 114.596 49.0589 114.328 48.8188C114.055 48.5736 113.691 48.2474 113.419 48.0022C113.146 47.7571 112.782 47.4308 112.51 47.1857C112.242 46.9455 111.885 46.6243 111.617 46.3841C111.36 46.1521 111.015 45.8433 110.758 45.6119C110.514 45.3936 110.19 45.1016 109.947 44.8833C109.948 44.8839 109.949 44.8845 109.95 44.8845C112.265 46.9642 114.58 49.0433 116.894 51.1224Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.291L114.359 50.5289C115.125 50.5289 116.678 50.749 117.707 51.6729L110.763 45.435C109.733 44.5112 108.181 44.291 107.414 44.291Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 44,
    width: 8,
    height: 8
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M116.98 51.169C116.952 51.1534 116.923 51.139 116.894 51.1241C114.579 49.045 112.265 46.9659 109.95 44.8862C109.978 44.9006 110.006 44.9155 110.035 44.9311C112.35 47.0102 114.665 49.0893 116.98 51.169Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.2935L114.359 50.5313C115.125 50.5313 116.678 50.7515 117.707 51.6753L110.763 45.4375C109.733 44.5136 108.181 44.2935 107.414 44.2935Z",
    fill: "#3F2782"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5098 57.0825L104.455 63.3204L103.305 66.4175L96.3608 60.1796L97.5098 57.0825Z",
    fill: "#F5CF2C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3594 60.1846L97.5103 57.0825L104.455 63.3204L103.304 66.4224L96.3594 60.1846Z",
    fill: "#FBF0C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0776 57.0825L105.023 63.3204L103.871 66.4224L96.9268 60.1846L98.0776 57.0825Z",
    fill: "#FBF0C4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9268 60.1846L98.0776 57.0825L105.023 63.3204L103.871 66.4224L96.9268 60.1846Z",
    fill: "#FBDD63"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 44,
    width: 11,
    height: 8
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M110.742 45.4355L117.687 51.6733C116.658 50.7495 115.12 50.5318 114.359 50.5318L107.414 44.2939C108.176 44.2946 109.713 44.5117 110.742 45.4355Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.742 45.4355L117.687 51.6733C116.658 50.7495 115.12 50.5318 114.359 50.5318L107.414 44.2939C108.176 44.2946 109.713 44.5117 110.742 45.4355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 45,
    width: 9,
    height: 9
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.139 51.6734C117.715 52.1899 118.126 52.926 118.145 53.9664L111.2 47.7286C111.181 46.6881 110.77 45.952 110.195 45.4355C112.278 47.3069 115.056 49.802 117.139 51.6734Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.201 47.7285L118.145 53.9663C118.144 53.8964 118.141 53.8272 118.136 53.7598L111.191 47.522C111.196 47.59 111.199 47.6586 111.201 47.7285Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.191 47.5218L118.136 53.7596C118.128 53.6517 118.116 53.5475 118.099 53.4459L111.155 47.208C111.171 47.3097 111.183 47.4139 111.191 47.5218Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.155 47.2086L118.1 53.4464C118.085 53.3554 118.067 53.2668 118.046 53.1807L111.102 46.9429C111.123 47.0283 111.141 47.1169 111.155 47.2086Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.101 46.9428L118.046 53.1806C118.027 53.1008 118.004 53.0228 117.979 52.9473L111.035 46.7095C111.06 46.785 111.082 46.8623 111.101 46.9428Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.034 46.7089L117.979 52.9468C117.954 52.8719 117.927 52.7995 117.897 52.7291L110.953 46.4912C110.983 46.5611 111.009 46.6341 111.034 46.7089Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.953 46.4911L117.897 52.7289C117.868 52.6591 117.836 52.5911 117.803 52.525L110.858 46.2871C110.892 46.3532 110.923 46.4212 110.953 46.4911Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.858 46.2889L117.803 52.5267C117.768 52.4588 117.73 52.3926 117.691 52.3296L110.747 46.0918C110.786 46.1548 110.823 46.2209 110.858 46.2889Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.747 46.0898L117.691 52.3276C117.651 52.2622 117.608 52.1985 117.563 52.1368L110.618 45.8989C110.663 45.9607 110.706 46.0243 110.747 46.0898Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.618 45.9007L117.563 52.1386C117.515 52.0743 117.466 52.0119 117.414 51.9527L110.47 45.7148C110.521 45.7741 110.571 45.8365 110.618 45.9007Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.469 45.7149L117.413 51.9527C117.356 51.8866 117.297 51.8236 117.234 51.7637L110.29 45.5259C110.352 45.5858 110.412 45.6488 110.469 45.7149Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29 45.5248L117.235 51.7626C117.204 51.732 117.172 51.7021 117.139 51.6734L110.195 45.4355C110.227 45.4649 110.258 45.4942 110.29 45.5248Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 45,
    width: 9,
    height: 9
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.139 51.6734C117.715 52.1899 118.126 52.926 118.145 53.967L111.2 47.7292C111.181 46.6887 110.769 45.952 110.195 45.4355C112.278 47.3069 115.056 49.802 117.139 51.6734Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.194 45.4355L117.139 51.6734C117.171 51.7027 117.203 51.732 117.234 51.7626L110.29 45.5248C110.259 45.4942 110.227 45.4649 110.194 45.4355Z",
    fill: "#E7C32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.291 45.5259L117.235 51.7637C117.297 51.8242 117.357 51.8872 117.414 51.9534L110.47 45.7155C110.412 45.6494 110.352 45.5864 110.291 45.5259Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.469 45.7148L117.413 51.9527C117.465 52.0126 117.514 52.0743 117.562 52.1386L110.617 45.9007C110.57 45.8365 110.521 45.7741 110.469 45.7148Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.617 45.9014L117.562 52.1392C117.607 52.2003 117.65 52.264 117.69 52.3301L110.746 46.0922C110.706 46.0261 110.663 45.9625 110.617 45.9014Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.747 46.0903L117.691 52.3282C117.73 52.3918 117.768 52.4573 117.803 52.5253L110.858 46.2875C110.823 46.2201 110.786 46.154 110.747 46.0903Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.858 46.2891L117.803 52.5269C117.836 52.5924 117.868 52.6604 117.897 52.7309L110.953 46.493C110.923 46.4225 110.892 46.3546 110.858 46.2891Z",
    fill: "#ECC72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.953 46.4912L117.898 52.7291C117.928 52.7995 117.954 52.8719 117.979 52.9468L111.035 46.7089C111.01 46.6347 110.983 46.5617 110.953 46.4912Z",
    fill: "#EDC82B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.035 46.7095L117.979 52.9473C118.004 53.0228 118.027 53.1008 118.046 53.1806L111.101 46.9428C111.082 46.8623 111.06 46.785 111.035 46.7095Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.102 46.9429L118.046 53.1807C118.067 53.2668 118.085 53.3554 118.1 53.4464L111.155 47.2086C111.141 47.1169 111.123 47.0283 111.102 46.9429Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.155 47.2095L118.1 53.4473C118.116 53.5484 118.128 53.6525 118.136 53.7611L111.191 47.5232C111.184 47.4147 111.171 47.3105 111.155 47.2095Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.191 47.522L118.136 53.7598C118.141 53.8272 118.144 53.8958 118.145 53.9663L111.201 47.7285C111.199 47.6586 111.196 47.5893 111.191 47.522Z",
    fill: "#F1CB2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 45,
    width: 9,
    height: 7
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M116.718 51.3453C116.475 51.1269 116.151 50.835 115.907 50.6167C115.649 50.3853 115.305 50.0759 115.047 49.8444C114.779 49.6037 114.422 49.283 114.154 49.0429C113.881 48.7977 113.518 48.4715 113.245 48.2263C112.645 47.6868 112.044 47.1478 111.444 46.6082C110.887 46.108 110.33 45.6077 109.772 45.1074C109.92 45.2041 110.061 45.3114 110.194 45.4305L117.138 51.6684C117.006 51.5492 116.866 51.442 116.718 51.3453Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.212 44.2871L108.157 50.525C108.378 50.525 112.591 50.525 113.791 50.525C114.558 50.525 116.11 50.7451 117.139 51.669L110.195 45.4311C109.166 44.5073 107.614 44.2871 106.846 44.2871C105.646 44.2871 101.434 44.2871 101.212 44.2871Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 45,
    width: 9,
    height: 10
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.686 51.6651C118.272 52.1909 118.692 52.9457 118.712 54.0199L111.767 47.782C111.748 46.7079 111.327 45.9531 110.742 45.4272C112.825 47.2986 115.603 49.7937 117.686 51.6651Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.768 47.7824L118.712 54.0202C118.711 53.9466 118.708 53.8742 118.703 53.8038L111.758 47.5659C111.763 47.6364 111.766 47.7088 111.768 47.7824Z",
    fill: "#F7DA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.758 47.5656L118.702 53.8034C118.694 53.6918 118.682 53.5839 118.665 53.4791L111.72 47.2412C111.737 47.346 111.75 47.4539 111.758 47.5656Z",
    fill: "#F6D961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.721 47.2409L118.665 53.4788C118.65 53.3839 118.631 53.2922 118.61 53.2037L111.665 46.9658C111.687 47.0544 111.706 47.1461 111.721 47.2409Z",
    fill: "#F5D861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.665 46.9661L118.609 53.2039C118.589 53.1216 118.566 53.0418 118.541 52.9644L111.596 46.7266C111.622 46.8039 111.645 46.8838 111.665 46.9661Z",
    fill: "#F4D761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.596 46.7259L118.541 52.9637C118.515 52.887 118.487 52.8122 118.457 52.7398L111.513 46.502C111.543 46.5743 111.571 46.6485 111.596 46.7259Z",
    fill: "#F3D660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.513 46.5013L118.457 52.7392C118.427 52.6674 118.395 52.5982 118.36 52.5308L111.416 46.293C111.45 46.3603 111.483 46.4296 111.513 46.5013Z",
    fill: "#F2D560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.415 46.2952L118.36 52.5331C118.324 52.4638 118.286 52.3965 118.246 52.3316L111.301 46.0938C111.342 46.1586 111.38 46.226 111.415 46.2952Z",
    fill: "#F1D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.301 46.0921L118.246 52.3299C118.204 52.2626 118.16 52.1977 118.114 52.1353L111.169 45.8975C111.216 45.9598 111.26 46.0247 111.301 46.0921Z",
    fill: "#F0D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17 45.8975L118.115 52.1353C118.067 52.0698 118.016 52.0068 117.964 51.9463L111.019 45.7085C111.071 45.769 111.122 45.832 111.17 45.8975Z",
    fill: "#EFD35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.019 45.708L117.964 51.9458C117.906 51.8791 117.846 51.8161 117.783 51.7549L110.839 45.5171C110.901 45.5782 110.961 45.6418 111.019 45.708Z",
    fill: "#EED25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.839 45.5183L117.784 51.7562C117.752 51.725 117.719 51.6944 117.686 51.6651L110.742 45.4272C110.775 45.4572 110.807 45.4878 110.839 45.5183Z",
    fill: "#EDD15E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 45,
    width: 9,
    height: 9
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71 53.8841C118.694 53.8704 118.674 53.8523 118.659 53.8385C118.642 53.8242 118.621 53.8049 118.605 53.7899C118.588 53.7749 118.566 53.755 118.55 53.74C118.533 53.7244 118.51 53.7044 118.493 53.6888C118.476 53.6732 118.453 53.6533 118.436 53.6377C118.419 53.6227 118.397 53.6028 118.38 53.5878C118.364 53.5734 118.342 53.5541 118.326 53.5398C118.311 53.526 118.291 53.5079 118.276 53.4942C118.047 53.289 117.744 53.0158 117.515 52.8112C117.273 52.5941 116.951 52.304 116.709 52.087C116.459 51.8611 116.124 51.5611 115.873 51.3353C115.617 51.1057 115.277 50.7995 115.021 50.5699C114.765 50.3404 114.424 50.0341 114.169 49.8045C113.918 49.5793 113.583 49.2787 113.332 49.0529C113.09 48.8358 112.768 48.5457 112.526 48.3287C112.298 48.1241 111.994 47.8508 111.766 47.6456C111.727 46.6488 111.322 45.9377 110.762 45.4355L117.707 51.6734C118.266 52.1762 118.671 52.8873 118.71 53.8841Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.762 45.438L117.706 51.6758C117.739 51.7052 117.771 51.7345 117.802 51.765L110.857 45.5272C110.826 45.4966 110.794 45.4673 110.762 45.438Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.857 45.5278L117.802 51.7657C117.863 51.8262 117.923 51.8892 117.98 51.9547L111.035 45.7168C110.979 45.6513 110.919 45.5883 110.857 45.5278Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.036 45.7168L117.98 51.9546C118.032 52.0145 118.081 52.0763 118.129 52.1405L111.184 45.9027C111.137 45.8384 111.087 45.7761 111.036 45.7168Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.185 45.9028L118.129 52.1407C118.174 52.2018 118.217 52.2654 118.258 52.3316L111.313 46.0937C111.273 46.0276 111.229 45.964 111.185 45.9028Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.313 46.0928L118.258 52.3306C118.297 52.3942 118.334 52.4597 118.369 52.5277L111.425 46.2899C111.39 46.2225 111.352 46.1564 111.313 46.0928Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.425 46.2905L118.369 52.5284C118.403 52.5939 118.435 52.6619 118.464 52.7323L111.52 46.4945C111.49 46.424 111.458 46.356 111.425 46.2905Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.52 46.4937L118.464 52.7315C118.493 52.802 118.521 52.8743 118.546 52.9492L111.601 46.7114C111.576 46.6371 111.549 46.5641 111.52 46.4937Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.602 46.7119L118.546 52.9498C118.571 53.0252 118.594 53.1032 118.613 53.183L111.668 46.9452C111.649 46.8647 111.627 46.7874 111.602 46.7119Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.668 46.9448L118.613 53.1827C118.634 53.2688 118.652 53.3573 118.666 53.4484L111.722 47.2106C111.707 47.1189 111.689 47.0303 111.668 46.9448Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.722 47.2119L118.666 53.4498C118.682 53.5508 118.694 53.6556 118.702 53.7635L111.758 47.5257C111.75 47.4171 111.738 47.313 111.722 47.2119Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.758 47.5254L118.702 53.7632C118.707 53.8306 118.711 53.8999 118.712 53.9697L111.767 47.7319C111.766 47.662 111.763 47.5934 111.758 47.5254Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 44,
    width: 8,
    height: 8
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M116.98 51.1666C115.823 50.1267 114.666 49.0875 113.508 48.0476C113.235 47.8031 112.872 47.4763 112.599 47.2311C112.331 46.9909 111.975 46.6697 111.706 46.4295C111.448 46.1981 111.104 45.8887 110.846 45.6573C110.603 45.439 110.278 45.147 110.035 44.9287C110.293 45.0672 110.54 45.2344 110.762 45.434L117.706 51.6718C117.485 51.4722 117.238 51.3057 116.98 51.1666Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.2915L114.359 50.5293C115.125 50.5293 116.678 50.7495 117.707 51.6734L110.763 45.4355C109.733 44.5117 108.181 44.2915 107.414 44.2915Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 57,
    width: 11,
    height: 7
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0835L108.691 63.3213C105.59 63.3213 105.59 63.3213 105.59 63.3213L98.6455 57.0835C98.6455 57.0835 98.6455 57.0835 101.746 57.0835Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0835L108.691 63.3213C105.59 63.3213 105.59 63.3213 105.59 63.3213L98.6455 57.0835C98.6455 57.0835 98.6455 57.0835 101.746 57.0835Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 57,
    width: 11,
    height: 7
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6455 57.0835C98.6455 57.0835 98.6455 57.0835 101.746 57.0835L108.691 63.3213C105.59 63.3213 105.59 63.3213 105.59 63.3213C103.507 61.45 100.729 58.9548 98.6455 57.0835Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6455 57.0835L105.59 63.3213C105.59 63.3213 105.59 63.3213 108.691 63.3213L101.746 57.0835C98.6455 57.0835 98.6455 57.0835 98.6455 57.0835Z",
    fill: "#E7CB5B"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M111.026 51.0151L117.97 57.253H106.229L99.2847 51.0151H111.026Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 54,
    width: 15,
    height: 10
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0843C104.443 57.0843 106.682 55.8716 108.303 54.2036L115.248 60.4415C113.627 62.1095 111.388 63.3221 108.691 63.3221C106.608 61.4507 103.83 58.9556 101.746 57.0843Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0845L108.691 63.3223C109.7 63.3223 110.644 63.1526 111.517 62.8526L104.572 56.6147C103.7 56.9148 102.755 57.0845 101.746 57.0845Z",
    fill: "#6D44E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.572 56.6154L111.517 62.8533C111.753 62.7722 111.983 62.6818 112.209 62.5826L105.264 56.3447C105.039 56.4433 104.808 56.5344 104.572 56.6154Z",
    fill: "#E8C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.264 56.3442L112.209 62.582C112.384 62.5047 112.556 62.4223 112.723 62.335L105.779 56.0972C105.61 56.1845 105.439 56.2668 105.264 56.3442Z",
    fill: "#E9C739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.779 56.098L112.723 62.3359C112.866 62.2617 113.007 62.1837 113.145 62.1026L106.2 55.8647C106.063 55.9465 105.922 56.0238 105.779 56.098Z",
    fill: "#EAC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 55.8636L113.146 62.1015C113.272 62.0272 113.397 61.9505 113.519 61.8707L106.574 55.6328C106.452 55.7127 106.327 55.7894 106.201 55.8636Z",
    fill: "#EBC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.574 55.6333L113.518 61.8711C113.633 61.7963 113.746 61.7195 113.857 61.6397L106.912 55.4019C106.802 55.4817 106.689 55.559 106.574 55.6333Z",
    fill: "#ECC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.913 55.4025L113.858 61.6403C113.964 61.5642 114.069 61.4863 114.173 61.4058L107.228 55.168C107.125 55.2478 107.02 55.3264 106.913 55.4025Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.227 55.1674L114.172 61.4053C114.273 61.3267 114.372 61.2468 114.47 61.1651L107.525 54.9272C107.428 55.009 107.328 55.0888 107.227 55.1674Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.525 54.9272L114.47 61.1651C114.567 61.0834 114.663 61.0004 114.756 60.9156L107.812 54.6777C107.718 54.7626 107.623 54.8455 107.525 54.9272Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.812 54.6784L114.756 60.9162C114.851 60.8307 114.944 60.7434 115.035 60.6548L108.09 54.417C107.999 54.5056 107.906 54.5929 107.812 54.6784Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.091 54.4163L115.035 60.6542C115.107 60.5843 115.178 60.5132 115.248 60.4415L108.304 54.2036C108.234 54.2753 108.163 54.3465 108.091 54.4163Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 54,
    width: 15,
    height: 10
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M115.248 60.4415C113.627 62.1095 111.388 63.3221 108.691 63.3221L101.746 57.0843C104.443 57.0843 106.682 55.8716 108.303 54.2036C110.618 56.2827 112.933 58.3624 115.248 60.4415Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.362 54.1416L115.307 60.3794C115.287 60.4 115.268 60.4206 115.248 60.4406C115.178 60.5123 115.107 60.5834 115.035 60.6533L108.09 54.4154C108.162 54.3456 108.233 54.2745 108.303 54.2027C108.323 54.1821 108.342 54.1622 108.362 54.1416Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09 54.4146L115.035 60.6524C114.944 60.741 114.851 60.8283 114.756 60.9138L107.812 54.6759C107.906 54.5905 107.999 54.5031 108.09 54.4146Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.812 54.6772L114.756 60.9151C114.663 60.9999 114.567 61.0829 114.47 61.1646L107.525 54.9268C107.623 54.845 107.718 54.7621 107.812 54.6772Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.525 54.9258L114.47 61.1636C114.372 61.2453 114.273 61.3258 114.172 61.4038L107.227 55.1659C107.328 55.0873 107.428 55.0075 107.525 54.9258Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.227 55.1655L114.172 61.4034C114.069 61.4832 113.963 61.5618 113.857 61.6379L106.912 55.4001C107.019 55.324 107.124 55.2454 107.227 55.1655Z",
    fill: "#E7C32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.913 55.4009L113.858 61.6387C113.746 61.7179 113.634 61.7953 113.519 61.8701L106.574 55.6323C106.688 55.5575 106.802 55.4801 106.913 55.4009Z",
    fill: "#E6C22A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.573 55.6309L113.518 61.8687C113.396 61.9485 113.271 62.0253 113.145 62.0995L106.2 55.8617C106.327 55.7874 106.452 55.7107 106.573 55.6309Z",
    fill: "#E5C129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 55.8618L113.146 62.0997C113.008 62.1808 112.867 62.2587 112.724 62.333L105.779 56.0951C105.922 56.0209 106.063 55.9435 106.201 55.8618Z",
    fill: "#E4C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.779 56.0957L112.723 62.3335C112.555 62.4209 112.383 62.5032 112.209 62.5806L105.264 56.3427C105.439 56.2654 105.61 56.183 105.779 56.0957Z",
    fill: "#E3C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.264 56.3423L112.209 62.5801C111.983 62.6793 111.753 62.7698 111.517 62.8508L104.572 56.613C104.808 56.5325 105.039 56.4415 105.264 56.3423Z",
    fill: "#E2BF29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.572 56.6147L111.517 62.8526C110.645 63.1526 109.7 63.3223 108.691 63.3223L101.746 57.0845C102.755 57.0838 103.7 56.9142 104.572 56.6147Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 54,
    width: 15,
    height: 10
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M108.303 54.2036L115.248 60.4415C113.629 62.1095 111.39 63.3221 108.691 63.3221L101.746 57.0843C104.446 57.0843 106.684 55.8716 108.303 54.2036Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.303 54.2036L115.248 60.4415C115.177 60.5144 115.105 60.5868 115.032 60.6579L108.087 54.4201C108.161 54.3489 108.232 54.2766 108.303 54.2036Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.087 54.4204L115.031 60.6583C114.94 60.7468 114.848 60.8335 114.753 60.919L107.809 54.6812C107.903 54.5957 107.996 54.5084 108.087 54.4204Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.809 54.6816L114.753 60.9195C114.66 61.0037 114.565 61.0867 114.468 61.1684L107.523 54.9305C107.62 54.8488 107.715 54.7659 107.809 54.6816Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.523 54.9302L114.468 61.168C114.37 61.2497 114.271 61.3296 114.17 61.4076L107.226 55.1697C107.327 55.0917 107.426 55.0119 107.523 54.9302Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.226 55.1699L114.17 61.4078C114.067 61.4876 113.963 61.5656 113.856 61.6417L106.911 55.4038C107.019 55.3277 107.123 55.2498 107.226 55.1699Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.912 55.4038L113.857 61.6417C113.746 61.7209 113.634 61.7976 113.519 61.8725L106.574 55.6346C106.688 55.5604 106.801 55.483 106.912 55.4038Z",
    fill: "#ECC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.573 55.6338L113.518 61.8716C113.396 61.9509 113.272 62.0276 113.146 62.1018L106.202 55.864C106.328 55.7904 106.451 55.7136 106.573 55.6338Z",
    fill: "#EBC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 55.8652L113.146 62.1031C113.008 62.1842 112.868 62.2615 112.725 62.3358L105.78 56.0979C105.923 56.0237 106.063 55.9457 106.201 55.8652Z",
    fill: "#EAC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78 56.0972L112.725 62.335C112.557 62.4223 112.385 62.5047 112.211 62.5814L105.266 56.3436C105.441 56.2668 105.612 56.1845 105.78 56.0972Z",
    fill: "#E9C739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.266 56.3438L112.21 62.5816C111.985 62.6808 111.755 62.7712 111.519 62.8523L104.575 56.6145C104.81 56.534 105.041 56.4429 105.266 56.3438Z",
    fill: "#E8C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.574 56.6147L111.519 62.8526C110.646 63.1526 109.701 63.3223 108.691 63.3223L101.746 57.0845C102.757 57.0845 103.702 56.9148 104.574 56.6147Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 51,
    width: 17,
    height: 13
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0827C104.446 57.0827 106.684 55.8701 108.303 54.2021C109.235 53.2421 109.962 52.1323 110.454 51.0151L117.398 57.253C116.907 58.3702 116.18 59.4799 115.248 60.4399C113.629 62.1079 111.39 63.3205 108.691 63.3205C106.608 61.4492 103.83 58.9541 101.746 57.0827Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0825L108.691 63.3204C109.701 63.3204 110.646 63.1507 111.519 62.8506L104.574 56.6128C103.702 56.9128 102.757 57.0825 101.746 57.0825Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.574 56.6125L111.519 62.8504C111.755 62.7693 111.985 62.6788 112.21 62.5796L105.265 56.3418C105.041 56.441 104.811 56.532 104.574 56.6125Z",
    fill: "#E8DEB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.266 56.3421L112.211 62.5799C112.385 62.5026 112.557 62.4203 112.725 62.3335L105.78 56.0957C105.612 56.183 105.441 56.2654 105.266 56.3421Z",
    fill: "#E9DFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78 56.0965L112.724 62.3343C112.867 62.2601 113.008 62.1827 113.145 62.1016L106.201 55.8638C106.063 55.9442 105.923 56.0222 105.78 56.0965Z",
    fill: "#EAE0B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 55.8635L113.146 62.1013C113.272 62.0271 113.396 61.9504 113.518 61.8711L106.573 55.6333C106.451 55.7125 106.328 55.7892 106.201 55.8635Z",
    fill: "#EBE0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.574 55.6331L113.518 61.871C113.633 61.7961 113.745 61.7194 113.856 61.6402L106.912 55.4023C106.801 55.4816 106.689 55.5589 106.574 55.6331Z",
    fill: "#ECE1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.912 55.4019L113.856 61.6397C113.963 61.5636 114.068 61.4857 114.171 61.4058L107.226 55.168C107.123 55.2484 107.018 55.3264 106.912 55.4019Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.226 55.1697L114.171 61.4076C114.272 61.3296 114.37 61.2491 114.468 61.168L107.524 54.9302C107.426 55.0113 107.327 55.0911 107.226 55.1697Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.523 54.9291L114.468 61.1669C114.564 61.0858 114.66 61.0029 114.753 60.918L107.809 54.6802C107.715 54.765 107.62 54.848 107.523 54.9291Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.809 54.6797L114.753 60.9175C114.848 60.8321 114.94 60.7454 115.031 60.6568L108.087 54.4189C107.996 54.5069 107.903 54.5942 107.809 54.6797Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.087 54.4191L115.032 60.657C115.104 60.5859 115.177 60.5135 115.248 60.4405C115.267 60.4212 115.286 60.4012 115.305 60.3819L108.36 54.144C108.341 54.1634 108.323 54.1833 108.304 54.2027C108.232 54.275 108.161 54.3474 108.087 54.4191Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36 54.1428L115.304 60.3807C115.397 60.2834 115.488 60.1848 115.576 60.085L108.632 53.8472C108.543 53.9476 108.452 54.0462 108.36 54.1428Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.632 53.8475L115.576 60.0853C115.67 59.9799 115.761 59.8726 115.85 59.7647L108.905 53.5269C108.816 53.6354 108.725 53.7421 108.632 53.8475Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.905 53.5286L115.85 59.7665C115.946 59.6498 116.039 59.5319 116.129 59.4122L109.184 53.1743C109.094 53.2941 109.001 53.412 108.905 53.5286Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.184 53.1742L116.129 59.412C116.228 59.2798 116.325 59.1457 116.417 59.0103L109.473 52.7725C109.38 52.9072 109.284 53.0413 109.184 53.1742Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.473 52.7712L116.417 59.009C116.524 58.8531 116.626 58.6952 116.724 58.5362L109.78 52.2983C109.682 52.4574 109.58 52.6152 109.473 52.7712Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.78 52.298L116.724 58.5359C116.846 58.3382 116.96 58.1379 117.066 57.9371L110.122 51.6992C110.015 51.9001 109.901 52.1003 109.78 52.298Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.122 51.7001L117.066 57.9379C117.187 57.7109 117.297 57.4819 117.398 57.253L110.453 51.0151C110.352 51.2441 110.242 51.473 110.122 51.7001Z",
    fill: "white"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M101.746 57.0825H102.314L109.259 63.3204H108.691L101.746 57.0825Z",
    fill: "#3F2782"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M102.314 57.0825L109.259 63.3204H108.691L101.746 57.0825H102.314Z",
    fill: "#E6DCB3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 47.7862L111.2 47.7275L118.145 53.9654V54.024L111.2 47.7862Z",
    fill: "#FAEFC3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 47,
    width: 8,
    height: 7
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71 53.8819C118.711 53.9093 118.712 53.9368 118.713 53.9648L111.768 47.727C111.767 47.6989 111.767 47.6715 111.766 47.644C114.08 49.7231 116.395 51.8028 118.71 53.8819Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.759 47.5205L118.703 53.7584C118.708 53.8257 118.711 53.895 118.713 53.9648L111.768 47.727C111.767 47.6571 111.764 47.5885 111.759 47.5205Z",
    fill: "#3F2782"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M107.414 44.292C108.61 44.292 111.714 44.8266 111.768 47.7291V47.7877H111.2V47.7291C111.147 44.8266 108.042 44.292 106.846 44.292H107.414Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M111.768 47.7881L118.713 54.0259H118.145L111.2 47.7881H111.768Z",
    fill: "#E6DCB3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 47.7881H111.768L118.713 54.0259H118.145L111.2 47.7881Z",
    fill: "#3F2782"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M111.768 47.7275L118.713 53.9654V54.024L111.768 47.7862V47.7275Z",
    fill: "#FAEFC3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 51,
    width: 16,
    height: 13
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M111.026 51.0151L117.971 57.253C116.621 60.3114 113.512 63.3205 109.26 63.3205L102.315 57.0827C106.568 57.0827 109.676 54.0736 111.026 51.0151Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.026 51.0151L117.971 57.253C117.873 57.4744 117.766 57.6959 117.65 57.9161L110.705 51.6782C110.821 51.4587 110.928 51.2372 111.026 51.0151Z",
    fill: "#F8EDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.705 51.6782L117.649 57.9161C117.541 58.1207 117.426 58.324 117.303 58.5249L110.358 52.287C110.481 52.0862 110.597 51.8828 110.705 51.6782Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.358 52.2871L117.303 58.525C117.204 58.6853 117.101 58.845 116.994 59.0022L110.048 52.7643C110.157 52.6071 110.26 52.448 110.358 52.2871Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.048 52.7642L116.994 59.002C116.901 59.1374 116.805 59.2715 116.705 59.4037L109.76 53.1659C109.859 53.0336 109.956 52.8995 110.048 52.7642Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76 53.1665L116.704 59.4043C116.614 59.5241 116.521 59.642 116.426 59.7587L109.481 53.5208C109.577 53.4042 109.67 53.2856 109.76 53.1665Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.481 53.52L116.426 59.7579C116.337 59.8664 116.245 59.9743 116.152 60.0797L109.207 53.8419C109.301 53.7365 109.392 53.6286 109.481 53.52Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.207 53.8433L116.152 60.0811C116.062 60.1815 115.971 60.2813 115.877 60.3793L108.933 54.1414C109.026 54.0435 109.118 53.9443 109.207 53.8433Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.933 54.1406L115.877 60.3785C115.788 60.472 115.697 60.5637 115.603 60.6542L108.659 54.4163C108.752 54.3259 108.843 54.2342 108.933 54.1406Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66 54.416L115.604 60.6539C115.513 60.7424 115.42 60.8291 115.326 60.9146L108.381 54.6768C108.476 54.5919 108.568 54.5046 108.66 54.416Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.381 54.6772L115.326 60.9151C115.232 60.9999 115.136 61.0835 115.039 61.1652L108.094 54.9274C108.191 54.845 108.287 54.7621 108.381 54.6772Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.094 54.9272L115.039 61.1651C114.941 61.2468 114.842 61.3267 114.741 61.4046L107.796 55.1668C107.897 55.0888 107.997 55.009 108.094 54.9272Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.797 55.168L114.741 61.4058C114.638 61.4863 114.532 61.5649 114.425 61.641L107.48 55.4031C107.587 55.327 107.693 55.2484 107.797 55.168Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 55.4023L114.425 61.6402C114.314 61.7194 114.2 61.7968 114.086 61.8716L107.141 55.6338C107.256 55.5589 107.369 55.4816 107.48 55.4023Z",
    fill: "#ECE1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.141 55.6343L114.086 61.8721C113.965 61.9513 113.841 62.0274 113.716 62.101L106.771 55.8632C106.896 55.7896 107.02 55.7135 107.141 55.6343Z",
    fill: "#EBE0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.771 55.8638L113.715 62.1016C113.577 62.1827 113.437 62.2601 113.294 62.3343L106.35 56.0965C106.492 56.0222 106.633 55.9449 106.771 55.8638Z",
    fill: "#EAE0B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.35 56.0942L113.294 62.3321C113.127 62.4188 112.957 62.5005 112.783 62.5772L105.839 56.3394C106.012 56.2633 106.183 56.1809 106.35 56.0942Z",
    fill: "#E9DFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.839 56.3413L112.783 62.5792C112.555 62.6802 112.32 62.7725 112.08 62.8549L105.135 56.617C105.375 56.5347 105.61 56.4424 105.839 56.3413Z",
    fill: "#E8DEB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.135 56.6152L112.08 62.8531C111.209 63.1512 110.266 63.3197 109.26 63.3197L102.315 57.0818C103.322 57.0818 104.264 56.9134 105.135 56.6152Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 51,
    width: 16,
    height: 13
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M102.314 57.0827C106.568 57.0827 109.675 54.0729 111.025 51.0151L117.97 57.253C116.62 60.3114 113.512 63.3205 109.259 63.3205L102.314 57.0827Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.314 57.0818L109.259 63.3197C110.266 63.3197 111.209 63.1506 112.079 62.8531L105.134 56.6152C104.264 56.9134 103.321 57.0818 102.314 57.0818Z",
    fill: "#E7CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.135 56.617L112.079 62.8549C112.32 62.7725 112.554 62.6802 112.783 62.5792L105.838 56.3413C105.609 56.4424 105.375 56.5347 105.135 56.617Z",
    fill: "#E8CC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.838 56.3394L112.783 62.5772C112.956 62.5005 113.127 62.4188 113.294 62.3321L106.349 56.0942C106.182 56.1809 106.012 56.2633 105.838 56.3394Z",
    fill: "#E9CD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.349 56.0965L113.294 62.3343C113.437 62.2601 113.577 62.1827 113.715 62.1016L106.77 55.8638C106.632 55.9449 106.492 56.0222 106.349 56.0965Z",
    fill: "#EACE5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.771 55.8632L113.715 62.101C113.84 62.0274 113.964 61.9507 114.085 61.8721L107.14 55.6343C107.019 55.7135 106.896 55.7896 106.771 55.8632Z",
    fill: "#EBCF5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.141 55.6338L114.085 61.8716C114.2 61.7968 114.314 61.7194 114.425 61.6402L107.48 55.4023C107.368 55.4816 107.255 55.5589 107.141 55.6338Z",
    fill: "#ECD05D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 55.4031L114.425 61.641C114.532 61.5643 114.637 61.4857 114.741 61.4058L107.796 55.168C107.692 55.2484 107.587 55.327 107.48 55.4031Z",
    fill: "#EDD15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.796 55.1682L114.741 61.4061C114.842 61.3281 114.941 61.2483 115.039 61.1666L108.094 54.9287C107.996 55.0098 107.897 55.0896 107.796 55.1682Z",
    fill: "#EED25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.093 54.9274L115.038 61.1652C115.135 61.0835 115.231 60.9999 115.325 60.9151L108.38 54.6772C108.287 54.7627 108.191 54.8457 108.093 54.9274Z",
    fill: "#EFD35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.381 54.6768L115.325 60.9146C115.42 60.8291 115.513 60.7418 115.604 60.6539L108.659 54.416C108.568 54.504 108.475 54.5913 108.381 54.6768Z",
    fill: "#F0D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.659 54.4163L115.604 60.6542C115.697 60.5637 115.788 60.4714 115.878 60.3785L108.933 54.1406C108.843 54.2342 108.752 54.3259 108.659 54.4163Z",
    fill: "#F1D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.932 54.1414L115.877 60.3793C115.97 60.2813 116.061 60.1822 116.151 60.0811L109.207 53.8433C109.117 53.9443 109.026 54.0435 108.932 54.1414Z",
    fill: "#F2D560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.207 53.8419L116.151 60.0797C116.245 59.9737 116.336 59.8664 116.426 59.7579L109.481 53.52C109.392 53.6286 109.3 53.7365 109.207 53.8419Z",
    fill: "#F3D660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.481 53.5208L116.426 59.7587C116.521 59.642 116.614 59.5241 116.704 59.4043L109.759 53.1665C109.669 53.2856 109.576 53.4042 109.481 53.5208Z",
    fill: "#F4D761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.759 53.1659L116.704 59.4037C116.804 59.2715 116.9 59.1374 116.993 59.002L110.047 52.7642C109.956 52.8995 109.859 53.0336 109.759 53.1659Z",
    fill: "#F5D861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.048 52.7643L116.994 59.0022C117.101 58.845 117.204 58.6853 117.303 58.525L110.358 52.2871C110.26 52.448 110.156 52.6071 110.048 52.7643Z",
    fill: "#F6D961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.358 52.287L117.303 58.5249C117.426 58.3234 117.541 58.1207 117.649 57.9161L110.705 51.6782C110.597 51.8828 110.481 52.0862 110.358 52.287Z",
    fill: "#F7DA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.705 51.6782L117.649 57.9161C117.765 57.6959 117.873 57.4744 117.97 57.253L111.026 51.0151C110.928 51.2372 110.821 51.4587 110.705 51.6782Z",
    fill: "#F8DB62"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 51,
    width: 21,
    height: 15
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M114.522 51.0151L121.467 57.253C116.964 65.5281 108.897 65.7863 108.472 65.8001L101.527 59.5622C101.952 59.5491 110.019 59.2903 114.522 51.0151Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.522 51.0151L121.467 57.253C121.316 57.5293 121.161 57.7969 121.004 58.0552L114.059 51.8173C114.217 51.5591 114.372 51.2915 114.522 51.0151Z",
    fill: "#F7DA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.059 51.8188L121.004 58.0567C120.84 58.3249 120.673 58.5838 120.502 58.8339L113.557 52.5961C113.728 52.3466 113.896 52.0877 114.059 51.8188Z",
    fill: "#F6D961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.557 52.5957L120.502 58.8335C120.349 59.0575 120.194 59.2733 120.036 59.4829L113.091 53.2451C113.249 53.0355 113.404 52.819 113.557 52.5957Z",
    fill: "#F5D861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.091 53.2466L120.036 59.4844C119.899 59.6666 119.759 59.8443 119.618 60.0159L112.673 53.778C112.814 53.6059 112.953 53.4287 113.091 53.2466Z",
    fill: "#F4D761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.673 53.7773L119.618 60.0152C119.478 60.1855 119.338 60.3508 119.196 60.5111L112.251 54.2733C112.393 54.1129 112.534 53.9476 112.673 53.7773Z",
    fill: "#F3D660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25 54.2729L119.195 60.5108C119.06 60.663 118.924 60.8108 118.786 60.9549L111.842 54.7171C111.979 54.573 112.116 54.4252 112.25 54.2729Z",
    fill: "#F2D560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.842 54.7168L118.786 60.9546C118.649 61.0987 118.51 61.2385 118.37 61.3738L111.426 55.136C111.566 55.0006 111.705 54.8609 111.842 54.7168Z",
    fill: "#F1D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.426 55.1348L118.371 61.3726C118.229 61.5105 118.086 61.644 117.943 61.7737L110.998 55.5359C111.142 55.4061 111.284 55.2726 111.426 55.1348Z",
    fill: "#F0D45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.998 55.5366L117.943 61.7745C117.797 61.9061 117.651 62.0333 117.504 62.1562L110.559 55.9184C110.706 55.7955 110.852 55.6682 110.998 55.5366Z",
    fill: "#EFD35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.559 55.9185L117.504 62.1563C117.347 62.2873 117.19 62.4139 117.032 62.5362L110.087 56.2983C110.245 56.1761 110.402 56.0495 110.559 55.9185Z",
    fill: "#EED25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.088 56.2988L117.032 62.5367C116.865 62.6658 116.698 62.7906 116.53 62.9097L109.585 56.6719C109.753 56.5521 109.92 56.428 110.088 56.2988Z",
    fill: "#EDD15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.585 56.6699L116.53 62.9078C116.349 63.0369 116.167 63.1598 115.987 63.2777L109.042 57.0398C109.224 56.9225 109.404 56.799 109.585 56.6699Z",
    fill: "#ECD05D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.043 57.042L115.988 63.2798C115.776 63.4177 115.564 63.5487 115.353 63.6716L108.409 57.4337C108.62 57.3102 108.831 57.1798 109.043 57.042Z",
    fill: "#EBCF5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.408 57.4336L115.353 63.6714C115.106 63.8155 114.862 63.9503 114.62 64.075L107.675 57.8372C107.917 57.7118 108.162 57.5777 108.408 57.4336Z",
    fill: "#EACE5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.676 57.8364L114.62 64.0743C114.313 64.2327 114.01 64.3768 113.713 64.5078L106.769 58.27C107.065 58.139 107.369 57.9955 107.676 57.8364Z",
    fill: "#E9CD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.768 58.2705L113.713 64.5084C113.277 64.6999 112.853 64.8633 112.448 65.0024L105.503 58.7645C105.908 58.6254 106.332 58.4626 106.768 58.2705Z",
    fill: "#E8CC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.503 58.7642L112.448 65.002C110.29 65.7424 108.657 65.7948 108.472 65.8004L101.527 59.5626C101.712 59.557 103.346 59.5046 105.503 58.7642Z",
    fill: "#E7CB5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 51,
    width: 21,
    height: 15
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M101.527 59.5582C101.952 59.5445 110.019 59.2863 114.499 51.0498L121.444 57.2877C116.964 65.5235 108.897 65.7823 108.472 65.7961C106.389 63.9247 103.611 61.4296 101.527 59.5582Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.527 59.5584L108.472 65.7962C108.657 65.79 110.3 65.7376 112.464 64.9947L105.519 58.7568C103.354 59.4998 101.713 59.5522 101.527 59.5584Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.519 58.7576L112.464 64.9954C112.868 64.8563 113.291 64.6935 113.727 64.502L106.782 58.2642C106.347 58.4557 105.924 58.6185 105.519 58.7576Z",
    fill: "#C28D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.782 58.2635L113.727 64.5013C114.024 64.3703 114.327 64.2269 114.633 64.0684L107.689 57.8306C107.382 57.9884 107.079 58.1325 106.782 58.2635Z",
    fill: "#C38D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.688 57.8302L114.633 64.0681C114.875 63.9433 115.119 63.8092 115.364 63.6651L108.42 57.4272C108.174 57.5713 107.931 57.7055 107.688 57.8302Z",
    fill: "#C48E08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42 57.4276L115.365 63.6654C115.574 63.5426 115.785 63.4128 115.996 63.275L109.052 57.0371C108.841 57.1743 108.63 57.3047 108.42 57.4276Z",
    fill: "#C58F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.052 57.0379L115.997 63.2757C116.178 63.1578 116.359 63.0349 116.54 62.9058L109.595 56.668C109.414 56.7965 109.233 56.92 109.052 57.0379Z",
    fill: "#C68F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.595 56.6679L116.539 62.9057C116.706 62.7872 116.872 62.6637 117.038 62.5352L110.094 56.2974C109.927 56.4259 109.761 56.5494 109.595 56.6679Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.094 56.2966L117.038 62.5344C117.196 62.4128 117.352 62.2868 117.509 62.1558L110.564 55.918C110.408 56.0483 110.251 56.1743 110.094 56.2966Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.564 55.9183L117.509 62.1562C117.655 62.0339 117.8 61.9073 117.945 61.7769L111 55.5391C110.856 55.6701 110.71 55.7961 110.564 55.9183Z",
    fill: "#C89108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 55.5382L117.945 61.7761C118.088 61.647 118.23 61.5141 118.371 61.3775L111.427 55.1396C111.285 55.2769 111.143 55.4097 111 55.5382Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.426 55.1393L118.37 61.3772C118.509 61.2425 118.647 61.104 118.783 60.9605L111.839 54.7227C111.702 54.8655 111.564 55.0046 111.426 55.1393Z",
    fill: "#CA9208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.839 54.7228L118.783 60.9606C118.92 60.8178 119.055 60.6712 119.19 60.5196L112.245 54.2817C112.111 54.4333 111.975 54.5799 111.839 54.7228Z",
    fill: "#CB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.245 54.2822L119.189 60.5201C119.331 60.361 119.471 60.1969 119.609 60.0279L112.664 53.79C112.526 53.9591 112.386 54.1231 112.245 54.2822Z",
    fill: "#CC9409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.665 53.7911L119.61 60.0289C119.749 59.858 119.888 59.6821 120.025 59.5005L113.08 53.2627C112.943 53.4442 112.804 53.6201 112.665 53.7911Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08 53.2614L120.024 59.4993C120.181 59.2915 120.335 59.077 120.486 58.8555L113.542 52.6177C113.39 52.8397 113.236 53.0537 113.08 53.2614Z",
    fill: "#CD9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.542 52.6187L120.486 58.8565C120.656 58.6082 120.822 58.3519 120.984 58.0855L114.039 51.8477C113.877 52.114 113.711 52.371 113.542 52.6187Z",
    fill: "#CE9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.04 51.8475L120.984 58.0853C121.141 57.8283 121.294 57.5626 121.444 57.2881L114.499 51.0503C114.35 51.3248 114.197 51.5905 114.04 51.8475Z",
    fill: "#CF9609"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M115.09 51.0151L122.034 57.253H121.467L114.522 51.0151H115.09Z",
    fill: "#3F2782"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M114.499 51.0544L115.09 51.0151L122.034 57.253L121.444 57.2923L114.499 51.0544Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 51,
    width: 21,
    height: 15
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M115.09 51.0151L122.034 57.253C117.531 65.5281 109.46 65.7863 109.035 65.8001L102.091 59.5622C102.516 59.5491 110.587 59.2903 115.09 51.0151Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.09 51.0151L122.035 57.253C121.884 57.5293 121.73 57.7963 121.573 58.0552L114.628 51.8173C114.786 51.5585 114.94 51.2915 115.09 51.0151Z",
    fill: "#CF9609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.628 51.8188L121.572 58.0567C121.409 58.3249 121.241 58.5838 121.07 58.8339L114.125 52.5961C114.296 52.3459 114.464 52.0871 114.628 51.8188Z",
    fill: "#CE9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.126 52.5942L121.07 58.8321C120.917 59.0554 120.762 59.2719 120.604 59.4815L113.66 53.2436C113.817 53.0346 113.973 52.8182 114.126 52.5942Z",
    fill: "#CD9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66 53.2437L120.604 59.4815C120.467 59.6636 120.327 59.8414 120.186 60.013L113.242 53.7751C113.383 53.6036 113.522 53.4264 113.66 53.2437Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.242 53.7754L120.186 60.0132C120.047 60.1835 119.906 60.3488 119.764 60.5091L112.819 54.2713C112.962 54.111 113.103 53.9457 113.242 53.7754Z",
    fill: "#CC9409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.819 54.272L119.764 60.5098C119.629 60.662 119.492 60.8099 119.355 60.9533L112.411 54.7155C112.548 54.572 112.684 54.4242 112.819 54.272Z",
    fill: "#CB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.411 54.7163L119.356 60.9542C119.218 61.0982 119.079 61.238 118.94 61.3733L111.996 55.1355C112.135 54.9995 112.273 54.8598 112.411 54.7163Z",
    fill: "#CA9208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.995 55.1348L118.939 61.3726C118.798 61.5105 118.655 61.644 118.511 61.7737L111.567 55.5359C111.71 55.4061 111.853 55.2726 111.995 55.1348Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.567 55.5347L118.511 61.7725C118.365 61.9041 118.219 62.0314 118.072 62.1543L111.127 55.9164C111.275 55.7935 111.421 55.6663 111.567 55.5347Z",
    fill: "#C89108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.128 55.916L118.073 62.1539C117.916 62.2855 117.759 62.4121 117.601 62.5338L110.657 56.2959C110.814 56.1743 110.971 56.0476 111.128 55.916Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.657 56.2964L117.602 62.5342C117.434 62.6634 117.267 62.7875 117.099 62.9072L110.155 56.6694C110.322 56.5503 110.49 56.4261 110.657 56.2964Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.155 56.6699L117.099 62.9078C116.918 63.0369 116.737 63.1604 116.556 63.2777L109.611 57.0398C109.792 56.9226 109.974 56.799 110.155 56.6699Z",
    fill: "#C68F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.611 57.04L116.556 63.2779C116.344 63.4157 116.132 63.5467 115.922 63.6696L108.977 57.4318C109.188 57.3083 109.399 57.1779 109.611 57.04Z",
    fill: "#C58F08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.977 57.4321L115.921 63.67C115.675 63.8141 115.43 63.9488 115.188 64.0742L108.243 57.8363C108.486 57.711 108.73 57.5762 108.977 57.4321Z",
    fill: "#C48E08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 57.8364L115.188 64.0743C114.881 64.2327 114.578 64.3768 114.28 64.5078L107.335 58.2699C107.633 58.1389 107.936 57.9949 108.243 57.8364Z",
    fill: "#C38D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.336 58.269L114.281 64.5069C113.845 64.699 113.421 64.8625 113.015 65.0009L106.071 58.7631C106.476 58.624 106.9 58.4605 107.336 58.269Z",
    fill: "#C28D08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.071 58.7637L113.015 65.0015C110.856 65.7426 109.221 65.795 109.035 65.8006L102.091 59.5627C102.276 59.5571 103.911 59.5047 106.071 58.7637Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 59,
    width: 8,
    height: 7
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.035 65.7966L102.091 59.5587C102.162 59.5562 102.447 59.5475 102.894 59.4951C105.208 61.5742 107.523 63.6539 109.839 65.733C109.392 65.7854 109.107 65.7947 109.035 65.7966Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.091 59.5595L109.035 65.7973C109.221 65.7917 110.865 65.7387 113.031 64.9952L106.087 58.7573C103.92 59.5009 102.276 59.5539 102.091 59.5595Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 59,
    width: 9,
    height: 7
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M109.839 65.7349C107.523 63.6559 105.208 61.5762 102.894 59.4971C102.967 59.4884 103.045 59.479 103.127 59.4678C105.442 61.5468 107.757 63.6265 110.071 65.7056C109.99 65.7168 109.912 65.7268 109.839 65.7349Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.091 59.5624L109.035 65.8003C109.221 65.7947 110.865 65.7416 113.031 64.9981L106.087 58.7603C103.92 59.5038 102.276 59.5568 102.091 59.5624Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 59,
    width: 8,
    height: 7
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M110.573 65.6294C110.393 65.6606 110.225 65.6856 110.072 65.7068C109.828 65.4885 109.504 65.1966 109.26 64.9782C109.002 64.7468 108.658 64.4374 108.4 64.206C108.132 63.9652 107.775 63.6446 107.507 63.4044C107.235 63.1599 106.871 62.833 106.598 62.5879C106.326 62.3427 105.962 62.0165 105.69 61.7713C105.422 61.5312 105.065 61.21 104.797 60.9698C104.539 60.7384 104.195 60.429 103.937 60.1975C103.694 59.9792 103.37 59.6873 103.126 59.469C103.279 59.4484 103.447 59.4228 103.628 59.3916C105.943 61.4707 108.258 63.5497 110.573 65.6294Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.091 59.5624L109.036 65.8003C109.221 65.7947 110.865 65.7416 113.032 64.9981L106.087 58.7603C103.921 59.5038 102.277 59.5568 102.091 59.5624Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 30,
    width: 19,
    height: 10
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M135.011 39.853C134.21 39.1338 133.322 38.5138 132.356 38.0035C130.184 36.8769 127.645 36.2681 124.89 36.2681L117.945 30.0303C120.701 30.0303 123.239 30.6391 125.411 31.7657C126.377 32.2759 127.266 32.8959 128.067 33.6152C130.15 35.4865 132.928 37.9817 135.011 39.853Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.944 30.0303L124.889 36.2681C127.644 36.2681 130.183 36.8769 132.355 38.0035C133.321 38.5138 134.21 39.1338 135.01 39.853L128.066 33.6152C127.265 32.8959 126.376 32.2759 125.41 31.7657C123.238 30.6391 120.7 30.0303 117.944 30.0303Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 30,
    width: 14,
    height: 10
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M132.356 38.0075C131.417 37.521 130.411 37.1305 129.348 36.8448C129.104 36.6265 128.78 36.3345 128.536 36.1162C128.278 35.8848 127.934 35.5754 127.676 35.3439C127.408 35.1038 127.052 34.7825 126.783 34.5424C126.511 34.2972 126.147 33.971 125.874 33.7259C125.602 33.4807 125.238 33.1545 124.966 32.9093C124.698 32.6692 124.341 32.3479 124.073 32.1077C123.815 31.8763 123.471 31.5669 123.213 31.3355C122.97 31.1172 122.645 30.8253 122.402 30.6069C123.465 30.8933 124.472 31.2831 125.41 31.7697C125.41 31.7697 125.41 31.7697 125.411 31.7697C127.726 33.8487 130.041 35.9278 132.356 38.0075C130.041 35.9284 127.726 33.8487 125.412 31.7697C126.377 32.2799 127.266 32.9 128.067 33.6192L135.012 39.857C134.211 39.1378 133.322 38.5178 132.356 38.0075Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6191L135.012 39.8569C134.211 39.1377 133.322 38.5177 132.356 38.0074C130.184 36.8808 127.645 36.272 124.89 36.272C124.649 36.272 124.406 36.277 124.161 36.2864L117.217 30.0485C117.461 30.0392 117.705 30.0342 117.945 30.0342C120.701 30.0342 123.239 30.643 125.411 31.7696C126.376 32.2798 127.266 32.8999 128.067 33.6191Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 30,
    width: 18,
    height: 10
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M124.161 36.2823L117.217 30.0444C120.176 30.1417 122.835 30.9146 125.046 32.2607C127.361 34.3398 129.676 36.4189 131.991 38.4986C131.747 38.2803 131.423 37.9883 131.18 37.77C130.921 37.5386 130.578 37.2292 130.319 36.9978C130.052 36.7576 129.694 36.4364 129.427 36.1962C129.154 35.951 128.79 35.6248 128.518 35.3797C128.245 35.1351 127.882 34.8083 127.609 34.5631C127.341 34.323 126.985 34.0017 126.716 33.7616C126.458 33.5302 126.114 33.2207 125.856 32.9893C125.613 32.771 125.289 32.4797 125.045 32.2607C125.766 32.6999 126.44 33.2002 127.061 33.7572L134.005 39.995C131.482 37.7282 128.086 36.4108 124.161 36.2823Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.216 30.0444L124.16 36.2823C128.085 36.4114 131.482 37.7288 134.005 39.9957L127.06 33.7578C124.537 31.491 121.141 30.1729 117.216 30.0444Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 30,
    width: 18,
    height: 10
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M127.061 33.7578L134.005 39.9957C131.482 37.7288 128.086 36.4114 124.161 36.2823L117.216 30.0444C121.141 30.1736 124.538 31.4916 127.061 33.7578Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.061 33.7578L134.005 39.9957C131.482 37.7288 128.086 36.4114 124.161 36.2823L117.216 30.0444C121.141 30.1736 124.538 31.4916 127.061 33.7578Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 44,
    width: 8,
    height: 11
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M115.546 44.3511L122.491 50.5889C122.602 50.8977 122.694 51.3693 122.724 51.9575C122.754 52.5457 122.722 53.2506 122.587 54.0266L115.642 47.7888C115.778 47.0134 115.809 46.3085 115.779 45.7197C115.749 45.1314 115.657 44.6598 115.546 44.3511Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.546 44.3511L122.491 50.5889C122.498 50.6076 122.505 50.627 122.511 50.6469L115.566 44.4091C115.56 44.3898 115.553 44.3704 115.546 44.3511Z",
    fill: "#F3D660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.566 44.4087L122.511 50.6465C122.535 50.7176 122.557 50.7956 122.578 50.8811L115.633 44.6432C115.613 44.5578 115.59 44.4792 115.566 44.4087Z",
    fill: "#F4D761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.633 44.644L122.577 50.8819C122.604 50.9917 122.629 51.1121 122.65 51.2437L115.705 45.0058C115.685 44.8742 115.66 44.7532 115.633 44.644Z",
    fill: "#F5D861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.706 45.0059L122.651 51.2437C122.677 51.4084 122.699 51.5899 122.713 51.7864L115.768 45.5485C115.754 45.3521 115.732 45.1705 115.706 45.0059Z",
    fill: "#F6D961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.769 45.5488L122.713 51.7867C122.718 51.8428 122.721 51.8996 122.724 51.9582C122.734 52.1528 122.737 52.3605 122.732 52.5789L115.787 46.341C115.792 46.1227 115.789 45.915 115.779 45.7204C115.777 45.6617 115.773 45.6043 115.769 45.5488Z",
    fill: "#F7DA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.787 46.3398L122.732 52.5777C122.722 52.9707 122.687 53.3992 122.615 53.854L115.671 47.6161C115.742 47.1608 115.778 46.7322 115.787 46.3398Z",
    fill: "#F8DB62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.671 47.6177L122.616 53.8555C122.607 53.9123 122.597 53.9697 122.587 54.0277L115.643 47.7898C115.653 47.7318 115.663 47.6744 115.671 47.6177Z",
    fill: "#F9DC63"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 44,
    width: 8,
    height: 11
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M115.642 47.7888C115.778 47.0134 115.809 46.3085 115.779 45.7197C115.749 45.1314 115.657 44.6598 115.546 44.3511L122.491 50.5889C122.602 50.8977 122.694 51.3693 122.724 51.9575C122.754 52.5457 122.722 53.2506 122.587 54.0266C120.504 52.1553 117.726 49.6601 115.642 47.7888Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.643 47.7874L122.587 54.0252C122.597 53.9672 122.607 53.9098 122.616 53.8531L115.671 47.6152C115.663 47.672 115.653 47.7294 115.643 47.7874Z",
    fill: "#D19709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.671 47.6156L122.615 53.8535C122.687 53.3987 122.723 52.9702 122.732 52.5772L115.787 46.3394C115.778 46.7323 115.742 47.1609 115.671 47.6156Z",
    fill: "#D09709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.787 46.341L122.732 52.5789C122.737 52.3605 122.734 52.1528 122.724 51.9582C122.721 51.9002 122.717 51.8428 122.713 51.7867L115.769 45.5488C115.773 45.605 115.776 45.6617 115.779 45.7204C115.789 45.9144 115.792 46.1221 115.787 46.341Z",
    fill: "#CF9609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.768 45.5485L122.713 51.7864C122.699 51.5905 122.677 51.409 122.651 51.2437L115.706 45.0059C115.732 45.1705 115.754 45.3521 115.768 45.5485Z",
    fill: "#CE9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.706 45.0034L122.651 51.2413C122.63 51.1096 122.605 50.9886 122.578 50.8794L115.634 44.6416C115.661 44.7508 115.685 44.8718 115.706 45.0034Z",
    fill: "#CD9509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.633 44.6432L122.578 50.8811C122.557 50.7956 122.534 50.7176 122.511 50.6465L115.566 44.4087C115.59 44.4792 115.613 44.5578 115.633 44.6432Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.566 44.4091L122.511 50.6469C122.504 50.627 122.498 50.6076 122.491 50.5889L115.546 44.3511C115.553 44.3698 115.56 44.3891 115.566 44.4091Z",
    fill: "#CC9409"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M120.75 44.292L127.695 50.5298L122.491 50.5878L115.546 44.35L120.75 44.292Z",
    fill: "#3F2782"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M115.546 44.35L120.75 44.292L127.695 50.5298L122.491 50.5878L115.546 44.35Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 44,
    width: 8,
    height: 11
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M123.16 54.024L116.215 47.7862C116.481 46.2355 116.332 44.966 116.115 44.3491L123.059 50.587C123.277 51.2039 123.426 52.4727 123.16 54.024Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.214 47.7866L123.159 54.0245C123.167 53.977 123.175 53.9296 123.182 53.8829L116.237 47.645C116.231 47.6918 116.222 47.7392 116.214 47.7866Z",
    fill: "#F3CD2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.238 47.6433L123.182 53.8812C123.254 53.4246 123.29 52.9935 123.3 52.5987L116.355 46.3608C116.346 46.7557 116.31 47.1867 116.238 47.6433Z",
    fill: "#F2CC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.355 46.3623L123.299 52.6001C123.306 52.3113 123.299 52.0419 123.28 51.7955L116.335 45.5576C116.354 45.804 116.362 46.0735 116.355 46.3623Z",
    fill: "#F1CB2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.336 45.5569L123.28 51.7947C123.265 51.5945 123.243 51.4092 123.217 51.2408L116.272 45.0029C116.299 45.1714 116.321 45.3566 116.336 45.5569Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.272 45.0038L123.217 51.2417C123.195 51.1069 123.17 50.9828 123.142 50.8711L116.198 44.6333C116.225 44.745 116.25 44.8691 116.272 45.0038Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.198 44.6322L123.142 50.87C123.121 50.7833 123.099 50.7041 123.075 50.6324L116.13 44.3945C116.154 44.4663 116.177 44.5455 116.198 44.6322Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13 44.3959L123.075 50.6338C123.07 50.6175 123.064 50.6019 123.059 50.587L116.114 44.3491C116.12 44.3641 116.125 44.3797 116.13 44.3959Z",
    fill: "#EDC82B"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M116.215 47.7881L123.16 54.0259H122.588L115.643 47.7881H116.215Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 44,
    width: 8,
    height: 11
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M116.114 44.3511L123.059 50.5889C123.277 51.2065 123.426 52.4753 123.159 54.0266L116.215 47.7888C116.481 46.2374 116.333 44.9686 116.114 44.3511Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.114 44.3511L123.059 50.5889C123.064 50.6045 123.069 50.6201 123.075 50.6357L116.13 44.3979C116.125 44.3823 116.12 44.3667 116.114 44.3511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13 44.3989L123.075 50.6368C123.099 50.7085 123.121 50.7877 123.142 50.8744L116.198 44.6366C116.177 44.5492 116.154 44.47 116.13 44.3989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.198 44.6348L123.142 50.8726C123.17 50.9843 123.195 51.1084 123.217 51.2431L116.272 45.0053C116.25 44.8706 116.225 44.7464 116.198 44.6348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.272 45.0059L123.217 51.2437C123.243 51.4115 123.265 51.5968 123.28 51.7976L116.336 45.5598C116.321 45.3595 116.299 45.1743 116.272 45.0059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.336 45.5601L123.281 51.7979C123.299 52.0443 123.306 52.3138 123.3 52.6026L116.355 46.3647C116.362 46.0759 116.355 45.8065 116.336 45.5601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.355 46.3643L123.3 52.6021C123.29 52.997 123.255 53.428 123.182 53.8846L116.238 47.6468C116.31 47.1901 116.346 46.7591 116.355 46.3643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.238 47.6465L123.183 53.8843C123.175 53.9311 123.168 53.9785 123.159 54.0259L116.215 47.7881C116.223 47.7407 116.231 47.6933 116.238 47.6465Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 58,
    width: 11,
    height: 8
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M113.921 64.6603C112.619 65.1949 111.445 65.4775 110.573 65.6272C110.567 65.6222 110.56 65.616 110.555 65.611C110.549 65.606 110.541 65.5991 110.535 65.5942C110.529 65.5885 110.522 65.5817 110.515 65.5767C110.509 65.5711 110.501 65.5642 110.495 65.5586C110.489 65.553 110.481 65.5461 110.475 65.5405C110.469 65.5349 110.462 65.528 110.455 65.523C110.45 65.518 110.442 65.5112 110.437 65.5062C110.431 65.5012 110.424 65.495 110.419 65.49C110.18 65.276 109.863 64.9916 109.625 64.7776C109.373 64.5512 109.036 64.2486 108.784 64.0222C108.522 63.787 108.173 63.4733 107.912 63.2381C107.645 62.9986 107.29 62.6792 107.023 62.4397C106.756 62.2001 106.401 61.8808 106.134 61.6412C105.872 61.4061 105.523 61.0923 105.261 60.8571C105.009 60.6307 104.672 60.3282 104.42 60.1017C104.183 59.8878 103.865 59.6033 103.627 59.3894C103.642 59.3869 103.657 59.3844 103.672 59.3813C105.982 61.456 108.291 63.5301 110.601 65.6048C108.291 63.5301 105.982 61.456 103.672 59.3813C104.54 59.2291 105.696 58.9471 106.977 58.4219C109.291 60.5016 111.606 62.5807 113.921 64.6603Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.09 59.5595L109.035 65.7973C109.22 65.7917 110.864 65.7387 113.031 64.9952L106.086 58.7573C103.92 59.5009 102.276 59.5539 102.09 59.5595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.086 58.7581L113.031 64.9959C113.435 64.8568 113.859 64.694 114.294 64.5025L107.349 58.2646C106.914 58.4562 106.491 58.6196 106.086 58.7581Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 58,
    width: 9,
    height: 7
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M113.922 64.6617C111.607 62.5827 109.292 60.5036 106.978 58.4233C107.012 58.4095 107.046 58.3952 107.08 58.3809C109.395 60.4599 111.711 62.5396 114.026 64.6181C113.991 64.6324 113.956 64.6474 113.922 64.6617Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.086 58.7581L113.031 64.9959C113.435 64.8568 113.859 64.694 114.294 64.5025L107.349 58.2646C106.914 58.4562 106.491 58.6196 106.086 58.7581Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 58,
    width: 8,
    height: 7
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M114.033 64.6177C114.031 64.6184 114.028 64.6196 114.026 64.6202C111.711 62.5418 109.396 60.4621 107.081 58.383C107.083 58.3818 107.086 58.3811 107.087 58.3799C109.403 60.459 111.718 62.538 114.033 64.6177Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.086 58.7586L113.031 64.9964C113.436 64.8573 113.859 64.6945 114.294 64.503L107.35 58.2651C106.915 58.4566 106.492 58.6201 106.086 58.7586Z",
    fill: "#E2BF29"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M123.854 41.0386L130.799 47.2764L127.695 50.5295L120.75 44.2916L123.854 41.0386Z",
    fill: "#F4D761"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M120.75 44.2916L123.854 41.0386L130.799 47.2764L127.695 50.5295L120.75 44.2916Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 51,
    width: 8,
    height: 7
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M121.996 57.3189C121.752 57.1006 121.428 56.8087 121.184 56.5903C120.926 56.3583 120.582 56.0495 120.324 55.8181C120.056 55.5773 119.699 55.2567 119.431 55.0165C119.159 54.7714 118.795 54.4451 118.522 54.2C118.25 53.9555 117.886 53.6286 117.614 53.3835C117.346 53.1433 116.989 52.8221 116.721 52.5819C116.463 52.3505 116.119 52.0411 115.861 51.8097C115.617 51.5913 115.293 51.2994 115.05 51.0811C115.055 51.0711 115.06 51.0617 115.065 51.0518L122.01 57.2896C122.006 57.2996 122.001 57.3089 121.996 57.3189Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.607 51.8483L121.552 58.0862C121.709 57.8292 121.862 57.5634 122.011 57.2896L115.067 51.0518C114.917 51.3256 114.764 51.5913 114.607 51.8483Z",
    fill: "#F1CB2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 51,
    width: 7,
    height: 7
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M121.981 57.3441C121.738 57.1258 121.414 56.8339 121.17 56.6155C120.912 56.3841 120.568 56.0747 120.31 55.8433C120.042 55.6025 119.685 55.2819 119.417 55.0417C119.145 54.7966 118.781 54.4703 118.508 54.2252C118.236 53.98 117.872 53.6538 117.599 53.4087C117.332 53.1679 116.975 52.8473 116.707 52.6071C116.449 52.3751 116.105 52.0663 115.847 51.8349C115.603 51.6165 115.279 51.3246 115.036 51.1063C115.041 51.0975 115.045 51.0888 115.05 51.0801C117.365 53.1592 119.68 55.2388 121.995 57.3179C121.991 57.3267 121.986 57.3354 121.981 57.3441Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.608 51.8483L121.552 58.0862C121.709 57.8292 121.863 57.5634 122.012 57.2896L115.067 51.0518C114.918 51.3256 114.764 51.5913 114.608 51.8483Z",
    fill: "white"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M116.114 44.35L121.318 44.292L128.263 50.5298L123.059 50.5878L116.114 44.35Z",
    fill: "#3F2782"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M121.318 44.292L128.263 50.5298L123.059 50.5878L116.114 44.35L121.318 44.292Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M124.422 41.0386L131.367 47.2764H130.799L123.854 41.0386H124.422Z",
    fill: "#3F2782"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M123.854 41.0386H124.422L131.367 47.2764H130.799L123.854 41.0386Z",
    fill: "#3F2782"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M121.318 44.2916L124.422 41.0386L131.367 47.2764L128.263 50.5295L121.318 44.2916Z",
    fill: "#3F2782"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M124.422 41.0386L131.367 47.2764L128.263 50.5295L121.318 44.2916L124.422 41.0386Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 55,
    width: 12,
    height: 10
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M114.033 64.6151C114.031 64.6132 114.028 64.6113 114.026 64.6095C114.025 64.6076 114.021 64.6051 114.02 64.6032C114.018 64.6014 114.015 64.5989 114.013 64.597C114.011 64.5951 114.008 64.5926 114.006 64.5907C114.004 64.5889 114.001 64.5864 113.999 64.5845C113.997 64.5826 113.994 64.5801 113.992 64.5783C113.99 64.5764 113.988 64.5739 113.985 64.572C113.983 64.5702 113.981 64.5683 113.979 64.5664C112.831 63.5347 111.682 62.503 110.533 61.4712C110.262 61.2286 109.902 60.9042 109.631 60.6615C109.365 60.4226 109.011 60.1045 108.745 59.8662C108.49 59.636 108.148 59.3298 107.892 59.0996C107.651 58.8825 107.329 58.5937 107.087 58.3766C108.348 57.8483 109.724 57.0841 111.06 55.9775C113.375 58.0566 115.69 60.1363 118.005 62.2154C116.669 63.3226 115.293 64.0867 114.033 64.6151Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.086 58.7576L113.031 64.9954C113.436 64.8563 113.859 64.6935 114.294 64.502L107.35 58.2642C106.915 58.4557 106.492 58.6191 106.086 58.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35 58.2646L114.295 64.5024C114.592 64.3714 114.895 64.2273 115.202 64.0689L108.257 57.8311C107.95 57.9901 107.648 58.1342 107.35 58.2646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.257 57.8312L115.202 64.069C115.444 63.9443 115.688 63.8102 115.934 63.6661L108.989 57.4282C108.743 57.5717 108.499 57.7058 108.257 57.8312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.989 57.4281L115.933 63.6659C116.143 63.5431 116.354 63.4133 116.565 63.2754L109.621 57.0376C109.409 57.1748 109.198 57.3052 108.989 57.4281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.621 57.0384L116.565 63.2762C116.746 63.1583 116.927 63.0354 117.109 62.9063L110.164 56.6685C109.982 56.797 109.802 56.9205 109.621 57.0384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.164 56.6684L117.108 62.9062C117.275 62.7877 117.441 62.6642 117.607 62.5357L110.663 56.2979C110.497 56.4257 110.33 56.5492 110.164 56.6684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.663 56.2971L117.607 62.5349C117.764 62.4133 117.921 62.2873 118.078 62.1563L111.133 55.9185C110.977 56.0495 110.82 56.1755 110.663 56.2971Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 55,
    width: 8,
    height: 8
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M118.064 62.17C118.044 62.1862 118.025 62.203 118.005 62.2193C115.69 60.1402 113.375 58.0605 111.061 55.9814C111.081 55.9652 111.1 55.949 111.12 55.9321C113.435 58.0118 115.75 60.0909 118.064 62.17Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.662 56.2995L117.607 62.5374C117.764 62.4157 117.92 62.2897 118.077 62.1587L111.132 55.9209C110.977 56.0519 110.819 56.1779 110.662 56.2995Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 55,
    width: 8,
    height: 8
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M118.065 62.1688C118.053 62.1588 118.038 62.1451 118.027 62.1351C118.015 62.1245 117.998 62.1102 117.987 62.0989C117.974 62.0877 117.957 62.0727 117.945 62.0615C117.932 62.0503 117.915 62.0347 117.902 62.0235C117.89 62.0122 117.873 61.9966 117.86 61.9854C117.848 61.9742 117.831 61.9592 117.819 61.948C117.807 61.9374 117.791 61.923 117.779 61.9124C117.768 61.9024 117.753 61.8887 117.741 61.8787C117.509 61.6704 117.2 61.3928 116.968 61.1838C116.722 60.963 116.394 60.668 116.148 60.4471C115.893 60.2176 115.553 59.9119 115.297 59.683C115.037 59.4497 114.691 59.1384 114.431 58.9045C114.171 58.6712 113.825 58.36 113.565 58.126C113.309 57.8965 112.969 57.5908 112.714 57.3619C112.183 56.8847 111.651 56.4075 111.121 55.931C111.159 55.8985 111.198 55.8661 111.237 55.833C113.551 57.9121 115.866 59.9918 118.181 62.0709C118.142 62.1039 118.103 62.1364 118.065 62.1688Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.662 56.2981L117.607 62.5359C117.764 62.4143 117.92 62.2883 118.077 62.1573L111.132 55.9194C110.977 56.0504 110.819 56.1764 110.662 56.2981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.132 55.9188L118.077 62.1567C118.223 62.0344 118.368 61.9078 118.513 61.7774L111.568 55.5396C111.424 55.6699 111.278 55.7966 111.132 55.9188Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 55,
    width: 8,
    height: 8
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M118.184 62.0679C118.183 62.0692 118.182 62.0698 118.181 62.071C117.023 61.0312 115.866 59.992 114.708 58.9521C114.435 58.707 114.072 58.3807 113.799 58.1356C113.532 57.8948 113.174 57.5742 112.906 57.334C112.648 57.1026 112.305 56.7932 112.046 56.5618C111.803 56.3435 111.479 56.0515 111.235 55.8332C111.237 55.832 111.238 55.8313 111.239 55.8301C113.555 57.9092 115.869 59.9888 118.184 62.0679Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.132 55.9198L118.077 62.1576C118.223 62.0354 118.368 61.9087 118.513 61.7784L111.568 55.5405C111.424 55.6709 111.278 55.7975 111.132 55.9198Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 51,
    width: 11,
    height: 12
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M118.184 62.0686C118.182 62.0668 118.18 62.0649 118.178 62.063C118.176 62.0612 118.174 62.0587 118.172 62.0574C118.17 62.0556 118.167 62.0531 118.165 62.0512C118.163 62.0493 118.16 62.0468 118.158 62.0449C118.156 62.0431 118.153 62.0406 118.151 62.0387C118.149 62.0368 118.146 62.0343 118.144 62.0325C118.142 62.0306 118.14 62.0281 118.138 62.0269C118.136 62.025 118.134 62.0231 118.132 62.0212C117.89 61.8042 117.569 61.5154 117.327 61.2983C117.071 61.0681 116.73 60.7618 116.474 60.5316C116.208 60.2927 115.854 59.9746 115.588 59.7357C115.317 59.4924 114.957 59.1687 114.686 58.9254C114.415 58.6821 114.055 58.3584 113.784 58.1151C113.518 57.8762 113.164 57.5581 112.898 57.3198C112.643 57.0896 112.301 56.7833 112.045 56.5532C111.804 56.3361 111.482 56.0473 111.24 55.8302C112.61 54.6612 113.931 53.1261 115.037 51.1094C117.352 53.1884 119.667 55.2681 121.982 57.3472C120.875 59.3645 119.554 60.8997 118.184 62.0686Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.132 55.9213L118.077 62.1591C118.223 62.0368 118.368 61.9102 118.513 61.7798L111.568 55.542C111.424 55.6724 111.278 55.799 111.132 55.9213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.568 55.5413L118.513 61.7792C118.656 61.6507 118.797 61.5172 118.939 61.3799L111.994 55.1421C111.853 55.2793 111.711 55.4122 111.568 55.5413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.994 55.1421L118.939 61.38C119.077 61.2452 119.215 61.1068 119.352 60.9639L112.407 54.7261C112.27 54.8689 112.133 55.008 111.994 55.1421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.407 54.7262L119.352 60.964C119.488 60.8212 119.624 60.6746 119.758 60.523L112.813 54.2852C112.679 54.4367 112.543 54.5833 112.407 54.7262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.813 54.2846L119.758 60.5225C119.899 60.3634 120.039 60.1994 120.177 60.0303L113.233 53.7925C113.094 53.9615 112.954 54.1256 112.813 54.2846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.232 53.793L120.177 60.0308C120.317 59.8599 120.455 59.684 120.592 59.5025L113.647 53.2646C113.511 53.4462 113.372 53.6221 113.232 53.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.647 53.2642L120.592 59.5021C120.749 59.2943 120.903 59.0804 121.054 58.8589L114.109 52.6211C113.958 52.8425 113.804 53.0571 113.647 53.2642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.109 52.6219L121.054 58.8598C121.224 58.6121 121.39 58.3551 121.552 58.0894L114.607 51.8516C114.444 52.1173 114.278 52.3743 114.109 52.6219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.607 51.8508L121.552 58.0886C121.709 57.8316 121.862 57.5659 122.011 57.292L115.067 51.0542C114.917 51.328 114.764 51.5938 114.607 51.8508Z",
    fill: "white"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M118.135 51.0151L125.079 57.253H122.034L115.09 51.0151H118.135Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M115.067 51.0538L118.135 51.0151L125.079 57.253L122.011 57.2917L115.067 51.0538Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M121.203 47.7881L128.148 54.0259H123.16L116.214 47.7881H121.203Z",
    fill: "#3F2782"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M115.643 47.7881H121.204L128.148 54.0259H122.588L115.643 47.7881Z",
    fill: "#3F2782"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M121.203 47.7881L128.148 54.0259L125.079 57.254L118.134 51.0162L121.203 47.7881Z",
    fill: "#F4D761"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M118.134 51.0162L121.203 47.7881L128.148 54.0259L125.079 57.254L118.134 51.0162Z",
    fill: "#3F2782"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.134 51.0151H118.702L125.647 57.253H125.079L118.134 51.0151Z",
    fill: "#3F2782"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M118.702 51.0151L125.647 57.253H125.079L118.134 51.0151H118.702Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M121.771 47.7881L128.716 54.0259H128.148L121.204 47.7881H121.771Z",
    fill: "#3F2782"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M121.204 47.7881H121.771L128.716 54.0259H128.148L121.204 47.7881Z",
    fill: "#3F2782"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M118.702 51.0162L121.771 47.7881L128.716 54.0259L125.647 57.254L118.702 51.0162Z",
    fill: "#3F2782"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M121.771 47.7881L118.702 51.0162H118.134L121.203 47.7881H121.771Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M121.771 47.7881L128.716 54.0259L125.647 57.254L118.702 51.0162L121.771 47.7881Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M102.234 75.1115L96.3594 60.1855L103.304 66.4234L109.179 81.3493L102.234 75.1115Z",
    fill: "#3F2782"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3608 60.1772L103.305 66.4151L109.178 81.346L102.233 75.1082L96.3608 60.1772Z",
    fill: "#EFCA2B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9268 60.1855L103.871 66.4234L109.746 81.3493L102.801 75.1115L96.9268 60.1855Z",
    fill: "#3F2782"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M102.801 75.1115L96.9268 60.1855L103.871 66.4234L109.746 81.3493L102.801 75.1115Z",
    fill: "#F5D861"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M102.233 75.1123H106.969L113.914 81.3502H109.179L102.233 75.1123Z",
    fill: "#3F2782"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M102.801 75.1123L109.746 81.3502H109.179L102.233 75.1123H102.801Z",
    fill: "#E6DCB3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 81,
    width: 7,
    height: 7
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M104.173 87.2275C102.128 85.3911 100.084 83.5547 98.0396 81.7183C100.123 83.5896 102.901 86.0848 104.984 87.9561C104.714 87.7128 104.444 87.4702 104.173 87.2275Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1895 78.1504L94.1341 84.3882C94.9337 85.1062 95.8208 85.725 96.7851 86.2353C98.9609 87.3618 101.497 87.9706 104.254 87.9706C104.496 87.9706 104.739 87.9656 104.984 87.9563L98.0396 81.7184C97.7944 81.7278 97.5511 81.7328 97.3097 81.7328C94.5514 81.7328 92.0163 81.124 89.8399 79.9974C88.8762 79.4872 87.9891 78.8684 87.1895 78.1504Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 78,
    width: 17,
    height: 10
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1909 78.0029C90.7148 80.2698 94.1125 81.5878 98.0405 81.7163L104.985 87.9542C101.057 87.825 97.6593 86.5076 95.1355 84.2408C93.0521 82.3694 90.2744 79.8743 88.1909 78.0029Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1909 78.0029L95.1355 84.2408C97.6593 86.5076 101.057 87.8257 104.985 87.9542L98.0405 81.7163C94.1125 81.5878 90.7148 80.2704 88.1909 78.0029Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 78,
    width: 17,
    height: 10
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M104.985 87.9542C101.058 87.825 97.6598 86.5076 95.136 84.2408L88.1914 78.0029C90.7152 80.2698 94.113 81.5872 98.0403 81.7163C100.123 83.5877 102.901 86.0828 104.985 87.9542Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0395 81.7163L104.984 87.9542C101.056 87.825 97.6584 86.5076 95.1345 84.2408L88.1899 78.0029C90.7144 80.2698 94.1121 81.5872 98.0395 81.7163Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 78,
    width: 18,
    height: 10
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M94.135 84.3873L87.1904 78.1494C87.9901 78.8674 88.8771 79.4868 89.8415 79.9964C92.0173 81.123 94.553 81.7318 97.3113 81.7318C97.5527 81.7318 97.796 81.7268 98.0412 81.7175L104.986 87.9553C104.741 87.9647 104.497 87.9697 104.256 87.9697C101.498 87.9697 98.9625 87.3608 96.7867 86.2343C95.8217 85.7247 94.9347 85.1052 94.135 84.3873Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0396 81.7175L104.984 87.9553C104.739 87.9647 104.496 87.9697 104.254 87.9697C101.496 87.9697 98.9609 87.3608 96.7851 86.2343C95.8208 85.7247 94.9337 85.1059 94.1341 84.3873L87.1895 78.1494C87.9891 78.8674 88.8762 79.4868 89.8405 79.9964C92.0163 81.123 94.552 81.7318 97.3104 81.7318C97.5518 81.7312 97.795 81.7268 98.0396 81.7175Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 78,
    width: 13,
    height: 10
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7862 86.2331C95.8524 85.7396 94.9909 85.1439 94.2118 84.4546C93.9685 84.2363 93.6442 83.9444 93.4009 83.7261C93.1427 83.4946 92.7989 83.1853 92.5407 82.9538C92.2731 82.7131 91.9157 82.3924 91.6481 82.1523C91.3755 81.9071 91.0118 81.5809 90.7392 81.3357C90.4666 81.0906 90.103 80.7643 89.8304 80.5192C89.5628 80.279 89.2053 79.9578 88.9377 79.7176C88.6795 79.4856 88.3358 79.1768 88.0775 78.9454C87.8342 78.7271 87.5099 78.4351 87.2666 78.2168C88.0463 78.9061 88.9072 79.5018 89.841 79.9952C90.781 80.4818 91.7884 80.8716 92.8513 81.158C95.1662 83.237 97.4811 85.3167 99.7959 87.3958C98.733 87.1095 97.7262 86.7196 96.7862 86.2331Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1484L94.1345 84.3863C94.9342 85.1043 95.8213 85.7231 96.7856 86.2333C98.9614 87.3599 101.497 87.9687 104.255 87.9687C104.496 87.9687 104.74 87.9637 104.985 87.9543L98.04 81.7165C97.7949 81.7258 97.5516 81.7308 97.3102 81.7308C94.5518 81.7308 92.0168 81.122 89.8404 79.9955C88.8767 79.4852 87.9896 78.8664 87.1899 78.1484Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 81,
    width: 10,
    height: 7
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8163 87.4019C99.0815 86.7419 98.3467 86.082 97.6119 85.422C96.0318 84.0029 94.4518 82.5832 92.8711 81.1641C93.3807 81.3007 93.9035 81.4129 94.4374 81.5009C96.7523 83.58 99.0671 85.6597 101.382 87.7387C100.849 87.6508 100.326 87.5385 99.8163 87.4019Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1895 78.1509L94.1341 84.3887C94.9337 85.1067 95.8208 85.7255 96.7851 86.2357C98.9609 87.3623 101.497 87.9711 104.254 87.9711C104.496 87.9711 104.739 87.9661 104.984 87.9568L98.0396 81.7189C97.7944 81.7283 97.5511 81.7333 97.3097 81.7333C94.5514 81.7333 92.0163 81.1245 89.8399 79.9979C88.8762 79.4876 87.9891 78.8689 87.1895 78.1509Z",
    fill: "#6D44E5"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M116.492 30.0303C116.736 30.0303 116.976 30.0353 117.216 30.0446C111.149 30.2392 104.279 33.1417 98.3996 37.9162C92.5104 42.6713 87.6954 49.2491 85.2602 55.8812C82.7688 62.5126 82.7058 69.091 85.0655 73.8461C87.3991 78.6256 92.1168 81.5231 98.0396 81.7177C97.7945 81.7271 97.5512 81.732 97.3098 81.732C94.5514 81.732 92.0164 81.1232 89.84 79.9967C87.4852 78.7522 85.5914 76.8559 84.3064 74.4543C83.0158 72.0571 82.3546 69.1453 82.3477 65.9653C82.3408 62.7852 83.0195 59.3338 84.2877 55.8818C85.5814 52.4298 87.4646 48.9777 89.8294 45.7933C92.1991 42.6183 95.0174 39.7064 98.0914 37.3092C101.155 34.9076 104.46 33.0114 107.739 31.7669C110.752 30.6354 113.736 30.0303 116.492 30.0303Z",
    fill: "url(#paint0_linear_10961_47271)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M123.854 41.0386L120.75 44.291L115.547 44.3496C115.658 44.6584 115.75 45.13 115.78 45.7182C115.809 46.3064 115.778 47.0113 115.643 47.7873H121.203L118.134 51.0154H115.09H114.522C110.019 59.2905 101.952 59.5487 101.527 59.5625L106.969 75.1109H102.801L96.9263 60.185L98.0778 57.0829C98.0778 57.0829 98.0778 57.0829 98.6454 57.0829C98.6454 57.0829 98.6454 57.0829 101.746 57.0829H102.314C106.567 57.0829 109.675 54.0732 111.025 51.0154H99.2842L102.615 47.7873H111.199H111.767C111.713 44.8262 108.608 44.2916 107.413 44.2916H106.845C105.09 44.2916 102.484 44.2916 102.346 44.2916C101.994 44.2916 101.789 44.2916 101.779 44.2916L105.033 41.0392H123.854V41.0386Z",
    fill: "#3F2782"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106.969 75.1113L101.527 59.5635L108.472 65.8013L113.914 81.3492L106.969 75.1113Z",
    fill: "#CE9509"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M101.527 59.5635L108.472 65.8013L113.914 81.3492L106.969 75.1113L101.527 59.5635Z",
    fill: "#F5D961"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M106.969 75.1123L113.914 81.3502H109.746L102.801 75.1123H106.969Z",
    fill: "#3F2782"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M106.969 75.1123H107.541L114.485 81.3502H113.914L106.969 75.1123Z",
    fill: "#3F2782"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M107.541 75.11L102.091 59.5615L109.035 65.7994L114.485 81.3478L107.541 75.11Z",
    fill: "#F0CA2B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M102.091 59.5635L109.035 65.8013L114.486 81.3492L107.541 75.1113L102.091 59.5635Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M107.541 75.1123L114.486 81.3502H113.914L106.969 75.1123H107.541Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 37,
    width: 41,
    height: 51
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M130.186 37.9194L137.13 44.1573C139.49 48.9124 139.427 55.4902 136.94 62.1223C134.5 68.7537 129.685 75.3321 123.796 80.0872C117.917 84.8617 111.047 87.7642 104.984 87.9588L98.0396 81.7209C104.103 81.5263 110.972 78.6238 116.852 73.8494C122.741 69.0943 127.556 62.5165 129.995 55.8844C132.482 49.2523 132.545 42.6739 130.186 37.9194Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.186 37.9194L137.13 44.1573C137.266 44.4311 137.394 44.7112 137.514 44.9969L130.569 38.759C130.449 38.4733 130.322 38.1933 130.186 37.9194Z",
    fill: "#ECC72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.569 38.7583L137.514 44.9961C137.668 45.3636 137.809 45.741 137.937 46.1265L130.992 39.8886C130.864 39.5031 130.723 39.1257 130.569 38.7583Z",
    fill: "#EDC82B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.992 39.8892L137.937 46.127C138.073 46.5393 138.194 46.9623 138.3 47.3933L131.356 41.1554C131.25 40.7244 131.129 40.3015 130.992 39.8892Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.356 41.1553L138.301 47.3931C138.417 47.8653 138.515 48.3488 138.594 48.8415L131.649 42.6037C131.569 42.1109 131.472 41.6281 131.356 41.1553Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.649 42.604L138.594 48.8418C138.684 49.4033 138.751 49.9778 138.794 50.5629L131.85 44.325C131.807 43.7399 131.739 43.1654 131.649 42.604Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 44.3252L138.795 50.563C138.848 51.2773 138.865 52.0071 138.848 52.7506L131.903 46.5128C131.921 45.7692 131.903 45.0394 131.85 44.3252Z",
    fill: "#F1CB2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.902 46.5137L138.847 52.7515C138.821 53.8519 138.718 54.9809 138.537 56.1293L131.593 49.8915C131.773 48.7437 131.877 47.614 131.902 46.5137Z",
    fill: "#F2CC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.593 49.8916L138.538 56.1294C138.23 58.0888 137.697 60.1029 136.94 62.1221C136.806 62.4871 136.664 62.852 136.516 63.2169L129.571 56.979C129.72 56.6147 129.861 56.2498 129.995 55.8843C130.753 53.8651 131.285 51.8509 131.593 49.8916Z",
    fill: "#F3CD2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.571 56.9775L136.516 63.2154C136.055 64.3476 135.526 65.4754 134.936 66.5894L127.992 60.3516C128.581 59.2375 129.11 58.1097 129.571 56.9775Z",
    fill: "#F2CC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.992 60.3525L134.936 66.5904C134.532 67.3545 134.099 68.1124 133.64 68.8616L126.695 62.6237C127.154 61.8752 127.587 61.1173 127.992 60.3525Z",
    fill: "#F1CB2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.695 62.6245L133.639 68.8624C133.257 69.4849 132.857 70.1012 132.44 70.7094L125.495 64.4715C125.913 63.8633 126.313 63.247 126.695 62.6245Z",
    fill: "#F0CA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.496 64.4702L132.441 70.7081C132.068 71.2508 131.682 71.7872 131.283 72.3162L124.339 66.0783C124.737 65.5494 125.124 65.0129 125.496 64.4702Z",
    fill: "#EFCA2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.339 66.0786L131.283 72.3165C130.913 72.8074 130.533 73.2914 130.142 73.768L123.197 67.5302C123.588 67.053 123.969 66.5689 124.339 66.0786Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.197 67.5303L130.141 73.7681C129.773 74.2179 129.395 74.6608 129.009 75.0962L122.064 68.8583C122.451 68.4229 122.828 67.98 123.197 67.5303Z",
    fill: "#EDC82B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.064 68.8579L129.008 75.0958C128.637 75.5143 128.259 75.9254 127.872 76.3296L120.927 70.0918C121.314 69.6875 121.693 69.2765 122.064 68.8579Z",
    fill: "#ECC72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.928 70.0928L127.873 76.3306C127.499 76.7217 127.118 77.106 126.731 77.4821L119.787 71.2443C120.173 70.8681 120.554 70.4839 120.928 70.0928Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.786 71.2437L126.731 77.4815C126.349 77.852 125.962 78.2151 125.569 78.57L118.625 72.3322C119.017 71.9772 119.405 71.6142 119.786 71.2437Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.624 72.334L125.569 78.5718C125.17 78.9324 124.765 79.2848 124.354 79.6285L117.409 73.3907C117.82 73.0463 118.226 72.6945 118.624 72.334Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41 73.3896L124.355 79.6275C124.17 79.7822 123.984 79.935 123.797 80.0866C123.557 80.2819 123.315 80.4733 123.072 80.6624L116.127 74.4245C116.371 74.2361 116.612 74.044 116.852 73.8488C117.039 73.6978 117.225 73.5443 117.41 73.3896Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.127 74.4233L123.071 80.6612C122.64 80.9955 122.205 81.3199 121.764 81.6337L114.82 75.3958C115.26 75.0821 115.696 74.7577 116.127 74.4233Z",
    fill: "#E7C32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82 75.397L121.764 81.6348C121.299 81.9667 120.829 82.2873 120.355 82.5961L113.411 76.3582C113.885 76.0494 114.354 75.7288 114.82 75.397Z",
    fill: "#E6C22A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.411 76.3579L120.356 82.5958C119.843 82.9295 119.327 83.2489 118.807 83.5545L111.863 77.3167C112.383 77.011 112.9 76.6916 113.411 76.3579Z",
    fill: "#E5C129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.863 77.3174L118.807 83.5552C118.233 83.8927 117.654 84.2127 117.073 84.5146L110.128 78.2768C110.71 77.9748 111.288 77.6549 111.863 77.3174Z",
    fill: "#E4C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.128 78.2769L117.072 84.5147C116.399 84.864 115.722 85.189 115.043 85.489L108.099 79.2512C108.778 78.9512 109.455 78.6262 110.128 78.2769Z",
    fill: "#E3C029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 79.2495L115.044 85.4874C114.189 85.8647 113.333 86.2016 112.477 86.4966L105.532 80.2588C106.387 79.9637 107.245 79.6269 108.099 79.2495Z",
    fill: "#E2BF29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.532 80.2588L112.477 86.4966C109.927 87.3755 107.392 87.8802 104.984 87.9575L98.0396 81.7197C100.447 81.6423 102.982 81.1377 105.532 80.2588Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 33,
    width: 41,
    height: 55
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M134.006 39.9957C135.288 41.1472 136.345 42.5438 137.131 44.1538C139.491 48.9089 139.428 55.4867 136.941 62.1188C134.501 68.7503 129.686 75.3287 123.797 80.0838C117.918 84.8583 111.048 87.7607 104.985 87.9553L98.0405 81.7175C104.104 81.5229 110.973 78.6204 116.853 73.846C122.742 69.0909 127.557 62.513 129.996 55.881C132.483 49.2495 132.546 42.6711 130.187 37.916C129.401 36.306 128.344 34.9093 127.061 33.7578C129.144 35.6292 131.923 38.1243 134.006 39.9957Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.7182L104.985 87.9561C107.392 87.8787 109.928 87.3747 112.478 86.4952L105.533 80.2573C102.984 81.1362 100.448 81.6409 98.04 81.7182Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.533 80.2568L112.477 86.4947C113.333 86.1996 114.19 85.8628 115.044 85.4854L108.1 79.2476C107.245 79.6249 106.388 79.9618 105.533 80.2568Z",
    fill: "#E8DEB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1 79.2483L115.045 85.4861C115.723 85.1867 116.4 84.8617 117.074 84.5118L110.129 78.2739C109.456 78.6239 108.779 78.9489 108.1 79.2483Z",
    fill: "#E9DFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.129 78.2738L117.073 84.5117C117.655 84.2098 118.234 83.8898 118.808 83.5523L111.864 77.3145C111.289 77.6519 110.71 77.9719 110.129 78.2738Z",
    fill: "#EAE0B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.863 77.3147L118.808 83.5526C119.327 83.2469 119.844 82.9275 120.356 82.5938L113.412 76.356C112.9 76.6897 112.384 77.0091 111.863 77.3147Z",
    fill: "#EBE0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.411 76.3558L120.356 82.5936C120.829 82.2848 121.3 81.9642 121.765 81.6324L114.82 75.3945C114.355 75.7264 113.885 76.047 113.411 76.3558Z",
    fill: "#ECE1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82 75.3942L121.765 81.632C122.212 81.3133 122.653 80.9839 123.09 80.6446L116.146 74.4067C115.709 74.7461 115.267 75.0754 114.82 75.3942Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.146 74.4071L123.091 80.6449C123.328 80.4609 123.563 80.2744 123.797 80.0841C123.995 79.9238 124.192 79.7623 124.387 79.5982L117.443 73.3604C117.247 73.5244 117.05 73.6866 116.852 73.8463C116.618 74.0359 116.383 74.2231 116.146 74.4071Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.443 73.3603L124.387 79.5981C124.787 79.2632 125.181 78.9201 125.57 78.5689L118.625 72.3311C118.236 72.6816 117.843 73.0253 117.443 73.3603Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.625 72.3312L125.57 78.569C125.963 78.2141 126.35 77.8504 126.731 77.4805L119.786 71.2427C119.405 71.6126 119.018 71.9756 118.625 72.3312Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.786 71.2423L126.731 77.4802C127.118 77.1034 127.499 76.7198 127.873 76.3287L120.928 70.0908C120.554 70.4813 120.174 70.8656 119.786 71.2423Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.929 70.0908L127.873 76.3286C128.259 75.9244 128.639 75.5127 129.01 75.0948L122.065 68.8569C121.693 69.2755 121.315 69.6866 120.929 70.0908Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.064 68.8568L129.009 75.0947C129.396 74.6593 129.773 74.2164 130.142 73.7667L123.197 67.5288C122.829 67.9786 122.451 68.4214 122.064 68.8568Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.197 67.5287L130.142 73.7665C130.533 73.29 130.913 72.8053 131.283 72.315L124.339 66.0771C123.97 66.5674 123.588 67.0515 123.197 67.5287Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.339 66.0769L131.284 72.3147C131.683 71.7857 132.069 71.2493 132.441 70.7066L125.496 64.4688C125.124 65.0108 124.738 65.5473 124.339 66.0769Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.497 64.4681L132.441 70.706C132.858 70.0978 133.258 69.4815 133.641 68.8589L126.696 62.6211C126.314 63.2436 125.914 63.8599 125.497 64.4681Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.695 62.6208L133.64 68.8586C134.099 68.1095 134.532 67.3516 134.936 66.5875L127.992 60.3496C127.588 61.1144 127.155 61.8723 126.695 62.6208Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.992 60.3511L134.937 66.5889C135.526 65.4742 136.055 64.3471 136.516 63.2149L129.572 56.9771C129.11 58.1092 128.582 59.237 127.992 60.3511Z",
    fill: "#F8EDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.572 56.9751L136.516 63.213C136.665 62.8487 136.806 62.4838 136.941 62.1182C137.698 60.099 138.231 58.0848 138.538 56.1255L131.593 49.8877C131.286 51.847 130.753 53.8612 129.996 55.8804C129.862 56.2459 129.72 56.6108 129.572 56.9751Z",
    fill: "#F9EEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.593 49.889L138.538 56.1269C138.718 54.9791 138.822 53.8494 138.847 52.7491L131.903 46.5112C131.877 47.6116 131.774 48.7413 131.593 49.889Z",
    fill: "#F8EDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.903 46.5108L138.847 52.7487C138.865 52.0051 138.847 51.2747 138.794 50.5611L131.85 44.3232C131.903 45.0375 131.921 45.7673 131.903 46.5108Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 44.3231L138.795 50.5609C138.752 49.9758 138.684 49.4013 138.594 48.8399L131.649 42.6021C131.74 43.1635 131.807 43.738 131.85 44.3231Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65 42.6027L138.594 48.8406C138.514 48.3478 138.417 47.8643 138.301 47.3921L131.356 41.1543C131.472 41.6265 131.57 42.1093 131.65 42.6027Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.356 41.153L138.301 47.3908C138.195 46.9592 138.074 46.5369 137.937 46.1246L130.993 39.8867C131.129 40.299 131.25 40.722 131.356 41.153Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.993 39.8871L137.937 46.125C137.809 45.7395 137.668 45.3621 137.514 44.9947L130.57 38.7568C130.724 39.1242 130.865 39.5016 130.993 39.8871Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57 38.7567L137.515 44.9945C137.395 44.7088 137.267 44.4287 137.131 44.1549C137.097 44.0857 137.063 44.0164 137.028 43.9478L130.083 37.71C130.118 37.7786 130.153 37.8478 130.186 37.9171C130.322 38.1909 130.45 38.471 130.57 38.7567Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.083 37.7098L137.028 43.9476C136.851 43.6002 136.662 43.2633 136.46 42.9371L129.516 36.6992C129.717 37.0255 129.907 37.3623 130.083 37.7098Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.516 36.6983L136.46 42.9362C136.269 42.6268 136.066 42.3267 135.854 42.0367L128.909 35.7988C129.122 36.0895 129.324 36.3889 129.516 36.6983Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.909 35.8005L135.854 42.0383C135.638 41.7439 135.411 41.4594 135.173 41.1856L128.229 34.9478C128.466 35.2216 128.693 35.506 128.909 35.8005Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.228 34.9465L135.173 41.1843C134.93 40.9042 134.676 40.6348 134.411 40.3765L127.467 34.1387C127.731 34.3969 127.985 34.6664 128.228 34.9465Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.467 34.1387L134.412 40.3765C134.279 40.2468 134.143 40.1201 134.006 39.9966L127.061 33.7588C127.199 33.8823 127.334 34.0089 127.467 34.1387Z",
    fill: "#3F2782"
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M131.126 38.0752C133.486 42.8303 133.423 49.4081 130.936 56.0401C128.496 62.6716 123.681 69.25 117.792 74.0051C111.913 78.7796 105.043 81.6821 98.98 81.8767C93.0571 81.6821 88.3395 78.7846 86.0059 74.0051C83.6461 69.25 83.7091 62.6722 86.2005 56.0401C88.6358 49.4087 93.4507 42.8303 99.3399 38.0752C105.219 33.3007 112.089 30.3982 118.156 30.2036C124.075 30.3976 128.793 33.2957 131.126 38.0752ZM117.155 47.9447C117.42 46.3939 117.272 45.1245 117.054 44.5076L122.258 44.449L125.362 41.1966H124.794H105.974H105.402L102.153 44.449C102.374 44.449 106.586 44.449 107.787 44.449C108.982 44.449 112.086 44.9836 112.141 47.886L103.557 47.9447H102.989L99.658 51.1728H111.395C110.903 52.2899 110.176 53.3997 109.244 54.3597C107.623 56.0277 105.384 57.2403 102.687 57.2403C99.5863 57.2403 99.5863 57.2403 99.5863 57.2403C99.0186 57.2403 99.0187 57.2403 99.0187 57.2403C98.451 57.2403 98.451 57.2403 98.451 57.2403L97.3014 60.3374L103.174 75.2683H107.909H108.481L103.031 59.7198C103.456 59.7061 111.527 59.4479 116.007 51.2114L119.075 51.1728H119.643L122.712 47.9447H122.144H117.155Z",
    fill: "url(#paint1_linear_10961_47271)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 78,
    width: 8,
    height: 7
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1352 84.3873L87.1899 78.1494C87.2155 78.1725 87.2411 78.195 87.2667 78.2174C89.5815 80.2965 91.8964 82.3762 94.2113 84.4553C94.1857 84.4328 94.1601 84.4097 94.1352 84.3873Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1494L94.1345 84.3873C94.9342 85.1052 95.8213 85.724 96.7856 86.2343C98.9614 87.3608 101.497 87.9697 104.255 87.9697C104.496 87.9697 104.74 87.9647 104.985 87.9553L98.04 81.7175C97.7949 81.7268 97.5516 81.7318 97.3102 81.7318C94.5518 81.7318 92.0168 81.123 89.8404 79.9964C88.8767 79.4862 87.9896 78.8674 87.1899 78.1494Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 25,
    width: 20,
    height: 11
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M138.385 35.5752C135.321 32.8231 131.133 31.2418 126.032 31.2418L119.087 25.0039C124.188 25.0039 128.376 26.5846 131.44 29.3374C133.524 31.2087 136.301 33.7038 138.385 35.5752Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.087 25.0039L126.032 31.2418C131.133 31.2418 135.321 32.8224 138.385 35.5752L131.44 29.3374C128.376 26.5852 124.188 25.0039 119.087 25.0039Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 33,
    width: 11,
    height: 12
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M134.006 39.9957C135.288 41.1472 136.345 42.5438 137.131 44.1544L130.186 37.9166C129.4 36.3066 128.343 34.9093 127.061 33.7578C129.144 35.6292 131.922 38.1243 134.006 39.9957Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.061 33.7578L134.006 39.9957C134.143 40.1198 134.279 40.2464 134.412 40.3755L127.467 34.1377C127.334 34.0086 127.199 33.8819 127.061 33.7578Z",
    fill: "#E7C32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.467 34.1387L134.412 40.3765C134.676 40.6348 134.93 40.9042 135.173 41.1843L128.228 34.9465C127.986 34.6664 127.732 34.3969 127.467 34.1387Z",
    fill: "#E8C42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.229 34.9453L135.174 41.1832C135.411 41.457 135.638 41.7414 135.854 42.0359L128.91 35.798C128.693 35.5036 128.466 35.2192 128.229 34.9453Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.909 35.7993L135.854 42.0372C136.066 42.3272 136.269 42.6273 136.46 42.9367L129.515 36.6988C129.324 36.3894 129.122 36.09 128.909 35.7993Z",
    fill: "#EAC52A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.516 36.6982L136.461 42.9361C136.651 43.2442 136.831 43.5624 136.999 43.8892L130.054 37.6514C129.886 37.3245 129.706 37.007 129.516 36.6982Z",
    fill: "#EBC62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.054 37.6514L136.999 43.8892C137.044 43.9765 137.088 44.0651 137.132 44.1537L130.187 37.9159C130.143 37.8273 130.099 37.7387 130.054 37.6514Z",
    fill: "#ECC72B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 81,
    width: 8,
    height: 7
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3767 86.113C98.8564 86.544 99.3367 86.975 99.8164 87.4061C99.8095 87.4042 99.8027 87.4023 99.7964 87.4004C99.5532 87.1821 99.2288 86.8902 98.9849 86.6719C98.7266 86.4404 98.3829 86.131 98.1247 85.8996C97.8571 85.6588 97.5003 85.3382 97.232 85.098C96.9595 84.8535 96.5958 84.5267 96.3232 84.2815C96.0506 84.0364 95.6869 83.7101 95.4143 83.465C95.1467 83.2248 94.7893 82.9036 94.5217 82.6634C94.2641 82.432 93.9198 82.1226 93.6615 81.8912C93.4182 81.6729 93.0939 81.3809 92.8506 81.1626C92.8574 81.1645 92.8643 81.1663 92.8706 81.1682C94.707 82.8169 96.5415 84.4649 98.3767 86.113Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1519L94.1345 84.3897C94.9342 85.1077 95.8213 85.7265 96.7856 86.2367C98.9614 87.3633 101.497 87.9721 104.255 87.9721C104.496 87.9721 104.74 87.9671 104.985 87.9577L98.04 81.7199C97.7949 81.7293 97.5516 81.7343 97.3102 81.7343C94.5518 81.7343 92.0168 81.1254 89.8404 79.9989C88.8767 79.4886 87.9896 78.8698 87.1899 78.1519Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 81,
    width: 9,
    height: 7
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M101.382 87.7393C101.139 87.521 100.815 87.2291 100.571 87.0107C100.313 86.7793 99.9689 86.4699 99.7106 86.2385C99.443 85.9983 99.0856 85.6771 98.818 85.4369C98.5454 85.1918 98.1817 84.8655 97.9091 84.6204C97.309 84.0808 96.7083 83.5419 96.1076 83.0023C95.5506 82.502 94.9936 82.0017 94.4365 81.5015C94.8077 81.5626 95.1851 81.6119 95.5674 81.6487C95.8107 81.867 96.1351 82.1589 96.3784 82.3773C96.6366 82.6087 96.9803 82.9181 97.2386 83.1495C97.5062 83.3897 97.8636 83.7103 98.1312 83.9511C98.4038 84.1956 98.7675 84.5225 99.04 84.7676C99.6408 85.3072 100.241 85.8461 100.842 86.3857C101.399 86.886 101.956 87.3863 102.513 87.8865C102.131 87.8497 101.754 87.8004 101.382 87.7393Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1895 78.1504L94.1341 84.3882C94.9337 85.1062 95.8208 85.725 96.7851 86.2353C98.9609 87.3618 101.497 87.9706 104.254 87.9706C104.496 87.9706 104.739 87.9656 104.984 87.9563L98.0396 81.7184C97.7944 81.7278 97.5511 81.7328 97.3097 81.7328C94.5514 81.7328 92.0163 81.124 89.8399 79.9974C88.8762 79.4872 87.9891 78.8684 87.1895 78.1504Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 81,
    width: 8,
    height: 7
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M102.514 87.8814C100.199 85.8023 97.8842 83.7226 95.5693 81.6436C95.5749 81.6442 95.5806 81.6448 95.5862 81.6454C97.901 83.7245 100.216 85.8042 102.531 87.8833C102.525 87.8826 102.52 87.882 102.514 87.8814Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1465L94.1345 84.3843C94.9342 85.1023 95.8213 85.7211 96.7856 86.2314C98.9614 87.3579 101.497 87.9667 104.255 87.9667C104.496 87.9667 104.74 87.9617 104.985 87.9524L98.04 81.7145C97.7949 81.7239 97.5516 81.7289 97.3102 81.7289C94.5518 81.7289 92.0168 81.1201 89.8404 79.9935C88.8767 79.4833 87.9896 78.8645 87.1899 78.1465Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 81,
    width: 8,
    height: 7
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4049 85.0672C100.453 86.0085 101.501 86.9498 102.549 87.8911C102.543 87.8905 102.537 87.8898 102.531 87.8892C102.287 87.6709 101.963 87.379 101.719 87.1606C101.461 86.9292 101.117 86.6198 100.859 86.3884C100.258 85.8488 99.6581 85.3099 99.0574 84.7703C98.7848 84.5251 98.4212 84.1989 98.1486 83.9538C97.881 83.7136 97.5242 83.3924 97.256 83.1522C96.9983 82.9208 96.654 82.6114 96.3964 82.3799C96.1531 82.1616 95.8287 81.8697 95.5854 81.6514C95.5917 81.652 95.5973 81.6526 95.6035 81.6532C96.8711 82.791 98.138 83.9288 99.4049 85.0672Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1504L94.1345 84.3882C94.9342 85.1062 95.8213 85.725 96.7856 86.2353C98.9614 87.3618 101.497 87.9706 104.255 87.9706C104.496 87.9706 104.74 87.9656 104.985 87.9563L98.04 81.7184C97.7949 81.7278 97.5516 81.7328 97.3102 81.7328C94.5518 81.7328 92.0168 81.124 89.8404 79.9974C88.8767 79.4872 87.9896 78.8684 87.1899 78.1504Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 81,
    width: 7,
    height: 7
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M102.421 85.6525C103.275 86.4204 104.131 87.1882 104.985 87.9561C102.67 85.877 100.355 83.7973 98.0405 81.7183C99.5002 83.0295 100.96 84.3407 102.421 85.6525Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.719L104.985 87.9569C105.224 87.9662 105.464 87.9712 105.708 87.9712C108.223 87.9712 110.933 87.4672 113.675 86.5215L106.73 80.2837C103.988 81.2287 101.278 81.7334 98.763 81.7334C98.5204 81.7327 98.2796 81.7284 98.04 81.719Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 81,
    width: 7,
    height: 7
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M102.421 85.6531C103.275 86.421 104.13 87.1882 104.985 87.9561C102.902 86.0848 100.124 83.5896 98.0405 81.7183C99.5002 83.0301 100.96 84.3419 102.421 85.6531Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.719L104.985 87.9569C105.224 87.9662 105.464 87.9712 105.708 87.9712C108.223 87.9712 110.933 87.4672 113.675 86.5215L106.73 80.2837C103.988 81.2287 101.278 81.7334 98.763 81.7334C98.5204 81.7327 98.2796 81.7284 98.04 81.719Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 81,
    width: 10,
    height: 7
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M104.174 87.2281C104.444 87.4707 104.714 87.714 104.985 87.9567C104.74 87.966 104.497 87.971 104.255 87.971C103.676 87.971 103.107 87.9442 102.549 87.8912C100.234 85.8121 97.9189 83.7324 95.604 81.6533C96.1623 81.7063 96.7318 81.7332 97.3107 81.7332C97.5521 81.7332 97.7954 81.7282 98.0405 81.7188C98.2071 81.8685 98.3742 82.0189 98.5408 82.1686C100.418 83.8547 102.296 85.5414 104.174 87.2281Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1899 78.1504L94.1345 84.3882C94.9342 85.1062 95.8213 85.725 96.7856 86.2353C98.9614 87.3618 101.497 87.9706 104.255 87.9706C104.496 87.9706 104.74 87.9656 104.985 87.9563L98.04 81.7184C97.7949 81.7278 97.5516 81.7328 97.3102 81.7328C94.5518 81.7328 92.0168 81.124 89.8404 79.9974C88.8767 79.4872 87.9896 78.8684 87.1899 78.1504Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 33,
    width: 42,
    height: 55
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6152L135.012 39.8531C136.164 40.8879 137.134 42.1293 137.89 43.5459C139.185 45.9425 139.842 48.8549 139.853 52.035C139.855 55.2144 139.177 58.6664 137.913 62.1184C136.619 65.5705 134.732 69.0225 132.367 72.2069C129.997 75.382 127.179 78.2938 124.109 80.691C121.042 83.0926 117.736 84.9889 114.455 86.2383C111.449 87.3642 108.461 87.9687 105.708 87.9687C105.465 87.9687 105.225 87.9637 104.985 87.9544L98.0405 81.7165C98.2794 81.7259 98.5202 81.7309 98.7635 81.7309C101.517 81.7309 104.505 81.1264 107.511 80.0005C110.791 78.751 114.097 76.8547 117.165 74.4532C120.235 72.056 123.053 69.1441 125.422 65.9691C127.786 62.7846 129.674 59.3326 130.968 55.8806C132.232 52.4286 132.911 48.9765 132.908 45.7971C132.897 42.6177 132.24 39.7053 130.945 37.308C130.189 35.8914 129.219 34.6507 128.067 33.6152Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.067 33.6152L135.012 39.8531C135.147 39.9747 135.28 40.0989 135.41 40.2255L128.465 33.9876C128.335 33.861 128.202 33.7369 128.067 33.6152Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.465 33.9878L135.409 40.2256C135.671 40.4808 135.922 40.7471 136.162 41.0247L129.218 34.7869C128.977 34.5093 128.726 34.2429 128.465 33.9878Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.217 34.7881L136.162 41.0259C136.398 41.2985 136.623 41.5811 136.839 41.8743L129.894 35.6364C129.68 35.3433 129.454 35.0601 129.217 34.7881Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.894 35.6362L136.839 41.8741C137.052 42.1648 137.254 42.4648 137.446 42.7748L130.501 36.537C130.309 36.2276 130.107 35.9269 129.894 35.6362Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.501 36.5347L137.446 42.7725C137.601 43.0239 137.749 43.2809 137.889 43.5448C137.934 43.6277 137.978 43.7119 138.021 43.7961L131.077 37.5583C131.033 37.4741 130.989 37.3899 130.944 37.3069C130.804 37.0437 130.656 36.7861 130.501 36.5347Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.078 37.5601L138.022 43.7979C138.193 44.1291 138.351 44.4703 138.498 44.8197L131.554 38.5818C131.406 38.2325 131.248 37.8913 131.078 37.5601Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.553 38.5815L138.498 44.8194C138.653 45.1887 138.794 45.5673 138.923 45.9553L131.978 39.7175C131.85 39.3288 131.708 38.9502 131.553 38.5815Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.978 39.7173L138.923 45.9551C139.06 46.3718 139.183 46.7985 139.29 47.2351L132.345 40.9973C132.238 40.5613 132.116 40.134 131.978 39.7173Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.346 40.9971L139.29 47.2349C139.408 47.714 139.507 48.2049 139.588 48.7058L132.644 42.468C132.563 41.9671 132.464 41.4768 132.346 40.9971Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.644 42.4678L139.589 48.7056C139.68 49.2764 139.749 49.8596 139.793 50.4553L132.848 44.2175C132.804 43.6224 132.736 43.0385 132.644 42.4678Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.848 44.2178L139.792 50.4556C139.83 50.974 139.851 51.5004 139.853 52.035C139.853 52.2159 139.851 52.3981 139.847 52.5808L132.902 46.343C132.906 46.1602 132.908 45.9781 132.908 45.7972C132.906 45.2626 132.886 44.7361 132.848 44.2178Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.902 46.3428L139.846 52.5806C139.821 53.6779 139.717 54.805 139.536 55.9516L132.592 49.7137C132.771 48.5672 132.876 47.44 132.902 46.3428Z",
    fill: "#F8EDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.592 49.7134L139.537 55.9512C139.221 57.9673 138.672 60.0426 137.913 62.1179C137.789 62.4486 137.659 62.7785 137.525 63.1092L130.58 56.8713C130.715 56.5413 130.844 56.2107 130.968 55.8801C131.728 53.8048 132.276 51.7295 132.592 49.7134Z",
    fill: "#F9EEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 56.8726L137.525 63.1104C137.033 64.3162 136.47 65.5195 135.841 66.7078L128.896 60.4699C129.526 59.2816 130.089 58.0783 130.58 56.8726Z",
    fill: "#F8EDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.896 60.4692L135.841 66.7071C135.427 67.4899 134.983 68.2665 134.513 69.0332L127.568 62.7953C128.039 62.0281 128.482 61.2521 128.896 60.4692Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.568 62.7969L134.513 69.0347C134.13 69.6585 133.729 70.2767 133.311 70.8861L126.366 64.6483C126.785 64.0388 127.185 63.4207 127.568 62.7969Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.366 64.6465L133.311 70.8843C133.005 71.3297 132.69 71.7707 132.366 72.2067C132.31 72.2816 132.254 72.3565 132.198 72.4313L125.253 66.1935C125.31 66.1186 125.366 66.0438 125.422 65.9689C125.746 65.5329 126.061 65.0919 126.366 64.6465Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.253 66.1943L132.198 72.4322C131.832 72.9156 131.457 73.3928 131.071 73.8625L124.126 67.6247C124.512 67.155 124.887 66.6778 125.253 66.1943Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.127 67.6235L131.071 73.8614C130.695 74.3199 130.31 74.7721 129.915 75.2162L122.971 68.9784C123.365 68.5343 123.75 68.082 124.127 67.6235Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.971 68.979L129.916 75.2168C129.538 75.6429 129.152 76.0621 128.759 76.4731L121.814 70.2353C122.207 69.8236 122.593 69.405 122.971 68.979Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.814 70.2349L128.759 76.4727C128.378 76.8707 127.991 77.2612 127.597 77.6442L120.653 71.4063C121.046 71.0239 121.434 70.6328 121.814 70.2349Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.653 71.4062L127.597 77.6441C127.211 78.0196 126.819 78.387 126.422 78.7463L119.477 72.5085C119.875 72.1492 120.267 71.7818 120.653 71.4062Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.477 72.5083L126.422 78.7461C126.029 79.1011 125.631 79.4473 125.228 79.7854L118.283 73.5475C118.686 73.21 119.084 72.8632 119.477 72.5083Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.283 73.5483L125.228 79.7862C124.859 80.0956 124.486 80.3975 124.109 80.6919C124.07 80.7225 124.032 80.7524 123.993 80.7824L117.048 74.5445C117.087 74.5146 117.126 74.484 117.164 74.4541C117.542 74.1603 117.915 73.8577 118.283 73.5483Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.048 74.5444L123.993 80.7823C123.547 81.1291 123.096 81.4647 122.641 81.7897L115.696 75.5518C116.152 75.2275 116.602 74.8913 117.048 74.5444Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.696 75.5513L122.641 81.7891C122.174 82.1228 121.702 82.4441 121.227 82.7541L114.283 76.5163C114.758 76.2069 115.229 75.885 115.696 75.5513Z",
    fill: "#ECE1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.283 76.5166L121.227 82.7544C120.718 83.0863 120.205 83.4044 119.689 83.7076L112.745 77.4698C113.26 77.1666 113.774 76.8485 114.283 76.5166Z",
    fill: "#EBE0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.745 77.4688L119.689 83.7066C119.123 84.0397 118.553 84.3547 117.981 84.6516L111.037 78.4138C111.608 78.1169 112.178 77.8019 112.745 77.4688Z",
    fill: "#EAE0B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.036 78.4141L117.98 84.6519C117.326 84.9919 116.669 85.3075 116.011 85.5982L109.066 79.3603C109.724 79.0697 110.381 78.754 111.036 78.4141Z",
    fill: "#E9DFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.066 79.3613L116.011 85.5992C115.492 85.8281 114.973 86.0421 114.455 86.2392C114.194 86.3365 113.934 86.4301 113.674 86.5199L106.729 80.282C106.99 80.1922 107.25 80.0986 107.51 80.0013C108.029 79.8042 108.548 79.5909 109.066 79.3613Z",
    fill: "#E8DEB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73 80.2827L113.675 86.5206C110.933 87.4656 108.223 87.9702 105.708 87.9702C105.465 87.9702 105.224 87.9652 104.985 87.9559L98.04 81.718C98.2789 81.7274 98.5197 81.7324 98.763 81.7324C101.278 81.7318 103.988 81.2277 106.73 80.2827Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 82,
    width: 7,
    height: 6
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M101.193 82.2222C103.296 84.1104 105.398 85.9986 107.5 87.8868H107.5C107.448 87.84 107.379 87.7782 107.327 87.7314C107.272 87.6822 107.199 87.616 107.144 87.5667C107.086 87.5156 107.01 87.447 106.953 87.3958C106.895 87.3434 106.817 87.2742 106.759 87.2218C106.701 87.1694 106.623 87.1002 106.565 87.0478C106.508 86.9966 106.432 86.928 106.375 86.8769C106.32 86.8276 106.247 86.7614 106.192 86.7122C106.14 86.6654 106.071 86.6036 106.018 86.5568C104.409 85.1109 102.801 83.6669 101.193 82.2222Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0396 81.7161L104.984 87.9539C105.223 87.9633 105.464 87.9683 105.707 87.9683C108.222 87.9683 110.933 87.4643 113.674 86.5186L106.729 80.2808C103.988 81.2258 101.278 81.7304 98.7625 81.7304C98.5199 81.7298 98.2791 81.7254 98.0396 81.7161Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 81,
    width: 10,
    height: 7
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M106.017 86.5574C106.512 87.0016 107.006 87.4451 107.5 87.8892C106.893 87.9435 106.296 87.9709 105.708 87.9709C105.465 87.9709 105.225 87.9659 104.985 87.9566C102.67 85.8775 100.355 83.7978 98.0405 81.7187C98.2794 81.7281 98.5202 81.7331 98.7635 81.7331C99.3511 81.7331 99.9493 81.7056 100.556 81.6514C102.376 83.2863 104.197 84.9219 106.017 86.5574Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.7161L104.985 87.9539C105.224 87.9633 105.464 87.9683 105.708 87.9683C108.223 87.9683 110.933 87.4643 113.675 86.5186L106.73 80.2808C103.988 81.2258 101.278 81.7304 98.763 81.7304C98.5204 81.7298 98.2796 81.7254 98.04 81.7161Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 81,
    width: 8,
    height: 7
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 87.8896C105.185 85.8105 102.871 83.7308 100.556 81.6518C100.562 81.6511 100.568 81.6505 100.575 81.6499C101.732 82.6898 102.89 83.729 104.047 84.7688C105.205 85.8087 106.362 86.8479 107.52 87.8877C107.513 87.8884 107.507 87.889 107.5 87.8896Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.7205L104.985 87.9583C105.224 87.9677 105.464 87.9727 105.708 87.9727C108.223 87.9727 110.933 87.4687 113.675 86.523L106.73 80.2852C103.988 81.2302 101.278 81.7348 98.763 81.7348C98.5204 81.7342 98.2796 81.7298 98.04 81.7205Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 81,
    width: 9,
    height: 7
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M107.519 87.8859C105.204 85.8068 102.89 83.7271 100.575 81.6481C100.983 81.6113 101.396 81.562 101.812 81.5015C104.127 83.5805 106.441 85.6602 108.756 87.7393C108.341 87.8004 107.928 87.8491 107.519 87.8859Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0396 81.718L104.984 87.9559C105.223 87.9652 105.464 87.9702 105.707 87.9702C108.222 87.9702 110.933 87.4662 113.674 86.5206L106.729 80.2827C103.988 81.2277 101.278 81.7324 98.7625 81.7324C98.5199 81.7318 98.2791 81.7274 98.0396 81.718Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 81,
    width: 10,
    height: 7
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M109.134 86.1568C109.6 86.5754 110.066 86.994 110.532 87.4125C109.935 87.5448 109.343 87.6539 108.756 87.74C108.513 87.5217 108.189 87.2297 107.945 87.0114C107.687 86.7794 107.343 86.4706 107.085 86.2392C106.817 85.9984 106.46 85.6778 106.192 85.4376C105.919 85.1925 105.556 84.8662 105.283 84.6211C105.011 84.3765 104.647 84.0497 104.374 83.8052C104.107 83.5644 103.75 83.2438 103.482 83.0036C102.925 82.5033 102.368 82.0031 101.811 81.5028C102.396 81.4167 102.989 81.3075 103.586 81.1753C105.436 82.8352 107.285 84.4957 109.134 86.1568Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0396 81.718L104.984 87.9559C105.223 87.9652 105.464 87.9702 105.707 87.9702C108.222 87.9702 110.933 87.4662 113.674 86.5206L106.729 80.2827C103.988 81.2277 101.278 81.7324 98.7625 81.7324C98.5199 81.7318 98.2791 81.7274 98.0396 81.718Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 81,
    width: 8,
    height: 7
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M110.531 87.4117C110.483 87.368 110.418 87.31 110.369 87.2664C110.344 87.2439 110.311 87.2146 110.286 87.1921C110.236 87.1466 110.168 87.0861 110.117 87.0406C110.092 87.0175 110.057 86.9863 110.031 86.9632C109.979 86.9164 109.909 86.8534 109.856 86.8066C109.83 86.7829 109.795 86.7511 109.768 86.7274C109.714 86.6794 109.643 86.6151 109.589 86.5665C109.561 86.5421 109.526 86.5097 109.498 86.4854C109.444 86.4361 109.371 86.3706 109.316 86.322C109.289 86.2976 109.252 86.2646 109.225 86.2396C109.148 86.171 109.047 86.0799 108.971 86.0119C108.922 85.9683 108.857 85.9096 108.809 85.866C108.711 85.778 108.581 85.6614 108.483 85.5734C108.434 85.5298 108.369 85.4711 108.321 85.4275C108.224 85.3401 108.094 85.2241 107.998 85.1374C107.95 85.0944 107.885 85.037 107.837 84.9933C107.742 84.9085 107.616 84.7949 107.521 84.7095C107.474 84.6677 107.412 84.6122 107.366 84.5697C107.275 84.488 107.153 84.3789 107.062 84.2971C107.018 84.2572 106.958 84.2042 106.914 84.1643C106.575 83.8593 106.235 83.5542 105.895 83.2492C105.778 83.1438 105.622 83.0034 105.504 82.898C105.444 82.8444 105.365 82.7732 105.306 82.7196C105.186 82.6123 105.027 82.4689 104.907 82.3609C104.847 82.3073 104.768 82.2362 104.708 82.1825C104.591 82.0771 104.435 81.9368 104.317 81.8313C104.26 81.7802 104.184 81.7116 104.126 81.6604C104.017 81.5612 103.869 81.4296 103.76 81.3311C103.707 81.2843 103.637 81.2213 103.585 81.1745C103.656 81.1589 103.727 81.1427 103.798 81.1265C106.113 83.2055 108.428 85.2852 110.743 87.3643C110.673 87.3799 110.603 87.3955 110.531 87.4117Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0396 81.7176L104.984 87.9554C105.223 87.9648 105.464 87.9697 105.707 87.9697C108.222 87.9697 110.933 87.4657 113.674 86.5201L106.729 80.2822C103.988 81.2273 101.278 81.7319 98.7625 81.7319C98.5199 81.7313 98.2791 81.7269 98.0396 81.7176Z",
    fill: "#6D44E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 74,
    width: 22,
    height: 14
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M114.456 86.2383C113.21 86.7049 111.969 87.0816 110.745 87.363C110.501 87.1446 110.177 86.8527 109.933 86.6344C109.675 86.403 109.331 86.0936 109.073 85.8621C108.805 85.6213 108.448 85.3007 108.18 85.0606C107.908 84.8154 107.544 84.4892 107.271 84.244C106.999 83.9989 106.635 83.6727 106.363 83.4275C106.095 83.1874 105.738 82.8661 105.47 82.6259C105.212 82.3939 104.868 82.0851 104.61 81.8537C104.366 81.6354 104.042 81.3434 103.799 81.1251C105.022 80.8438 106.264 80.467 107.509 80.0004C110.79 78.751 114.096 76.8547 117.163 74.4531L124.107 80.691C121.041 83.0932 117.736 84.9888 114.456 86.2383Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.04 81.7171L104.985 87.9549C105.224 87.9643 105.464 87.9693 105.708 87.9693C108.223 87.9693 110.933 87.4652 113.675 86.5196L106.73 80.2817C103.988 81.2268 101.278 81.7314 98.763 81.7314C98.5204 81.7308 98.2796 81.7264 98.04 81.7171Z",
    fill: "#6D44E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73 80.282L113.675 86.5199C113.935 86.4301 114.195 86.3365 114.456 86.2392C114.974 86.0421 115.493 85.8281 116.011 85.5992L109.067 79.3613C108.548 79.5903 108.029 79.8042 107.511 80.0013C107.25 80.0986 106.989 80.1922 106.73 80.282Z",
    fill: "#E8C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.066 79.3613L116.011 85.5992C116.669 85.3085 117.326 84.9922 117.98 84.6529L111.036 78.415C110.381 78.755 109.724 79.0706 109.066 79.3613Z",
    fill: "#E9C739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.036 78.4157L117.981 84.6536C118.553 84.3567 119.123 84.041 119.689 83.7085L112.745 77.4707C112.178 77.8032 111.608 78.1188 111.036 78.4157Z",
    fill: "#EAC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.744 77.4702L119.689 83.7081C120.205 83.4049 120.718 83.0868 121.227 82.7549L114.282 76.5171C113.773 76.8489 113.26 77.1665 112.744 77.4702Z",
    fill: "#EBC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.283 76.5163L121.227 82.7541C121.702 82.4447 122.174 82.1228 122.641 81.7891L115.696 75.5513C115.229 75.885 114.758 76.2069 114.283 76.5163Z",
    fill: "#ECC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.696 75.5509L122.641 81.7887C123.084 81.4725 123.524 81.145 123.958 80.8082L117.014 74.5703C116.579 74.9078 116.14 75.2346 115.696 75.5509Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.014 74.5709L123.958 80.8087C124.009 80.7694 124.059 80.7308 124.109 80.6915L117.164 74.4536C117.114 74.4929 117.064 74.5322 117.014 74.5709Z",
    fill: "#3F2782"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 33,
    width: 23,
    height: 48
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M137.89 43.5459C139.185 45.9431 139.842 48.8549 139.853 52.035C139.855 55.2144 139.177 58.6664 137.913 62.1184C136.619 65.5705 134.732 69.0225 132.367 72.2069C129.997 75.382 127.179 78.2938 124.109 80.691L117.165 74.4532C120.235 72.056 123.053 69.1441 125.422 65.9691C127.787 62.7846 129.674 59.3326 130.968 55.8806C132.232 52.4286 132.911 48.9765 132.908 45.7971C132.897 42.6177 132.24 39.7053 130.945 37.3087C133.26 39.3877 135.575 41.4668 137.89 43.5459C135.575 41.4668 133.26 39.3871 130.945 37.308C130.19 35.8914 129.22 34.6501 128.067 33.6152L135.012 39.8531C136.164 40.8886 137.134 42.1293 137.89 43.5459Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.164 74.4526L124.108 80.6905C124.485 80.396 124.858 80.0941 125.227 79.7847L118.282 73.5469C117.914 73.8563 117.541 74.1582 117.164 74.4526Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.283 73.5465L125.228 79.7844C125.631 79.4463 126.029 79.1001 126.422 78.7452L119.477 72.5073C119.084 72.8623 118.686 73.2091 118.283 73.5465Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.477 72.5085L126.421 78.7463C126.819 78.387 127.211 78.019 127.597 77.6441L120.652 71.4062C120.266 71.7818 119.875 72.1492 119.477 72.5085Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 71.4049L127.597 77.6427C127.991 77.2603 128.378 76.8692 128.758 76.4712L121.814 70.2334C121.433 70.6314 121.046 71.0225 120.652 71.4049Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.814 70.2338L128.759 76.4717C129.152 76.0606 129.537 75.6414 129.915 75.2154L122.97 68.9775C122.592 69.4042 122.207 69.8228 121.814 70.2338Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.97 68.9784L129.915 75.2162C130.309 74.7721 130.695 74.3199 131.071 73.8614L124.126 67.6235C123.75 68.082 123.364 68.5343 122.97 68.9784Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.126 67.6227L131.071 73.8606C131.457 73.3909 131.832 72.9137 132.198 72.4302L125.252 66.1924C124.887 66.6758 124.512 67.153 124.126 67.6227Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.253 66.1935L132.198 72.4313C132.254 72.3565 132.31 72.2816 132.367 72.2067C132.69 71.7707 133.005 71.3297 133.311 70.8843L126.366 64.6465C126.061 65.0919 125.746 65.5329 125.422 65.9689C125.366 66.0438 125.31 66.1186 125.253 66.1935Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.366 64.6458L133.31 70.8837C133.729 70.2742 134.129 69.6561 134.512 69.0323L127.567 62.7944C127.185 63.4182 126.784 64.0364 126.366 64.6458Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.568 62.7953L134.513 69.0332C134.983 68.2665 135.427 67.4899 135.841 66.7071L128.897 60.4692C128.482 61.2515 128.038 62.0281 127.568 62.7953Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.896 60.4699L135.841 66.7078C136.469 65.5195 137.033 64.3168 137.524 63.1104L130.58 56.8726C130.088 58.0783 129.525 59.2816 128.896 60.4699Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 56.8713L137.524 63.1092C137.659 62.7792 137.788 62.4486 137.912 62.1179C138.672 60.0426 139.22 57.9673 139.537 55.9512L132.592 49.7134C132.276 51.7295 131.727 53.8048 130.968 55.8801C130.844 56.2107 130.714 56.5413 130.58 56.8713Z",
    fill: "#F9D53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.592 49.7137L139.536 55.9516C139.716 54.805 139.821 53.6779 139.846 52.5806L132.901 46.3428C132.876 47.44 132.771 48.5672 132.592 49.7137Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.902 46.3425L139.847 52.5804C139.851 52.3976 139.853 52.2154 139.853 52.0345C139.851 51.5 139.831 50.9735 139.792 50.4551L132.848 44.2173C132.886 44.7357 132.906 45.2621 132.908 45.7967C132.908 45.9776 132.906 46.1597 132.902 46.3425Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.848 44.2175L139.792 50.4553C139.748 49.8602 139.68 49.2764 139.588 48.7056L132.644 42.4678C132.735 43.0385 132.803 43.6224 132.848 44.2175Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.643 42.468L139.588 48.7058C139.507 48.2049 139.408 47.714 139.29 47.2349L132.345 40.9971C132.463 41.4761 132.562 41.9671 132.643 42.468Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.345 40.9973L139.29 47.2351C139.183 46.7985 139.06 46.3718 138.923 45.9551L131.978 39.7173C132.116 40.134 132.238 40.5606 132.345 40.9973Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.978 39.7165L138.922 45.9543C138.794 45.5663 138.652 45.1877 138.497 44.8184L131.553 38.5806C131.707 38.9498 131.849 39.3285 131.978 39.7165Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.553 38.5804L138.497 44.8182C138.351 44.4683 138.192 44.1277 138.021 43.7964L131.077 37.5586C131.248 37.8898 131.406 38.231 131.553 38.5804Z",
    fill: "#F2CF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.077 37.5583L138.022 43.7961C137.978 43.7119 137.934 43.6277 137.89 43.5448C137.749 43.2815 137.601 43.0239 137.446 42.7725L130.501 36.5347C130.657 36.7861 130.805 37.0431 130.945 37.3069C130.99 37.3899 131.034 37.4741 131.077 37.5583Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.501 36.536L137.446 42.7738C137.254 42.4638 137.052 42.1638 136.839 41.8731L129.894 35.6353C130.107 35.9259 130.309 36.2266 130.501 36.536Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.894 35.635L136.838 41.8728C136.623 41.5796 136.397 41.2971 136.161 41.0245L129.217 34.7866C129.453 35.0592 129.679 35.3424 129.894 35.635Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.217 34.7859L136.161 41.0237C135.921 40.7461 135.67 40.4798 135.408 40.2247L128.464 33.9868C128.726 34.2419 128.977 34.5083 129.217 34.7859Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.465 33.9876L135.409 40.2255C135.279 40.0982 135.147 39.9741 135.012 39.8531L128.067 33.6152C128.202 33.7362 128.334 33.8604 128.465 33.9876Z",
    fill: "#3F2782"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M117.945 30.0303C120.7 30.0303 123.239 30.6391 125.411 31.7657C127.766 33.0101 129.664 34.9064 130.945 37.308C132.24 39.7046 132.896 42.617 132.908 45.7971C132.91 48.9765 132.232 52.4285 130.968 55.8805C129.674 59.3326 127.786 62.7846 125.422 65.969C123.052 69.1441 120.234 72.0559 117.164 74.4531C114.097 76.8547 110.791 78.751 107.51 80.0004C104.504 81.1263 101.516 81.7308 98.763 81.7308C98.5204 81.7308 98.2796 81.7258 98.04 81.7164C104.103 81.5218 110.973 78.6194 116.852 73.8449C122.741 69.0898 127.556 62.512 129.996 55.8799C132.483 49.2485 132.546 42.67 130.186 37.9149C127.853 33.1355 123.135 30.238 117.216 30.0434C117.461 30.0353 117.704 30.0303 117.945 30.0303Z",
    fill: "#3F2782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_10961_47271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 29,
    width: 62,
    height: 64
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M131.44 29.3398L138.385 35.5777C144.381 40.9634 146.075 50.8348 141.886 62.1222C135.557 79.1777 118.196 93.0002 103.114 93.0002C98.0118 93.0002 93.8231 91.4195 90.759 88.6667L83.8145 82.4289C86.8785 85.181 91.0672 86.7623 96.1691 86.7623C111.252 86.7623 128.612 72.9399 134.942 55.8844C139.13 44.597 137.437 34.7256 131.44 29.3398Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_10961_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.44 29.3398L138.385 35.5777C138.547 35.723 138.705 35.8715 138.86 36.0231L131.916 29.7852C131.76 29.633 131.602 29.4846 131.44 29.3398Z",
    fill: "#6D44E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.039 34.0405L141.983 40.2784C142.197 40.6932 142.395 41.1205 142.579 41.559L135.634 35.3211C135.451 34.8826 135.252 34.4553 135.039 34.0405Z",
    fill: "#3F2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.819 30.7437L139.764 36.9815C140.05 37.3109 140.322 37.6527 140.582 38.0064L133.637 31.7685C133.378 31.4148 133.104 31.0736 132.819 30.7437Z",
    fill: "url(#paint2_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.916 29.7856L138.86 36.0235C139.175 36.3304 139.476 36.6498 139.763 36.9822L132.819 30.7444C132.531 30.4119 132.23 30.0919 131.916 29.7856Z",
    fill: "url(#paint3_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.637 31.7686L140.581 38.0064C140.841 38.3607 141.088 38.7269 141.321 39.1042L134.377 32.8664C134.143 32.489 133.897 32.1229 133.637 31.7686Z",
    fill: "url(#paint4_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.376 32.8667L141.321 39.1045C141.556 39.4844 141.776 39.8756 141.984 40.2785L135.039 34.0407C134.832 33.6383 134.611 33.2466 134.376 32.8667Z",
    fill: "url(#paint5_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.635 35.3198L142.579 41.5577C142.77 42.0118 142.944 42.4778 143.101 42.9556L136.157 36.7177C135.999 36.2405 135.825 35.7739 135.635 35.3198Z",
    fill: "url(#paint6_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.157 36.7188L143.101 42.9566C143.267 43.4587 143.414 43.9734 143.544 44.4998L136.599 38.262C136.47 37.7355 136.323 37.2209 136.157 36.7188Z",
    fill: "url(#paint7_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.599 38.2622L143.544 44.5001C143.682 45.0664 143.799 45.6472 143.895 46.2404L136.95 40.0026C136.855 39.4093 136.738 38.8286 136.599 38.2622Z",
    fill: "url(#paint8_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 40.0015L143.895 46.2393C144.001 46.9049 144.081 47.5873 144.132 48.2847L137.187 42.0469C137.136 41.3495 137.057 40.6677 136.95 40.0015Z",
    fill: "url(#paint9_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.187 42.0474L144.132 48.2852C144.193 49.1317 144.213 50.0006 144.191 50.8895L137.246 44.6517C137.269 43.7628 137.249 42.8938 137.187 42.0474Z",
    fill: "url(#paint10_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.246 44.6519L144.191 50.8897C144.158 52.1747 144.035 53.5021 143.82 54.8645L136.875 48.6266C137.091 47.2643 137.213 45.9369 137.246 44.6519Z",
    fill: "url(#paint11_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.876 48.625L143.821 54.8628C143.453 57.1908 142.814 59.6211 141.886 62.1212C141.746 62.4967 141.601 62.871 141.451 63.244L134.507 57.0062C134.657 56.6338 134.802 56.2595 134.941 55.8833C135.869 53.3832 136.509 50.953 136.876 48.625Z",
    fill: "url(#paint12_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.507 57.0073L141.452 63.2452C140.862 64.7104 140.191 66.1501 139.448 67.5561L132.503 61.3183C133.246 59.9117 133.917 58.4726 134.507 57.0073Z",
    fill: "url(#paint13_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.503 61.3179L139.448 67.5557C138.964 68.4727 138.449 69.3753 137.906 70.2623L130.961 64.0245C131.505 63.1375 132.019 62.2348 132.503 61.3179Z",
    fill: "url(#paint14_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.961 64.0244L137.906 70.2623C137.451 71.0064 136.975 71.7387 136.481 72.4592L129.537 66.2214C130.031 65.5009 130.506 64.7686 130.961 64.0244Z",
    fill: "url(#paint15_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.537 66.2207L136.481 72.4585C136.038 73.1054 135.58 73.7417 135.108 74.368L128.164 68.1301C128.636 67.5045 129.094 66.8676 129.537 66.2207Z",
    fill: "url(#paint16_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.163 68.1313L135.108 74.3692C134.672 74.9481 134.224 75.5176 133.765 76.0771L126.82 69.8393C127.279 69.2797 127.727 68.7102 128.163 68.1313Z",
    fill: "url(#paint17_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.82 69.8379L133.765 76.0757C133.328 76.6084 132.881 77.133 132.425 77.6477L125.48 71.4098C125.937 70.8952 126.384 70.3706 126.82 69.8379Z",
    fill: "url(#paint18_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.481 71.4106L132.425 77.6485C131.981 78.1506 131.526 78.6434 131.064 79.1269L124.12 72.889C124.582 72.405 125.035 71.9122 125.481 71.4106Z",
    fill: "url(#paint19_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.12 72.8887L131.064 79.1265C130.61 79.6018 130.148 80.0678 129.678 80.5244L122.733 74.2866C123.203 73.83 123.665 73.364 124.12 72.8887Z",
    fill: "url(#paint20_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.734 74.2866L129.679 80.5245C129.212 80.978 128.739 81.4215 128.259 81.8556L121.314 75.6178C121.794 75.1836 122.268 74.7401 122.734 74.2866Z",
    fill: "url(#paint21_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.314 75.6187L128.259 81.8565C127.775 82.2931 127.285 82.7204 126.788 83.1365L119.844 76.8987C120.34 76.482 120.83 76.0553 121.314 75.6187Z",
    fill: "url(#paint22_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.844 76.8979L126.789 83.1358C126.286 83.5575 125.776 83.9679 125.261 84.3671L118.317 78.1293C118.832 77.7307 119.341 77.3196 119.844 76.8979Z",
    fill: "url(#paint23_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.316 78.1289L125.261 84.3668C124.735 84.7741 124.203 85.1702 123.667 85.5532L116.722 79.3153C117.259 78.9317 117.791 78.5362 118.316 78.1289Z",
    fill: "url(#paint24_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.722 79.3169L123.667 85.5547C123.1 85.959 122.529 86.3494 121.952 86.7249L115.007 80.4871C115.584 80.111 116.156 79.7211 116.722 79.3169Z",
    fill: "url(#paint25_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.008 80.4858L121.952 86.7237C121.34 87.1223 120.723 87.504 120.101 87.869L113.157 81.6311C113.779 81.2662 114.396 80.8838 115.008 80.4858Z",
    fill: "url(#paint26_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.157 81.6309L120.102 87.8687C119.424 88.2661 118.742 88.6435 118.055 88.999L111.11 82.7612C111.797 82.4056 112.48 82.0282 113.157 81.6309Z",
    fill: "url(#paint27_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11 82.7617L118.054 88.9996C117.271 89.405 116.482 89.783 115.69 90.1324L108.746 83.8945C109.538 83.5452 110.327 83.1678 111.11 82.7617Z",
    fill: "url(#paint28_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.745 83.8936L115.69 90.1314C114.707 90.5643 113.719 90.9517 112.728 91.2923L105.784 85.0544C106.774 84.7138 107.762 84.3258 108.745 83.8936Z",
    fill: "url(#paint29_linear_10961_47271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.784 85.0557L112.728 91.2935C109.505 92.4001 106.259 93.0014 103.114 93.0014C98.0118 93.0014 93.8231 91.4208 90.759 88.668L83.8145 82.4302C86.8785 85.1823 91.0672 86.7636 96.1691 86.7636C99.3149 86.7636 102.56 86.1623 105.784 85.0557Z",
    fill: "url(#paint30_linear_10961_47271)"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M119.087 25.0039C134.17 25.0039 141.271 38.8264 134.941 55.8819C128.612 72.9374 111.251 86.7598 96.1689 86.7598C81.082 86.7598 73.9852 72.9374 80.3148 55.8819C86.6443 38.8264 104 25.0039 119.087 25.0039ZM117.164 74.4544C120.234 72.0572 123.052 69.1454 125.421 65.9703C127.786 62.7859 129.673 59.3339 130.967 55.8819C132.231 52.4298 132.91 48.9778 132.907 45.7984C132.896 42.619 132.239 39.7065 130.944 37.3093C129.664 34.9077 127.765 33.0114 125.411 31.767C123.239 30.6404 120.7 30.0316 117.945 30.0316C117.703 30.0316 117.461 30.0366 117.216 30.046C116.976 30.0366 116.736 30.0316 116.492 30.0316C113.736 30.0316 110.752 30.6367 107.739 31.767C104.461 33.0114 101.155 34.9077 98.092 37.3093C95.018 39.7065 92.1997 42.6183 89.83 45.7934C87.4658 48.9778 85.5826 52.4298 84.2883 55.8819C83.0201 59.3339 82.3408 62.7859 82.3483 65.9653C82.3552 69.1448 83.0164 72.0572 84.307 74.4544C85.592 76.856 87.4858 78.7523 89.8406 79.9967C92.0164 81.1233 94.552 81.7321 97.3104 81.7321C97.5518 81.7321 97.7951 81.7271 98.0402 81.7178C98.2792 81.7271 98.5199 81.7321 98.7632 81.7321C101.517 81.7321 104.505 81.1277 107.511 80.0017C110.791 78.7523 114.096 76.8566 117.164 74.4544Z",
    fill: "url(#paint31_linear_10961_47271)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M124.422 41.0386L121.318 44.291L116.114 44.3496C116.332 44.9672 116.48 46.2359 116.214 47.7873H115.642C115.778 47.0119 115.809 46.307 115.779 45.7182C115.749 45.13 115.657 44.6584 115.546 44.3496L120.75 44.291L123.853 41.0386H124.422Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M115.09 51.0151C110.587 59.2903 102.515 59.5485 102.091 59.5622L107.541 75.1107H106.969L101.527 59.5622C101.952 59.5485 110.019 59.2903 114.499 51.0538L115.09 51.0151Z",
    fill: "#3F28DD"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M129.124 41C129.148 43.0754 129.071 45.0757 126 45.5404C129.251 45.5 129 47.4974 129.157 50C129.245 47.4974 129.47 45.7021 132 45.5837C129.381 45.1594 129.452 43.9759 129.124 41Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1241 72C85.1478 74.0754 85.0709 76.0757 82 76.5404C85.2512 76.5 85 78.4974 85.1567 81C85.2453 78.4974 85.4699 76.7021 88 76.5837C85.3813 76.1594 85.4522 74.9759 85.1241 72Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1241 68C74.1478 70.0754 74.0709 72.0757 71 72.5404C74.2512 72.5 74 74.4974 74.1567 77C74.2453 74.4974 74.4699 72.7021 77 72.5837C74.3813 72.1594 74.4522 70.9759 74.1241 68Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.6877 269.71L1.23579 281.376L-24.3779 267.969L-29.8658 239.585L-11.0953 217.596L17.7989 218.562L35.0589 241.755L27.6877 269.71Z",
    fill: "url(#paint32_linear_10961_47271)",
    fillOpacity: 0.6
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M226.865 51.7981L190.138 56.2423L163.765 30.2989L167.605 -6.49615L198.766 -26.4355L233.784 -14.5044L246.29 20.3128L226.865 51.7981Z",
    fill: "url(#paint33_linear_10961_47271)",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10961_47271",
    x: 0,
    y: 0,
    width: 208,
    height: 308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10961_47271"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10961_47271",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10961_47271",
    x: 45,
    y: 61,
    width: 119,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_10961_47271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10961_47271",
    x1: 99.7818,
    y1: 30.0303,
    x2: 99.7818,
    y2: 81.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#432A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C267F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10961_47271",
    x1: 122.957,
    y1: 24.5896,
    x2: 93.9514,
    y2: 83.8491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494401,
    stopColor: "#85E6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4163B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10961_47271",
    x1: 136.701,
    y1: 30.7437,
    x2: 136.567,
    y2: 36.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10961_47271",
    x1: 135.839,
    y1: 29.7856,
    x2: 135.71,
    y2: 35.3085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10961_47271",
    x1: 137.479,
    y1: 31.7686,
    x2: 137.341,
    y2: 37.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10961_47271",
    x1: 138.18,
    y1: 32.8667,
    x2: 138.038,
    y2: 38.5543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10961_47271",
    x1: 139.368,
    y1: 35.3198,
    x2: 139.215,
    y2: 41.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10961_47271",
    x1: 139.85,
    y1: 36.7188,
    x2: 139.689,
    y2: 42.6891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10961_47271",
    x1: 140.247,
    y1: 38.2622,
    x2: 140.076,
    y2: 44.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10961_47271",
    x1: 140.541,
    y1: 40.0015,
    x2: 140.353,
    y2: 46.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10961_47271",
    x1: 140.693,
    y1: 42.0474,
    x2: 140.474,
    y2: 48.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10961_47271",
    x1: 140.533,
    y1: 44.6519,
    x2: 140.253,
    y2: 52.4836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3CC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10961_47271",
    x1: 136.678,
    y1: 52.3739,
    x2: 142.696,
    y2: 57.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5435AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10961_47271",
    x1: 134.045,
    y1: 58.3929,
    x2: 141.191,
    y2: 64.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B39BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5334AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10961_47271",
    x1: 135.205,
    y1: 61.3179,
    x2: 135.205,
    y2: 70.2623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10961_47271",
    x1: 133.721,
    y1: 64.0244,
    x2: 133.721,
    y2: 72.4592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10961_47271",
    x1: 132.322,
    y1: 66.2207,
    x2: 132.322,
    y2: 74.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10961_47271",
    x1: 130.964,
    y1: 68.1313,
    x2: 130.964,
    y2: 76.0771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10961_47271",
    x1: 129.623,
    y1: 69.8379,
    x2: 129.623,
    y2: 77.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10961_47271",
    x1: 128.272,
    y1: 71.4106,
    x2: 128.272,
    y2: 79.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C309F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10961_47271",
    x1: 123.513,
    y1: 73.4382,
    x2: 130.283,
    y2: 79.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10961_47271",
    x1: 125.497,
    y1: 74.2866,
    x2: 125.497,
    y2: 81.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10961_47271",
    x1: 124.051,
    y1: 75.6187,
    x2: 124.051,
    y2: 83.1365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10961_47271",
    x1: 122.553,
    y1: 76.8979,
    x2: 122.553,
    y2: 84.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10961_47271",
    x1: 120.991,
    y1: 78.1289,
    x2: 120.991,
    y2: 85.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10961_47271",
    x1: 119.337,
    y1: 79.3169,
    x2: 119.337,
    y2: 86.7249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10961_47271",
    x1: 117.554,
    y1: 80.4858,
    x2: 117.554,
    y2: 87.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10961_47271",
    x1: 115.606,
    y1: 81.6309,
    x2: 115.606,
    y2: 88.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10961_47271",
    x1: 113.4,
    y1: 82.7617,
    x2: 113.4,
    y2: 90.1324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10961_47271",
    x1: 110.737,
    y1: 83.8936,
    x2: 110.737,
    y2: 91.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10961_47271",
    x1: 98.2713,
    y1: 82.4302,
    x2: 98.2713,
    y2: 93.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D44E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C267F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10961_47271",
    x1: 125.938,
    y1: 17.3924,
    x2: 75.3365,
    y2: 94.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D44E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609849,
    stopColor: "#85E6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D44E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10961_47271",
    x1: 27.6877,
    y1: 269.71,
    x2: -22.9899,
    y2: 226.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FEDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10961_47271",
    x1: 226.865,
    y1: 51.7981,
    x2: 180.91,
    y2: -20.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FEDE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10961_47271"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 200,
    height: 300,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferalCard);
export default __webpack_public_path__ + "static/media/referal_card.15fab5c052ccad90a0eb823e3d216c6c.svg";
export { ForwardRef as ReactComponent };